<div class="container-xxl flex-grow-1 " style="text-align: justify;">
  <div class="row g-6">
    <!-- Source Visit -->
    <div class="col-xxl-12 col-xl-12 col-lg-12">
      <div class="card h-100 mt-5">
        <div class="card-header justify-content-between cif-section borderbtmtitle mb-5 pb-0">
          <a class="navbar-liand d-flex align-items-center" href="javascript:void(0)"><span class="custom-logo">
            <img src="../../../assets/images/new-table/Logowhite.png" alt="Tata Motors Commercial Vehicles"
              class="d-inline-block" style=" height: 65px; width: 265px; " />
            &nbsp;
          </span>
        &nbsp;</a>
        <!-- <span class="navbar-text ms-2">FleetCare</span></a> -->
        <div class="card-title mb-0">
          <h5 class="" style="text-align: left;">Customer Information Form</h5>
          <!-- <p class="card-subtitle">38.4k Visitors</p> -->
        </div>
      </div>
      <div class="card-body">
        @if (isError && shoMsg == '') {
          <div class="row">
            <div class="col-12 col-md-12">
              <h4 class="infotitles error-message" style="padding-left: 50px;">Invaild Token </h4>
            </div>
          </div>
        }
        @if (shoMsg !== '') {
          <div class="row mb-5">
            <div class="col-12 col-md-12">
              <h4 class="infotitles success-message" style="padding-left: 50px;">{{ shoMsg }}</h4>
            </div>
          </div>
        }

        @if (showOtp && !isError) {
          <div class="row">
            <div class="col-12 col-md-12 userinfo">
              <div class=" text-top-align2">
                <h4 class="infotitletop">Customer Name: <span>{{ customerFullName }}</span></h4>
              </div>
              <div class="">
                <h4 class="infotitletop">Customer Code: <span>{{ cifDetails?.customer_details.sap_customer_code
                }}</span>
              </h4>
            </div>
            <div class=" text-top-align1">
              <h4 class="infotitletop">Order Number: <span>{{ cifDetails?.customer_details.vas_order_number }}</span>
            </h4>
          </div>
        </div>
      </div>
    }
    <!--otp screens [s]-->
    @if (showOtp && !isError) {
      <div class="row otpdiv">
        <div class="col-12 col-md-12">
          <div>
            <hr />
          </div>
          <h5 style="text-align: left;">To proceed with Digital CIF Acceptance kindly request the OTP </h5>
          <div class="txtinputdiv">
            <h6>Enter OTP received on Mobile No: <span style="font-weight: 600;">{{
              maskMobile(cifDetails?.customer_details.customer_mobile_number)
            }}</span>
            <!-- / Email ID : <span style="font-weight: 600;">{{ maskEmail(cifDetails?.customer_details.customer_email)}}</span> -->
          </h6>
          <fieldset [disabled]="disableOtp" class="otp-fieldset">
            <ng-otp-input (onInputChange)="onOtpChange($event)"
              [config]="{ length: 6, allowNumbersOnly: true, inputClass: 'otp-input' }">
            </ng-otp-input>
          </fieldset>
        </div>
        <!-- <div style="margin-top: 10px;margin-bottom: 10px;">
        <app-google-captcha (captchaResolved)="onCaptchaResolved($event)"></app-google-captcha>
      </div> -->
      <div class="d-flex mt-3">
        @if (!resendBtn) {
          <div>
            <button class="btn-t01 btn-navy" (click)="generateOTP()">Send OTP</button>
          </div>
        }
        <!--   -->
        @if (resendBtn) {
          <div class="otp-wrapper">
            <div class="d-flex ">
              <button class="btn-t01 btn-navy" (click)="verifyOTP()">Verify OTP</button>
              <button class="btn-t01 btn-navy mx-3" (click)="resendOTP()"
              [disabled]="!isResendEnabled">Resend</button>
            </div>
            @if (isTimerVisible) {
              <div class="otp-timer">
                <span class="txtblue">You can resend the OTP in</span>
                <span class="clocktxt">
                  &nbsp;<img src="../../../assets/images/new-table/clock1.png">
                  <span>{{ getFormattedTime() }}</span>
                </span>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
  }<br />
  <!--otp screens [e]-->

  <!-- CIF verification s -->
  @if (!showOtp && !isError) {
    <div>
      @if (hideAllCode) {
        <div class="mb-5">
          <!-- TMCVL verification e -->
          <!-- Customer Details s -->
          <div class="row">
            <div class="col-12 col-md-12">
              <h4 class="infotitle">Customer Details</h4>
            </div>
            <div class="col-6 col-md-3">
              <div>
                <div class="me-2 textlabel">
                  <label class="mb-0 txt1">Customer Name</label>
                  <p class="paradata">{{ customerFullName }}</p>
                </div>
              </div>
            </div>
            @if (
              cifDetails?.customer_details?.customer_category === 'account'
              ) {
              <div class="col-6 col-md-3">
                <div>
                  <div class="me-2 textlabel">
                    <label class="mb-0 txt1">Company Name</label>
                    <p class="paradata">
                      {{ cifDetails?.customer_details.company_name }}
                    </p>
                  </div>
                </div>
              </div>
            }
            <div class="col-6 col-md-3">
              <div>
                <div class="me-2 textlabel">
                  <label class="mb-0 txt1">Customer Code</label>
                  <p class="paradata">
                    {{ cifDetails?.customer_details.sap_customer_code }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div>
                <div class="me-2 textlabel">
                  <label class="mb-0 txt1">{{cifDetails?.order_details?.is_group_order?'Group':'VAS'}} Order
                  Number</label>
                  <p class="paradata">
                    {{ cifDetails?.customer_details.vas_order_number }}
                  </p>
                </div>
              </div>
            </div>
            <!-- <div class="col-6 col-md-3">
            <div>
              <div class="me-2 textlabel">
                <label class="mb-0 txt1">Enquiry Ref. No.</label>
                <p class="paradata">
                  {{ cifDetails?.customer_details.opty_id }}
                </p>
              </div>
            </div>
          </div> -->
          <div class="col-12 col-md-3">
            <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
              <div class="textlabel">
                <h6 class="mb-0 txt1">Address</h6>
                <address class="text-body txt2">
                  {{
                  (cifDetails?.customer_details
                  ?.customer_address_line_1 || "") +
                  (cifDetails?.customer_details?.customer_address_line_2
                  ? (cifDetails?.customer_details
                  ?.customer_address_line_1
                  ? ", "
                  : "") +
                  cifDetails?.customer_details
                  ?.customer_address_line_2
                  : "") +
                  (cifDetails?.customer_details?.customer_pincode
                  ? (cifDetails?.customer_details
                  ?.customer_address_line_1 ||
                  cifDetails?.customer_details
                  ?.customer_address_line_2
                  ? ", "
                  : "") +
                  cifDetails?.customer_details?.customer_pincode
                  : "") || "-"
                  }}
                </address>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div>
              <div class="me-2 textlabel">
                <label class="mb-0 txt1">Email</label>
                <p class="paradata">
                  {{ cifDetails?.customer_details.customer_email }}
                </p>
              </div>
              <div class="me-2 textlabel">
                <label class="mb-0 txt1">Contact</label>
                <p class="paradata">
                  {{ cifDetails?.customer_details.customer_mobile_number }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div>
              @if (cifDetails?.customer_details.customer_pan_number) {
                <div class="me-2 textlabel">
                  <label class="mb-0 txt1">PAN</label>
                  <p class="paradata">
                    {{ cifDetails?.customer_details.customer_pan_number }}
                  </p>
                </div>
              }
              @if (cifDetails?.customer_details.customer_gstin_number) {
                <div class="me-2 textlabel">
                  <label class="mb-0 txt1">GSTIN</label>
                  <p class="paradata">
                    {{ cifDetails?.customer_details.customer_gstin_number }}
                  </p>
                </div>
              }
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div>
              <div class="me-2 textlabel">
                <label class="mb-0 txt1">TAN</label>
                <p class="paradata">
                  {{
                  cifDetails?.customer_details.customer_tan_number
                  ? cifDetails?.customer_details.customer_tan_number
                  : "-"
                  }}
                </p>
              </div>
              <div>
                <div class="me-2 textlabel">
                  <label class="mb-0 txt1">Documents Submitted</label>
                  <p class="paradata">{{ documentsSubmitted }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-12">
            <hr />
          </div>
        </div>
        <!-- Customer Details e -->
        <p><strong>Note:</strong> Please read carefully the attached general terms and conditions before
        signing/executing the CIF.
        The CIF and the general terms and conditions shall jointly constitute a binding agreement
        between you and Tata Motors Commercial Vehicles Ltd. <strong>("Tata Motors Commercial
      Vehicles").</strong></p>
      <!-- Vehicle Details s -->
      <div class="row mb-5">
        <div class="col-12 col-md-12">
          <h4 class="infotitle">Vehicle Specification</h4>
        </div>
        <div class="col-12 col-md-3">
          <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
            <div class="textlabel">
              <h6 class="mb-0 txt1">Model</h6>
              <small class="text-body txt2">{{
                cifDetails?.vehicle_details?.pl || "-"
              }}</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-3">
          <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
            <div class="textlabel">
              <h6 class="mb-0 txt1">VC Number</h6>
              <small class="text-body txt2">{{
                cifDetails?.vehicle_details?.vc_number || "-"
              }}</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-3">
          <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
            <div class="textlabel">
              <h6 class="mb-0 txt1">Fuel Type/BS Norms</h6>
              <small class="text-body txt2">{{
                cifDetails?.vehicle_details?.fuel_type
                }} - {{
                cifDetails?.vehicle_details?.bs_norm
              }}</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-3">
          <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
            <div class="textlabel">
              <h6 class="mb-0 txt1">No. of vehicles</h6>
              <small class="text-body txt2">{{cifDetails?.customer_details?.quantity }}</small>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-5 d-none">
        <div class="col-12 col-md-3">
          <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
            <div class="textlabel">
              <h6 class="mb-0 txt1">Chassis Number</h6>
              <!-- <small class="text-body txt2">{{
              cifDetails?.vehicle_details?.chassis_number || "-"
            }}</small> -->
            <small class="text-body txt2"> Refer Annexure 1 </small>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-3">
        <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
          <div class="textlabel">
            <h6 class="mb-0 txt1">Registration Number</h6>
            <!-- <small class="text-body txt2">{{
            cifDetails?.vehicle_details?.registration_number || "-"
          }}</small> -->
          <small class="text-body txt2"> Refer Annexure 1 </small>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-3">
      <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
        <div class="textlabel">
          <h6 class="mb-0 txt1">Vehicle Sale Date</h6>
          <!-- <small class="text-body txt2">
          {{
          cifDetails?.contract_summary?.sale_date
          ? (cifDetails.contract_summary.sale_date
          | date : "dd-MMM-yy")
          : "-"
        }}</small> -->
        <small class="text-body txt2"> Refer Annexure 1 </small>
      </div>
    </div>
  </div>
</div>
<div class="col-12 col-md-12">
  <hr />
</div>
<!-- Vehicle Details e -->
<!-- AMC Details s -->
<div class="row mb-5">
  <div class="col-12 col-md-12">
    <h4 class="infotitle">Contract Details</h4>
  </div>
  <div class="col-12 col-md-3">
    <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
      <div class="textlabel">
        <h6 class="mb-0 txt1">Service Product Type</h6>
        <small class="text-body txt2">{{
          cifDetails?.amc_details?.service_product_type || "-"
        }}</small>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-3">
    <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
      <div class="textlabel">
        <h6 class="mb-0 txt1">Service Category</h6>
        <small class="text-body txt2">{{
          cifDetails?.amc_details?.product_type || "-"
        }}</small>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-3">
    <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
      <div class="textlabel">
        <h6 class="mb-0 txt1">Application</h6>
        <small class="text-body txt2">
          {{ cifDetails?.vehicle_details?.application || "-" }}
        </small>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-3">
    <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
      <div class="textlabel">
        <h6 class="mb-0 txt1">Terrain</h6>
        <small class="text-body txt2">
          {{ cifDetails?.vehicle_details?.terrain || "-" }}
        </small>
      </div>
    </div>
  </div>
</div>
<div class="row mb-5 ">
  <!-- <div class="col-12 col-md-3">
  <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
    <div class="textlabel">
      <h6 class="mb-0 txt1">Contract No.</h6>
      <small class="text-body txt2"> Refer Annexure 1 </small>
    </div>
  </div>
</div> -->
<!-- <div class="col-12 col-md-3">
<div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
  <div class="textlabel">
    <h6 class="mb-0 txt1">Contract Duration(Months)</h6>
    <small class="text-body txt2">
      {{
      cifDetails?.contract_summary?.tenure_months !== null
      ? cifDetails.contract_summary.tenure_months
      : "-"
    }}</small>
  </div>
</div>
</div>
<div class="col-12 col-md-3">
  <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
    <div class="textlabel">
      <h6 class="mb-0 txt1">Annual Running {{showFormattext}}</h6>
      <small class="text-body txt2">
        {{
        (cifDetails?.contract_summary?.annual_running) !== null
        ? (cifDetails.contract_summary.annual_running | number : "1.0-0")
        : "-"
      }}</small>
    </div>
  </div>
</div> -->
<div class="col-12 col-md-6">
  <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
    <div class="textlabel">
      <h6 class="mb-0 txt1">Contract Validity</h6>
      <small class="text-body txt2">
        <b>{{
          cifDetails?.contract_summary?.validity_kms !== null
          ? cifDetails.contract_summary.validity_kms
          : "-"
        }}</b>
        {{showFormattext}} or
        <b>{{ cifDetails?.contract_summary?.year_and_month }}</b>
        , whichever is earlier
      </small>
    </div>
  </div>
</div>
</div>
<div>
  <p><strong>Note:</strong> The details of the vehicle(s) covered and contract details are provided in
Annexure 1.</p>
</div>
<div class="row mb-5 d-none">
  <div class="col-12 col-md-3">
    <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
      <div class="textlabel">
        <h6 class="mb-0 txt1">Start Date</h6>
        <!-- <small class="text-body txt2">
        {{
        cifDetails?.contract_summary?.start_date
        ? (cifDetails.contract_summary.start_date
        | date : "dd-MMM-yy")
        : "-"
        }}
      </small> -->
      <small class="text-body txt2"> Refer Annexure 1 </small>
    </div>
  </div>
</div>
<div class="col-12 col-md-3">
  <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
    <div class="textlabel">
      <h6 class="mb-0 txt1">End Date</h6>
      <!-- <small class="text-body txt2">
      {{
      cifDetails?.contract_summary?.end_date
      ? (cifDetails.contract_summary.end_date
      | date : "dd-MMM-yy")
      : "-"
    }}</small> -->
    <small class="text-body txt2"> Refer Annexure 1 </small>
  </div>
</div>
</div>
<div class="col-12 col-md-3">
  <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
    <div class="textlabel">
      <h6 class="mb-0 txt1">
        Start {{showFormattext}}
      </h6>
      <!-- <small class="text-body txt2">
      {{
      cifDetails?.contract_summary?.start_kms_or_hrs !== null
      ? cifDetails.contract_summary.start_kms_or_hrs
      : "-"
      }}
    </small> -->
    <small class="text-body txt2"> Refer Annexure 1 </small>
  </div>
</div>
</div>
<div class="col-12 col-md-3">
  <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
    <div class="textlabel">
      <h6 class="mb-0 txt1">
        End {{showFormattext}}
      </h6>
      <!-- <small class="text-body txt2">
      {{
      cifDetails?.contract_summary?.end_kms_or_hrs !== null
      ? cifDetails.contract_summary.end_kms_or_hrs
      : "-"
      }}
    </small> -->
    <small class="text-body txt2"> Refer Annexure 1 </small>
  </div>
</div>
</div>
</div>
<div class="col-12 col-md-12">
  <hr />
</div>
<!-- AMC details e -->
<!-- Contract Summary s -->
<div class="row">
  <div class="col-12 col-md-12">
    <h4 class="infotitle">Price Details</h4>
  </div>
  <div class="row">
    <div class="table-responsive text-nowrap table-paymentcustm fixed-table">
      <table class="table table-bordered">
        <thead class="table-header">
          <tr class="table-primary">
            <th>Base Product Price<br><span>(Per Vehicle)</span></th>
            @if (cifDetails?.amc_details?.cgst_amount > 0) {
              <th>CGST<br><span>(9%)</span></th>
            }
            @if (cifDetails?.amc_details?.ugst_amount > 0) {
              <th>UTGST<br><span>(9%)</span></th>
            }
            @if (cifDetails?.amc_details?.sgst_amount > 0) {
              <th>SGST<br><span>(9%)</span></th>
            }
            @if (cifDetails?.amc_details?.igst_amount > 0) {
              <th>IGST<br><span>(18%)</span></th>
            }
            <th>TDS <br><span> (2%)</span></th>
            <th>Amt Payable Per Vehicle<br><span>(Inclusive Taxes)</span></th>
            <th><span style="text-transform:none"><strong>No. of vehicles </strong></span></th>
            <th>Total Amount Payable<br> <span>(Inclusive Taxes)
            </span></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              ₹ {{
              cifDetails?.amc_details?.net_payable_amount
              | number : "1.2-2"
              }}
            </td>
            <!-- 1-->
            @if (cifDetails?.amc_details?.cgst_amount > 0) {
              <td>
                ₹ {{
                cifDetails?.amc_details?.cgst_amount
                | number : "1.2-2"
                }}
              </td>
            }
            @if (cifDetails?.amc_details?.ugst_amount > 0) {
              <td>
                ₹ {{
                cifDetails?.amc_details?.ugst_amount
                | number : "1.2-2"
                }}
              </td>
            }
            <!-- 2-->
            @if (cifDetails?.amc_details?.sgst_amount > 0) {
              <td>
                ₹ {{
                cifDetails?.amc_details?.sgst_amount
                | number : "1.2-2"
                }}
              </td>
            }
            @if (cifDetails?.amc_details?.igst_amount > 0) {
              <td>
                ₹ {{
                cifDetails?.amc_details?.igst_amount
                | number : "1.2-2"
                }}
              </td>
            }
            <td>
              @if (cifDetails?.customer_details?.opted_for_tds==false) {
                <span>
                  -
                </span>
              }
              @if (cifDetails?.customer_details?.opted_for_tds) {
                <span>
                  ₹ {{
                  cifDetails?.amc_details?.tds_amount
                  | number : "1.2-2"
                  }}
                </span>
              }
            </td>
            <td>
              <!-- 3-->
              ₹ {{
              cifDetails?.amc_details?.total_amount_per_vehicle
              | number : "1.2-2"
              }}
            </td>
            <td>{{cifDetails?.customer_details?.quantity}}</td>
            <td>
              <!-- 4-->
              ₹
              {{
              cifDetails?.amc_details?.total_amount
              | number : "1.2-2"
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="col-12 col-md-12">
    <hr />
  </div>
</div>
<!-- Payment Details s -->
<div class="row mt-4">
  <div class="col-12 col-md-12">
    <h4 class="infotitle">Payment Details</h4>
  </div>
  <!-- Payment plan s -->
  <div class="row mt-4">
    <div class="table-responsive text-nowrap table-paymentcustm fixed-table">
      <table class="table table-bordered">
        <thead class="table-header">
          <tr class="table-primary">
            <th>Receipt No</th>
            <th>Receipt Date</th>
            <th>Payment Mode</th>
            <th>Payment Method</th>
            <th>Payment Type</th>
            <!-- 1-->
            <th>Instrument No/Transaction ID</th>
            <!-- 2-->
            <th>Instrument/Payment Date</th>
            <th>Bank </th>
            <!--3-->
            <th>Amount (₹)</th>
            <!-- 4-->
          </tr>
        </thead>
        <tbody>
          @for (res of cifDetails?.realized_payments; track res?.id ?? $index) {
            <tr>
              <td>
                {{
                cifDetails?.payment_details?.receipt_number
                }}
              </td>
              <td>
                {{ cifDetails?.payment_details?.receipt_date ? (cifDetails.payment_details.receipt_date |
                date:'dd-MMM-yy') : '-' }}
              </td>
              <td>{{ cifDetails?.payment_details?.payment_mode || "-" }}</td>
              <td>{{ res?.payment_method_name }}</td>
              <td>{{ res?.payment_stage_name }}</td>
              <!-- 1-->
              <td>{{ res?.instrument_number ??
              '-' }}</td>
              <!-- 2-->
              <td>{{ res?.instrument_payment_date | date:"dd-MMM-yy" }}</td>
              <td>{{ res?.bank_name ?
              res?.bank_name : "-" }}</td>
              <td>
                <!-- 4-->
                {{ res?.amount | number : "1.2-2" }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  <div class="col-12 col-md-12">
    <hr />
  </div>
</div>
<div class="row">
  <div class="col-12 col-md-12">
    <h4 class="infotitle">EMI Details</h4>
  </div>
  <div class="row">
    <div class="table-responsive text-nowrap table-paymentcustm fixed-table">
      <table class="table table-bordered">
        <thead class="table-header">
          <tr class="table-primary">
            <th>Instalment Type</th>
            <th>No. of Instalments</th>
            <th>Per Instalment Amount (₹)</th>
            <th>No. of Vehicles</th>
            <th>Total Instalment Value (₹)</th>
            <!-- <th>Start Date</th>
            <th>End Date</th> -->
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {{
              cifDetails?.payment_details?.payment_mode === 'EMI'
              ? cifDetails?.payment_details?.emi_frequency
              : 'NA'
              }}
            </td>
            <td>
              {{
              cifDetails?.payment_details?.payment_mode === 'EMI'
              ? cifDetails?.payment_details?.total_number_of_emi
              : 'NA'
              }}
            </td>
            <td>
              {{
              cifDetails?.payment_details?.payment_mode === 'EMI'
              ? (cifDetails?.payment_details?.emi_amount | number : "1.2-2")
              : 'NA'
              }}
            </td>
            <td>
              {{
              cifDetails?.payment_details?.payment_mode === 'EMI'
              ? cifDetails?.customer_details?.quantity
              : 'NA'
              }}
            </td>
            <td>
              {{
              cifDetails?.payment_details?.payment_mode === 'EMI'
              ? (cifDetails?.payment_details?.total_installment_amount | number : "1.2-2")
              : 'NA'
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <br />
  </div>
</div>
<!-- Payment plan e -->
<!-- Payment Details e -->
<!-- dealer deatil s -->
<div class="row mt-4">
  <div class="col-12 col-md-12">
    <h4 class="infotitle">Dealer Details</h4>
  </div>
  <div class="row mb-5">
    <div class="col-12 col-md-3">
      <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
        <div class="textlabel">
          <h6 class="mb-0 txt1">Firm Name</h6>
          <small class="text-body txt2">{{
            cifDetails?.division_data?.org_name || "-"
          }}</small>
        </div>
      </div>
    </div>
    <!-- <div class="col-12 col-md-3">
    <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
      <div class="textlabel">
        <h6 class="mb-0 txt1">Dealer Code</h6>
        <small class="text-body txt2">{{
          cifDetails?.division_data?.dealer_code || "-"
        }}</small>
      </div>
    </div>
  </div> -->
  <div class="col-12 col-md-3">
    <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
      <div class="textlabel">
        <h6 class="mb-0 txt1">Contact</h6>
        <small class="text-body txt2">{{
          cifDetails?.division_data?.division_main_phone_number ||
          "-"
        }}</small>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-3">
    <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
      <div class="textlabel">
        <h6 class="mb-0 txt1">Email</h6>
        <small class="text-body txt2">{{
          cifDetails?.division_data?.division_email || "-"
        }}</small>
      </div>
    </div>
  </div>
</div>
<div class="row mb-5">
  <div class="col-12 col-md-3">
    <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
      <div class="textlabel">
        <h6 class="mb-0 txt1">DSE Name</h6>
        <small class="text-body txt2">{{
          (cifDetails?.dse_data?.first_name || "") +
          " " +
          (cifDetails?.dse_data?.last_name || "-")
        }}</small>
      </div>
    </div>
  </div>
  <!-- <div class="col-12 col-md-3">
  <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
    <div class="textlabel">
      <h6 class="mb-0 txt1">CRM Id</h6>
      <small class="text-body txt2">{{
        cifDetails?.dse_data?.login_name || "-"
      }}</small>
    </div>
  </div>
</div> -->
<div class="col-12 col-md-3">
  <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
    <div class="textlabel">
      <h6 class="mb-0 txt1">Contact</h6>
      <small class="text-body txt2">{{
        cifDetails?.dse_data?.cell_number || "-"
      }}</small>
    </div>
  </div>
</div>
<div class="col-12 col-md-3">
  <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
    <div class="textlabel">
      <h6 class="mb-0 txt1">Email</h6>
      <small class="text-body txt2">{{
        cifDetails?.dse_data?.email || "-"
      }}</small>
    </div>
  </div>
</div>
</div>
<div class="row mb-5">
  <div class="col-12 col-md-3">
    <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
      <div class="textlabel">
        <h6 class="mb-0 txt1">DSM Name</h6>
        <small class="text-body txt2">{{
          (
          (cifDetails?.dsm_data?.first_name || "") +
          " " +
          (cifDetails?.dsm_data?.last_name || "")
          ).trim() || "-"
        }}</small>
      </div>
    </div>
  </div>
  <!-- <div class="col-12 col-md-3">
  <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
    <div class="textlabel">
      <h6 class="mb-0 txt1">CRM Id</h6>
      <small class="text-body txt2">{{
        cifDetails?.dsm_data?.login_name || "-"
      }}</small>
    </div>
  </div>
</div> -->
<div class="col-12 col-md-3">
  <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
    <div class="textlabel">
      <h6 class="mb-0 txt1">Contact</h6>
      <small class="text-body txt2">{{
        cifDetails?.dsm_data?.cell_number || "-"
      }}</small>
    </div>
  </div>
</div>
<div class="col-12 col-md-3">
  <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
    <div class="textlabel">
      <h6 class="mb-0 txt1">Email</h6>
      <small class="text-body txt2">{{
        cifDetails?.dsm_data?.email || "-"
      }}</small>
    </div>
  </div>
</div>
</div>
<!-- dealer deatil s -->
<!-- Executive Details s -->
<div class="row mb-5">
  <div class="col-12 col-md-3">
    <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
      <div class="textlabel">
        <h6 class="mb-0 txt1">Booking Executive Name</h6>
        <small class="text-body txt2">{{
          (
          (cifDetails?.booking_executive_data?.first_name || "") +
          " " +
          (cifDetails?.booking_executive_data?.last_name || "")
          ).trim() || "-"
        }}</small>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-3">
    <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
      <div class="textlabel">
        <h6 class="mb-0 txt1">Contact</h6>
        <small class="text-body txt2">{{
          cifDetails?.booking_executive_data?.cell_number || "-"
        }}</small>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-6">
    <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
      <div class="textlabel">
        <h6 class="mb-0 txt1">Email</h6>
        <small class="text-body txt2">{{
          cifDetails?.booking_executive_data?.email || "-"
        }}</small>
      </div>
    </div>
  </div>
</div>
<div class="col-12 col-md-12">
  <hr />
</div>
<div class="row">
  <div class="col-12 col-md-12">
    <h4 class="infotitle">Seller Details
    </h4>
  </div>
  <div class="row mb-5">
    <div class="col-12 col-md-3">
      <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
        <div class="textlabel">
          <h6 class="mb-0 txt1">Name</h6>
          <small class="text-body txt2">{{
            cifDetails?.seller_details?.name || ""
          }}</small>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-3">
      <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
        <div class="textlabel">
          <h6 class="mb-0 txt1">PAN</h6>
          <small class="text-body txt2">{{
            cifDetails?.seller_details?.pan || "-"
          }}</small>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-3">
      <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
        <div class="textlabel">
          <h6 class="mb-0 txt1">State</h6>
          <small class="text-body txt2">{{
            cifDetails?.seller_details?.state || "-"
          }}</small>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-3">
      <div class="justify-content-between w-100 flex-wrap gap-2 d-block-xs">
        <div class="textlabel">
          <h6 class="mb-0 txt1">GSTIN</h6>
          <small class="text-body txt2">{{
            cifDetails?.seller_details?.gstin || "-"
          }}</small>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-12">
    <hr />
  </div>
</div>
<div class="row">
  <div class="col-12 col-md-12 d-none">
    @if (!cifDetails?.customer_details.customer_gstin_number) {
      <p>
        I/We confirm that I/We are not registered under GST. I/We understand that all the invoices
      pertaining to this contract will not bear GSTIN.</p>
    }
    @if (cifDetails?.customer_details.customer_gstin_number) {
      <p>
        I/We confirm that our GSTIN is <span
      style="font-weight:bold;color: #000;">{{cifDetails?.customer_details.customer_gstin_number}}</span>.
    I/We understand that all the invoices pertaining to this contract will bear this GSTIN.</p>
  }
  <p>
    I/We hereby confirm that payments under this contract shall be subject to deduction of TDS, if
    applicable, and the said TDS shall be deposited to the credit of the central government in favour
    of Tata Motors Commercial Vehicles Limited (PAN- AAACT2727Q). Accordingly, TDS Certificates shall
    be issued within the
  time limits as per the applicable regulation /guidelines under the Income-tax Act, 1961.</p>
  @if (cifDetails?.payment_details?.payment_made_to === 'DEALER') {
    <p>
      <strong span style="font-weight:bold;color: #000;">For Dealer: </strong><br>
      We have received the payment of INR <span
      style="font-weight:bold;color: #000;">{{cifDetails?.payment_details?.total_booking_amount |
    number : "1.2-2"}}</span>
    from our Customer <span style="font-weight:bold;color: #000;">{{customerFullName}}</span> on
    behalf of M/s. Tata Motors Commercial Vehicles Limited, towards purchase of Services as described
    in this CIF. We
    undertake to transfer this amount to TMCVL by mode of settlement as agreed with TMCVL. We request
    M/s.
    Tata Motors Commercial Vehicles Limited to transfer the above said amount by debiting any of our
    Payer Codes and
    credit to customer code <span style="font-weight:bold;color: #000;">{{
  cifDetails?.customer_details.sap_customer_code }}</span> for generating <span
style="font-weight:bold;color: #000;">{{cifDetails?.amc_details?.service_product_type}}</span>
Invoice on Customer <span style="font-weight:bold;color: #000;">{{customerFullName}}</span> .
</p>
}
</div>
<div class="col-12 col-md-12 ">
  <h5><strong>Please read the below terms carefully:</strong></h5>
  <div style="padding-left:15px;">
    <ol class="pl-3 mb-2">
      <li>Customer shall be required to pay the entire amount as displayed above, including taxes
      before signing/executing the CIF.</li>
      <li>The telematics system of Tata Motors Commercial Vehicles, if installed in your vehicle(s)
        will collect data
        related to the vehicle(s), and shall be stored in the database of Tata Motors Commercial
        Vehicles. By
        signing/executing the CIF, you acknowledge that you have no objection
      nor shall raise any in future as regards the said data collection.</li>
      <li>By signing/executing the CIF, you hereby unconditionally consent and authorize Tata Motors
        Commercial Vehicles
        to collect your personal data and any data related to your vehicle(s). Tata Motors Commercial
        Vehicles shall be
        authorized to use all the data disclosed by you,
        and to share all your personal information/ details and documents for promotional, marketing
        activities of Tata Motors Commercial Vehicles or any of its group companies/ subsidiaries/
        authorized dealers, in
        accordance with the <a href="https://fleetverse.tatamotors.com/privacy-policy" target="_blank"
      rel="noopener noreferrer">privacy policy</a> of Tata
      Motors <strong>("https://fleetverse.tatamotors.com/privacy-policy")</strong>. You shall inform
      in writing to Tata Motors Commercial Vehicles in
      terms of the Privacy
    Policy, if you would intend to withdraw your consent/ authorization ever in future.</li>
    <li>The services shall be provided to you strictly as per the selections made by you in the CIF.
      However, you shall have the option to upgrade and/or opt for additional services by
    signing/executing another CIF.</li>
    <li>By signing/executing the CIF, you acknowledge of having carefully read the general terms and
    conditions attached with the CIF.</li>
    <li>The invoice, once generated, shall not be cancelled, and the amounts received shall be
    non-refundable in any circumstances, whatsoever.</li>
    <li>The services being offered herein are intended for the end-user consumption only and not
    otherwise.</li>
  </ol>
</div>
<h5><strong>Please click/select as may be applicable:</strong></h5>
<p>
  <input type="checkbox" id="gstNotRegistered" name="gstNotRegistered"
    [disabled]="cifDetails?.customer_details?.customer_gstin_number" [(ngModel)]="gstNotRegistered"
    #gstNotRegisteredRef (change)="onGSTSelection('notRegistered')" />
  <label for="gstNotRegistered"
    [ngStyle]="cifDetails?.customer_details?.customer_gstin_number ? {'cursor': 'not-allowed'} : {}">
    I / We confirm that I / we are not registered under GST. I / We understand that all the invoices
    pertaining to this contract will not bear GSTN.
  </label>
</p>
<p>
  <input type="checkbox" id="gstRegistered" name="gstRegistered" [(ngModel)]="gstRegistered"
    [disabled]="!cifDetails?.customer_details?.customer_gstin_number" #gstRegisteredRef
    (change)="onGSTSelection('registered')" />
  <label for="gstRegistered"
    [ngStyle]="!cifDetails?.customer_details?.customer_gstin_number ? {'cursor': 'not-allowed'} : {}">
    I / We confirm that our GSTN is
    @if (cifDetails?.customer_details?.customer_gstin_number) {
      <span>
        {{cifDetails.customer_details.customer_gstin_number}}
      </span>
    } @else {
      [ - ]
    }
    .
    I / We understand that all the invoices pertaining to this contract will bear this GSTN.
  </label>
</p>
</div>
<div class="col-12 col-md-12">
  <hr />
</div>
</div>
<!-- Executive Details e -->
<div class="suraksha-info" style="margin-top: 10px; margin-bottom: 20px;">
  <h4>GENERAL TERMS AND CONDITIONS FOR VALUE ADDED SERVICES</h4>
  <div style="column-count: 2;column-gap: 50px;">
    <p>Tata Motors Commercial Vehicles Limited ("Tata Motors Commercial Vehicles<strong>/We</strong>")
    offers a range of value-added services
    <strong>("VAS")</strong> as detailed
    below:
  </p>
  <ol type="a">
    <li>Annual Maintenance Contract, referred as <strong>"Suraksha"</strong> (Clause 1.1);</li>
    <li>Fleet Management Services, referred as <strong>"FMS"</strong> (Clause 1.2);</li>
    <li>Extended Warranty, referred as <strong>"EW"</strong> (Clause 1.3); and</li>
    <li>FMS Comfort (EV) (Clause 1.4).</li>
    <li>On-site Service Support, referred as <strong>"OSS"</strong> (Clause 1.5).</li>
  </ol>
  <p>The VAS can be availed both physically by approaching the nearby authorized dealers of Tata
    Motors, and digitally by visiting Tata Motors Commercial Vehicles website
    (<a href="https://www.fleetverse.tatamotors.com" target="_blank"
  rel="noopener noreferrer">https://www.fleetverse.tatamotors.com</a>).</p>
  <p>Thanks for choosing the specific VAS from the above list by executing the physical/digital
    Customer Information Form <strong>("CIF").</strong> You shall be referred as
    <strong>"You/you/Customer".</strong> You and Tata
    Motors shall be individually referred as <strong>"Party"</strong> and collectively as
    <strong>"Parties".</strong>
  </p>
  <p>It is assumed that you have already read these general terms and conditions carefully before
    executing the CIF. The CIF duly executed by you read together with these general terms and
    conditions along with the <strong>Annexure 2</strong> shall jointly constitute a binding agreement
    <strong>(“Agreement”)</strong>
    between you and Tata Motors Commercial Vehicles. The provisions of this Agreement are intended to
    apply to diesel,
    petrol, CNG, LNG, electric, hybrid, hydrogen fuel cell and such other vehicle technologies as may
    be introduced by Tata Motors Commercial Vehicles from time to time. References to any specific
    component, fuel,
    emission-control system, engine, aggregate, charging system, battery system or operating parameter
    shall be construed as applicable only to the extent relevant to the particular vehicle model
    covered under the VAS.
  </p>
  <p>By executing the CIF, you represent and warrant to Tata Motors Commercial Vehicles that:</p>
  <ol>
    <li>You are an adult Indian citizen, or lawfully incorporated Company under Indian Companies Act
      (Applicable from time to time), or any other lawfully incorporated entity under any law for the
    time being in force in India or an authorized legal representative of such an entity;</li>
    <li>You are legally competent to enter into agreements under the laws of contract;</li>
    <li>You agree to be bound by the Agreement;</li>
    <li>You agree that any service not expressly mentioned in either the exclusions or inclusions in
      <strong>Annexure 2</strong> shall be deemed to be excluded from the services available to you,
      and you shall have
      no right to claim any such service from Tata Motors Commercial Vehicles.
    </li>
    <li>You understand that the validity/ coverage and Term (as defined below) of the VAS may be in
      time period, kilometers covered by the vehicle(s) engine hours, operating hours, battery
      operating hours or such other measurement parameter specified by Tata Motors Commercial Vehicles
      for the applicable vehicle model.
    </li>
  </ol>
  <p><strong>1.1. SURAKSHA:</strong></p>
  <div>
    <ol type="a">
      <li>Tata Motors Commercial Vehicles provides vehicle(s) annual maintenance services under
        Suraksha.
        Suraksha is divided
        into different types of schemes depending upon the available services viz. Platinum, Platinum
        Plus, Gold, Gold plus, and Silver. A comprehensive list of the exclusions and inclusions under
        each Suraksha (as defined below) is provided in <u><strong>Annexure 2.</strong></u></li>
        <li>For electric vehicle models, including but not limited to Tata Prima E.55 S Cerus and
          such other EV platforms as may be notified by Tata Motors Commercial Vehicles from time to
          time, the specific
          inclusions, exclusions, covered aggregates, consumables and maintenance scope applicable to
          the relevant EV maintenance package shall be as set out in <u><strong>Annexure 2.</strong></u>
        </li>
        <li>You will get the annual maintenance service for your Tata commercial vehicle at the Tata
          Motors Commercial Vehicles authorized dealers and Tata Motors Commercial
          Vehicles authorized service stations (collectively, <strong>"Service Stations"</strong>),
          subject to the terms and conditions as set out hereinafter. You are advised to regularly visit
          the
          <a href="https://cv.tatamotors.com/" target="_blank"
          rel="noopener noreferrer">https://cv.tatamotors.com/</a>
          for checking/ downloading the updated list of the Service Stations. The annual maintenance
          services shall be provided by Tata Motors Commercial Vehicles as per the particular category
          of Suraksha availed by you in the CIF.
        </li>
      </ol>
    </div>
    <p><strong>1.1.1. Silver Suraksha:</strong> Under the Silver Suraksha Scheme, you will be entitled
    to get the preventive maintenance for your vehicle(s) as per the schedule set out in Owner's
    Service Book <strong>("OSB").</strong> A detailed list of inclusions and exclusions under the
    Silver Suraksha Scheme are set out in <u><strong>Annexure 2.</strong></u></p>
    <p><strong>1.1.2. Silver Plus Suraksha:</strong> Under the Silver Plus Suraksha,
    you will be entitled to get the preventive maintenance for your vehicle(s) as per the schedule set
    out in OSB.
    A detailed list of inclusions and exclusions under the Silver Plus Suraksha are set out in
    <u><strong>Annexure 2.</strong></u>
  </p>
  <p><strong>1.1.3. Gold Plus Suraksha:</strong> Under the Gold Plus Suraksha, you will be entitled to
  get all the services included in the Silver Suraksha as above. However, unlike the Silver
  Suraksha, the services under the Gold Plus Suraksha are inclusive of the cost of labour and spare
  parts of clutch, brakes, flywheel, starter motor and alternator only, that may be required in
  servicing the vehicle(s). Hence, you will not be required to pay any amount at the Service
  Stations for the services carried out and/or the spare parts used as mentioned above in your
vehicle(s).</p>
<p>A detailed list of inclusions and exclusions under the Gold Suraksha are set out in
  <u><strong>Annexure 2.</strong></u>
</p>
<p><strong>1.1.4. Platinum Suraksha:</strong> Under the Platinum Suraksha, you will be entitled to
get all the services included in the Silver Suraksha as above. However, unlike the Silver
Suraksha, the services under the Platinum Suraksha are inclusive of the cost of labour, spare
parts and aggregates that may be required in servicing the vehicle(s). Hence, you will not be
required to pay any amount at the Service Stations for the services carried out and/ or the spare
parts and aggregates replaced/used in your vehicle(s).</p>
<p>A detailed list of inclusions and exclusions under the Platinum Suraksha are set out in
  <u><strong>Annexure 2 (EV).</strong></u>
</p>
<p><strong>1.1.5. Platinum Plus Suraksha:</strong> Under the Platinum Plus Suraksha, you will be
entitled to get all the services included in the Platinum Suraksha as above. However, unlike the
Platinum Suraksha, the services under the Platinum Plus Suraksha are inclusive of the cost of
labour, spare parts and aggregates with additional coverage of After Treatment System
<strong>("ATS")</strong>
components and wiring harness that may be required for servicing the vehicle(s). Hence, you will
not be required to pay any amount at the Service Stations for the services carried out and/ or
the spare parts, aggregates and additional coverage used as mentioned above for your vehicle(s).
</p>
<p>A detailed list of inclusions and exclusions under the Platinum Plus Suraksha are set out in
  <u><strong>Annexure 2.</strong></u>
</p>
<p><strong>1.2. FMS:</strong> Tata Motors Commercial Vehicles provides the services relating to the
management of
Vehicle(s) fleet of the Customer under FMS that would include (1) Maintenance Packages, and (2)
Managed Service Packages. Under the Maintenance packages, Tata Motors Commercial Vehicles arranges
to ensure periodic
maintenance of the Vehicle(s), scheduled checking, data monitoring, etc. as more detailed herein
below. Under the managed service packages, Tata Motors Commercial Vehicles arranges to provide the
continuous remote
monitoring of the vehicle(s) to track fault codes, selected components, and basic vehicle(s)
usage, identification of potential issues in vehicle(s). The services under FMS may depend upon
the specific Pack availed by the Customer out of various available Packs. Tata Motors Commercial
Vehicles provides
maintenance packages in three categories, viz. Pack-1, Pack-2, and Pack-3; and managed service
packages in two categories Pack-4 and Pack-5. A detailed list of the inclusions and exclusions
under each Pack (as defined below) is provided in <u><strong>Annexure 2.</strong></u>
</p>
<p><strong>1.2.1. Pack-1:</strong> You will be entitled to get all the services included in the
Platinum Plus Suraksha. However, unlike the Platinum Plus Suraksha, the services under Pack-1 are
inclusive of the cost of labour, spare parts and aggregates with additional coverage of quarterly
greasing, torquing and oil and coolant top-ups (of pre-defined quantity) that may be required in
servicing the vehicle(s). Hence, you will not be required to pay any amount at the Service
Stations for the services carried out and/ or the spare parts, aggregates and additional coverage
used as mentioned above for your vehicle(s).</p>
<p>A detailed list of inclusions and exclusions under Pack-1 are set out in <u><strong>
Annexure 2.</strong></u>
</p>
<p><strong>1.2.2. Pack-2:</strong> You will be entitled to get all the services included in the
Platinum Plus Suraksha as above. However, unlike the Platinum Plus Suraksha, the services under
Pack-2 are inclusive of the cost of labour, spare parts and aggregates with additional coverage of
battery and electrical components (All ECUs, Bulbs, Fuses and Relays) that may be required in
servicing the vehicle(s). Hence, you will not be required to pay any amount at the Service
Stations for the services carried out and/ or the spare parts and aggregates replaced/used in your
vehicle(s).</p>
<p>A detailed list of inclusions and exclusions under Pack-2 are set out in <u><strong>
Annexure 2.</strong></u>
</p>
<p><strong>1.2.3. Pack-3:</strong> You will be entitled to get all the services included in Pack-2
as above. However, unlike Pack-2 , the services under Pack-3 are inclusive of the cost of labour,
spare parts, aggregates and additional coverage related to suspension, body parts, wheel rim, I
beam, tyre management (as per customer requirements) that may be required in servicing the
vehicle(s). Hence, you will not be required to pay any amount at the Service Stations for the
services carried out and/ or the spare parts, aggregates and additional coverage used as mentioned
above for your vehicle(s).</p>
<p>A detailed list of inclusions and exclusions under Pack-3 are set out in <u><strong>
Annexure 2.</strong></u>
</p>
<p><strong>1.2.4. Pack 4:</strong> Under the Pack 4, Tata Motors Commercial Vehicles provides the
services of continuous
remote monitoring of the vehicle(s) to track fault codes, selected components, and basic
vehicle(s) usage, identification of potential issues in vehicle(s) that lead to unplanned
downtime, preventive maintenance, access to the central customer service center to support in
managing unplanned repairs and service needs to ensure quick response, troubleshooting,
identifying faulty components and advising on the necessary repairs and replacements in the
vehicle(s). Pack 4 is available only to those customers who have a valid/active subscription of
the Tata Fleetedge Advance, unless otherwise agreed by Tata Motors Commercial Vehicles. If the
services under Pack 4
are opted by you for your Vehicle(s) less than 50 in number, then the services shall be provided
within the premises of the Service Stations. However, if the services under Pack 4 are opted by
you for your Vehicle(s) either 50 or above in number, then the services shall be provided at your
workplace/ site <strong>("Site").</strong> The Service Stations shall provide a dedicated
executive to be stationed
at your Site only during the day hours for providing the services under Pack 4. As to avail the
services under Pack 4 at your Site, you shall be required to provide the basic amenities and other
infrastructural/safety facilities at your Site for the said executive of our Service Stations in
accordance with <u><strong>Annexure 2.</strong></u> Failure to provide the said
facilities may result in
automatic cancellation/withdrawal/ seizure of your services under Pack 4.</p>
<p>A detailed list of inclusions and exclusions of services under Pack 4 are set out in
  <u><strong>
  Annexure 2.</strong></u>
</p>
<p><strong>1.2.5. Pack 5:</strong> Under the Pack 5 you shall be entitled to get all the services as
detailed in <u><strong>Annexure 2.</strong></u> You shall be eligible for all the
services of Pack 4 along with
the fuel efficiency management. Pack 5 is available only to those customers who have a
valid/active subscription of the Tata Fleetedge Advance plus, unless otherwise agreed by Tata
Motors. If the services under Pack 5 are opted by you for your Vehicle(s) less than 50 in number,
then the services shall be provided within the premises of the Service Stations. However, if the
services under Pack 5 are opted by you for your Vehicle(s) either 50 or above in number, then the
services shall be provided at your Site. The Service Stations shall provide a dedicated executive
to be stationed at your Site only during the day hours for providing the services under Pack 5. As
to avail the services under Pack 5 at your Site, you shall be required to provide the basic
amenities and other infrastructural/safety facilities at your Site for the said executive of our
Service Stations in accordance with <u><strong>Annexure 2.</strong></u> Failure to
provide the said facilities
may result in automatic cancellation/withdrawal/ seizure of your services under Pack 5.</p>
<p><strong>1.3. EW:</strong></p>
<p>The vehicle(s) manufactured by Tata Motors Commercial Vehicles carry a standard/original warranty
  valid for a limited period and subject to the warranty terms as stipulated/ updated by Tata Motors
  Commercial Vehicles
  from time to time. The EW is an extension of the warranty on your vehicle(s), if availed by you,
  subject to the terms
  herein. The scope of EW coverage shall be as specified in <strong>Annexure 2.</strong> for
  the applicable vehicle model and may include engine, gearbox, rear axle, traction motor, battery
  pack, power electronics, charging systems and such other components as specified by Tata Motors
  Commercial Vehicles from time to time. The tenure/ kilometers/ hours of EW coverage shall be as
  per the model of your vehicle(s) in line with the EW policy of Tata Motors Commercial Vehicles and
  will come into immediate effect on the expiry of the original warranty of your vehicle(s).
</p>
<p>
  <strong>1.4. FMS Comfort (EV):</strong> This FMS service is available
  exclusively for electric vehicles and shall not be available for any other type of vehicle. The
  specific inclusions, exclusions, battery health parameters, charging related conditions and
  component coverage applicable to electric vehicles are set out exclusively in
  <strong>Annexure 2</strong>.
  Any transfer of battery-related warranties, EV-specific benefits or battery performance guarantees
  shall be subject to the applicable EV policies of Tata Motors Commercial Vehicles in force from
  time to time. The specific EV Truck AMC coverage, inclusions and exclusions applicable to electric
  truck platforms are additionally set out in <strong>Annexure 2</strong>, where applicable.
</p>
<p><strong>1.5. OSS:</strong> Tata Motors Commercial Vehicles provides the services on the site of
the customers under
OSS only to those customers who have a valid/active subscription of the Tata Fleetedge, unless
otherwise agreed by Tata Motors Commercial Vehicles. OSS is divided into different types of
schemes depending upon the
available services viz. OSS Standard, OSS Suraksha Pack 1, OSS Suraksha Pack 2, OSS Suraksha Pack
3, OSS Suraksha Pack 4, and OSS Suraksha Pack 5.</p>
<p>In each of the above OSS schemes, Tata Motors Commercial Vehicles provides/arranges to provide
  adequate number of
  supervisors, Sr. Mechanic, Asst. Mechanic, Helper &amp; Electrician <strong>("Manpower")</strong>
  to be stationed
  at your Site. for discharging the services as per the type of the OSS scheme availed by you. The
  actual number of Manpower shall depend upon the scale, hours of operations at the Site and the
  agreement you enter into with Tata Motors Commercial Vehicles. The exact Manpower details agreed
  between the Parties
  shall be as per <strong>Annexure 2</strong> (Manpower). The following services are generally
  provided
under the OSS schemes:</p>
<ol type="a">
  <li>Imparting adequate training on the vehicle(s) maintenance know how to your staff;</li>
  <li>Ensuring the planning and management of the maintenance of your vehicle(s);</li>
  <li>Ensure coordination with your main workshop for parts stocking, complaint diagnostics etc.;
  </li>
  <li>Advising and assisting your maintenance team as regards the servicing and repairs of your
  vehicle(s); and</li>
  <li>Training to your drivers and other staff on regular intervals.</li>
</ol>
<p>Please refer <strong>Annexure 2</strong> to see the exact details of the services
available to you. <br />
The final price for the services under OSS shall increase with the options availed by you as per
<strong>Annexure 2.</strong>
</p>
<p><strong>Note:</strong> As to avail the services under OSS, you shall be required to provide the
basic amenities and other infrastructural/safety facilities at your site for the staff of our
Service Stations on a 24x7 basis in accordance with <strong>Annexure 2</strong>
(Services to be provided
to the Customer/You basis the type of OSS opted). Failure to provide the said facilities may
result in automatic cancellation/withdrawal/ seizure of your services under the OSS.</p>
<p><strong>1.5.1. OSS Standard:</strong> Please refer to <strong>Annexure 2</strong> for
the inclusions,
exclusions and other terms of the services under OSS Standard.</p>
<p><strong>1.5.2. OSS Suraksha Pack 1:</strong> Please refer to <strong> Annexure 2</strong>.to see
a
detailed list of inclusions and exclusions of the services under OSS Suraksha Pack 1.</p>
<p><strong>1.5.3. OSS Suraksha Pack 2:</strong> Please refer to <strong> Annexure 2</strong>. to see
a
detailed list of inclusions and exclusions of the services under OSS Suraksha Pack 2.</p>
<p><strong>1.5.4. OSS Suraksha Pack 3:</strong> Please refer to <strong> Annexure
2</strong>. to see a
detailed list of inclusions and exclusions of the services under OSS Suraksha Pack 3.</p>
<p><strong>1.5.5. OSS Suraksha Pack 4:</strong> Please refer to <strong>Annexure 2</strong>. to see
a detailed list
of inclusions and exclusions
of the services under OSS Suraksha Pack 4.</p>
<p><strong>1.5.6. OSS Suraksha Pack 5:</strong> Please refer to <strong> Annexure
2</strong>. to see a
detailed list of inclusions and exclusions of the services under OSS Suraksha Pack 5.</p>
<p><strong>1.6.</strong> The VAS being provided to you are in addition to and will not diminish the
benefits you get under the manufacturing warranty on your vehicle(s).</p>
<p><strong>1.7.</strong> Tata Motors Commercial Vehicles and /or the Service Stations shall be
entitled to retain any
spare part and lubricants that have been replaced under the VAS. You shall not have any objection
nor raise any claim with regard to this in future.</p>
<p><strong>1.8.</strong> The VAS shall be applicable only in case of the brand-new vehicle(s),
except otherwise agreed by Tata Motors Commercial Vehicles.</p>
<p><strong>1.9.</strong> Notwithstanding the specific kilometer/ Engine Hours / duration of VAS
selected by Customer in the CIF, the VAS may be renewed for a further period and/ or kilometers,
engine hours, operating hours, battery operating hours, as the case may be, at the sole discretion
of Tata Motors Commercial Vehicles. The VAS so renewed shall be applicable only for the specified
kilometers, engine/ battery operating hours or period as may be selected by you at the time of
renewal. The unexpired/ unutilized kilometers or Engine Hours of the previous VAS tenure shall not
be carried forward in the renewal VAS.</p>
<p><strong>1.10.</strong>Unless otherwise agreed by Tata Motors Commercial Vehicles, the benefits of
the VAS
shall be available only to the owner of the vehicle(s) duly registered in the records of regional
transport office (RTO).</p>
<p><strong>1.11.</strong> The VAS shall be rendered only during normal working days/ hours. You
shall inform Tata Motors Commercial Vehicles on the toll free number 1800 209 7979, if any Service
Station refuses to
provide you with the VAS during normal working days / hours.</p>
<p><strong>1.12.</strong>The VAS under this Agreement are exclusive and non-transferable. You
agree that the VAS is valid only for the vehicle(s) covered under the VAS, provided that at the
option of Tata Motors Commercial Vehicles, in case of transfer of ownership of a vehicle(s)
covered under VAS with
unexpired Term and where the specific kilometers or Engine Hours have not expired, the benefit of
the VAS for such remaining duration of the Term and to the extent of the unexpired kilometers,
engine hours or battery operating hours shall transfer to the new owner of the vehicle(s) to whom
such ownership has been transferred. However, this Agreement shall lapse immediately with respect
to a transferred vehicle(s) where the Term and/ or specified kilometers, engine hours or battery
operating hours expires on, or has expired as of, the date of transfer of ownership of the
vehicle(s).</p>
<p><strong>2. CONSIDERATION</strong></p>
<p><strong>2.1.</strong> In consideration of the VAS provided by Tata Motors Commercial Vehicles to
you, you shall pay
fees <strong>("Fees")</strong> to Tata Motors Commercial Vehicles as per the Fees indicated in the
offer letter
provided to you by Tata Motors Commercial Vehicles and also indicated in the CIF (Contract Value)
executed by you.</p>
<p><strong>2.2.</strong> The Fees are exclusive of goods and services tax <strong>("GST")</strong>
or any other tax,
if levied, during the Term and shall be payable by you as extra at the prevailing rate.</p>
<p><strong>2.3.</strong> The Customer shall make payment of a base booking Fee as required by Tata
Motors for the booking and acceptance of CIF. In case of cheque payment for base booking Fee, the
VAS shall get activated only after the realization of cheque into Tata Motors Commercial Vehicles
bank account. If the
cheque is dishonored for any reason whatsoever, the booking and the CIF shall not be accepted.</p>
<p><strong>2.4.</strong> The Customer acknowledges and agrees that, following the payment of the
base booking Fee by the Customer and the booking and acceptance of the CIF, Tata Motors Commercial
Vehicles
may, at
its option, collect post-dated cheques <strong>("PDC")</strong> or seek issuance of NACH mandate /
standing
instructions from the Customer in favour of Tata Motors Commercial Vehicles covering the Fees due
to Tata Motors Commercial Vehicles, or
require electronic transfer of Fee installments or demand draft and their details from the
Customer for the purpose of processing payments. Tata Motors Commercial Vehicles shall provide the
Customer with the
details of the Equated Monthly Instalment <strong>("EMI")</strong> schedule, including the total
amount to be
collected and the specific EMI due dates, if EMI is availed by the Customer and approved by the
partner bank. Notwithstanding the aforesaid, Tata Motors Commercial Vehicles will communicate the
final payment
instrument approved by the partner bank with the Customer, after receiving confirmation from the
bank.</p>
<p><strong>2.5.</strong> Acceptance of Electronic Clearance Services <strong>("ECS")</strong>/ NACH
mandate/ PDC (as
the case maybe) shall occur only after the acceptance of the CIF by Customer and Tata Motors
Commercial Vehicles. In
the event of non-acceptance, rejection, or dishonor of the payment instrument by Tata Motors
Commercial Vehicles
or
the partner bank for any reason, the VAS shall be subject to cancellation at Tata Motors
Commercial Vehicles
sole
discretion.</p>
<p><strong>2.6.</strong> The Customer shall ensure that the payment instrument given by the Customer
shall remain valid and that sufficient funds are maintained in their account through which the
instrument is issued until the payment of all outstanding amounts under this Agreement. The
Customer shall not at any time close such account, or give instructions to their bank to stop
payment to Tata Motors Commercial Vehicles or cancel the mandate until the payment of all
outstanding amounts under
this Agreement is made to Tata Motors Commercial Vehicles.</p>
<p><strong>2.7.</strong> Tata Motors Commercial Vehicles shall, from time to time, assess and
ascertain the running of
the vehicle(s) on the basis of VAS history and odometer reading. In the event where the VAS
kilometers are likely to expire before the Term, Tata Motors Commercial Vehicles reserves the
right to demand the
balance Fees due and payable from the date of such assessment till the expiry of the Term. You
agree and undertake to pay such amount as and when demanded by Tata Motors Commercial Vehicles,
failing which Tata
Motors shall be entitled to suitable recourse as may be deemed fit.</p>
<p><strong>2.8.</strong> You shall not, and acknowledge that you will have no right, under this
Agreement to withhold, offset, recoup or debit any amounts owed (or to become due and owing) to
Tata Motors Commercial Vehicles or any of its affiliates, whether under this Agreement or
otherwise, against any other
amount owed (or to become due and owing) to you by Tata Motors Commercial Vehicles or Tata Motors
Commercial Vehicles
affiliates, whether
relating to Tata Motors Commercial Vehicles or its affiliates' breach or non-performance of this
Agreement, or any
other agreement between you or any of your affiliates and Tata Motors Commercial Vehicles or any
of its affiliates, or
otherwise.</p>
<p><strong>2.9.</strong> Tata Motors Commercial Vehicles reserves the right to revise the Fees for
the VAS at its sole
discretion at the expiry of the Term. Tata Motors Commercial Vehicles may, at its sole discretion,
revise the Fees at
the end of any calendar year during the Term as a consequence of any material variation or
alteration to the terms and conditions of the VAS or this Agreement made unilaterally by the
Customer, which may include without limitation, deteriorated condition of the vehicle(s) covered
under the VAS, or in case where the VAS have been applied for a fleet of vehicle(s), termination /
withdrawal of the VAS for a considerable number of vehicle(s) under such fleet. In the event of
any such revision in Fees by Tata Motors Commercial Vehicles, you shall accept such revised Fees
and make payments as
per the revised Fees from the next invoice onwards.</p>
<p><strong>2.10.</strong> The Customer shall pay Fees as per the payment schedule in the CIF
directly to Tata Motors Commercial Vehicles. As may be applicable for ECS transactions, or in the
event the Customer
does not provide the PDCs in advance or the PDCs are dishonored, delayed payments (for more than 7
days' of delay beyond the applicable due date) will attract interest at the rate of 18% per annum
from the applicable due date. Tata Motors Commercial Vehicles reserves the right to suspend or
refuse the VAS, or
terminate this Agreement if there is delay in making payments within the applicable due dates on
two or more occasions.</p>
<p><strong>2.11.</strong> Customer agrees to submit the duly signed TDS certificates to Tata Motors
Commercial Vehicles
as and when it is filed with the relevant tax authorities every quarter. Failing to submit such
TDS certificates shall be considered as breach of this Agreement.</p>
<p>
  <strong>Important Note:</strong> <br />
  This Agreement is a common master agreement applicable to multiple vehicle technologies and VAS
  offerings of Tata Motors Commercial Vehicles. Certain obligations contained herein may relate
  specifically to diesel,
  petrol, CNG, LNG, electric, hybrid or other vehicle technologies and shall apply only to the
  extent relevant to the vehicle covered under the applicable CIF.
</p>
<p class="d-none"><strong>2.12.</strong> Tata Motors Commercial Vehicles reserves the right to
revise the Fees for
the VAS at its sole
discretion any time on the basis of variation in the commodity prices, oil prices, or other
relevant parameters impacting the costs. Tata Motors Commercial Vehicles may, at its sole
discretion, revise the Fees
at the end of any calendar year during the Term as a consequence of any material variation or
alteration to the terms and conditions of the VAS or this Agreement made unilaterally by the
Customer, which may include without limitation, deteriorated condition of the vehicle(s) covered
under the VAS, or in case where the VAS have been applied for a fleet of vehicle(s), termination /
withdrawal of the VAS for a considerable number of vehicle(s) under such fleet. In the event of
any such revision in Fees by Tata Motors Commercial Vehicles, you shall accept such revised Fees
and make payments as
per the revised Fees from the next invoice onwards.</p>
<p><strong>3. YOUR DUTIES</strong></p>
<p>The duties set out below shall apply only to the extent relevant to the particular vehicle model,
  fuel type, propulsion technology and VAS selected by the Customer. Any obligation relating
  exclusively to diesel, petrol, CNG, LNG, electric, hybrid, hydrogen or any other propulsion
technology shall apply only where such technology is installed in the Customer's vehicle.</p>
<p>The provisions relating to ATS, DPF, SCR, DEF or similar emission-control systems shall apply
only to vehicle models equipped with such systems.</p>
<p>You agree and acknowledge that the provision of VAS by Tata Motors Commercial Vehicles is
  contingent to your
  fulfilment of the duties listed below throughout the Term, and your failure to fulfil any of these
duties shall deprive you from the benefits under the opted VAS:</p>
<p><strong>3.1.</strong> To read OSB thoroughly to know about operation aspects, features and
maintenance of your vehicle(s) before the vehicle(s) is driven. To ensure maximum safety and
optimum performance of your vehicle(s), follow recommended tips for driver, driving instruction
and other related information.</p>
<p><strong>3.2.</strong> Ensure that the daily checks are carried out in the vehicle(s) as per OSB.
</p>
<p><strong>3.3.</strong> Top up the oil in vehicle(s) aggregates whenever it falls below the
required level by bringing the vehicle(s) to nearest Service Station.</p>
<p><strong>3.4.</strong> Top up the water and coolant mix in the radiator whenever it falls below
the required level by bringing the vehicle(s) to nearest Service Station.</p>
<p><strong>3.5.</strong> Switch off the engine if the temperature of the cooling system crosses the
upper limit indicated on the temperature gauge in the vehicle(s).</p>
<p><strong>3.6.</strong> Do not drive the vehicle(s) if diesel supply to the fuel injection pump
<strong>("FIP")</strong> is erratic and causing air locks.
</p>
<p><strong>3.7.</strong> Do not drive the vehicle(s) if the oil levels in aggregates and/ or water
and coolant mixture level in radiator is not at requisite level.</p>
<p><strong>3.8.</strong> Bring the vehicle(s) for the scheduled services at authorized dealer(s)/
Service Station as per OSB.</p>
<p><strong>3.9.</strong> Not to tamper with the speedometer / odometer / hour meter of the
vehicle(s).</p>
<p><strong>3.10.</strong> Bring the vehicle(s) to the nearest Service Station for repairs whenever
the speedometer/ odometer/ hour meter starts malfunctioning or stops functioning.</p>
<p><strong>3.11.</strong> In case the speedometer/ odometer/ hour meter of the vehicle(s)/s is found
to have been tampered or malfunctioning, the Service Station shall be entitled to ascertain the
actual kilometers or hours run as nearly as possible, on the basis of such sources as it may deem
fit. You shall not object to the methodology adopted by the Service Station for calculation of the
kilometers or hours.</p>
<p><strong>3.12.</strong> Use only approved fuels, energy sources, charging infrastructure,
lubricants, fluids and consumables recommended by Tata Motors Commercial Vehicles for the
applicable vehicle model and
avoid any unauthorized modifications, adulteration or misuse. The question of adulteration in fuel
shall be decided in terms of the relevant policies of Tata Motors Commercial Vehicles.
</p>
<p><strong>3.13.</strong> Keep the vehicle(s) in a healthy running condition and ensure all
requisites that the VAS in the vehicle(s) are availed as per the OSB.</p>
<p><strong>3.14.</strong> Clean the fuel tank and diesel exhaust fluid <strong>("DEF")</strong> tank
once every year
or at intervals of 100,000 KMs or 2000 hours, whichever occurs earlier, through a Service Station.
</p>
<p><strong>3.15.</strong> Do not overload the vehicle(s) beyond permissible/ agreed limits.</p>
<p><strong>3.16.</strong> Pay directly to the Service Station for any service availed outside the
scope of VAS under the Suraksha Scheme.</p>
<p><strong>3.17.</strong> In the event of breakdown on route, the Customer shall contact Customer
Assistance Centre <strong>("CAC")</strong> on toll free number 1800 209 7979 to register a
complaint who will
direct the Customer to the nearest Service Station for repair / recommissioning of the vehicle(s).
</p>
<p><strong>3.18.</strong> Take delivery of the vehicle(s) within 48 hours of readiness after repair.
Tata Motors Commercial Vehicles / Service Station will be at liberty to charge storage charges if
delivery is not
taken by the Customer within 48 hours.</p>
<p><strong>3.19.</strong> Inform Tata Motors Commercial Vehicles immediately on sale and / or
transfer of ownership of
the vehicle(s) to someone else in any manner whatsoever by letter and provide a copy of the sale
letter, delivery letter and duly filled up RTO Form No. 28, 29 and 30 and a copy of ownership
transfer on RC book as proof of sale of vehicle(s).</p>
<p><strong>3.20.</strong> Inform Tata Motors Commercial Vehicles immediately in case the vehicle(s)
meets with an
accident during the Term and provide a copy of the police FIR for the accident and survey report
endorsed by insurance company within 30 (thirty) days of the accident.</p>
<p><strong>3.21.</strong> Ensure that only the Service Stations carry out the service and repair
activities in your vehicle(s).</p>
<p><strong>3.22.</strong> Ensure that only genuine DEF, if applicable, is used in your vehicle(s)
and precautionary measures are taken to avoid any adulteration of DEF.</p>
<p><strong>3.23.</strong> Ensure that the vehicle(s) is/are stopped immediately when DPF or SCR
lamps are switched ON, and stationary regeneration is done or vehicle(s) is taken to nearest
Service Station.</p>
<p><strong>3.24.</strong> Do not allow the vehicle(s) to run out of DEF. If the level goes below 10%
(ten percent) of the tank capacity, 'Check Engine' lamp will glow. If the DEF quantity is zero the
'Check Engine' lamp will start flashing and the vehicle(s) will go to de-rate mode. In this
condition immediately fill the DEF.</p>
<p><strong>3.25.</strong> Do not remove the heat shield provided on the exhaust pipe. It is required
for proper dosing and preventing crystallization of the fluid.
In addition to the above, you shall fulfil the following duty in the event fleet management VAS
has been opted by you:</p>
<p><strong>3.26.</strong> Ensure that the driver strictly adheres to all processes that support the
proper regeneration of the <strong>ATS</strong>. Any deliberate action by the driver to inhibit
regeneration
leading to ATS failure will result in forfeiting the benefits under the VAS as applicable.</p>
<p><strong>3.27.</strong> To check proper functioning of cylinder valves, close all the cylinder
valves and start the engine. If engine does not stop by itself, get valves checked / replaced, as
applicable for CNG vehicle(s).</p>
<div>
  <p>
    <strong>3.28. Additional Duties Applicable to Electric Vehicles:</strong><br>
    The following obligations shall apply additionally where the vehicle covered under the VAS is an
    electric vehicle:
  </p>
  <ol type="a">
    <li>The Customer shall operate, maintain, charge and store the vehicle strictly in accordance
      with the OSB, charging instructions, safety guidelines and other recommendations issued by
    Tata Motors Commercial Vehicles from time to time.</li>
    <li>The Customer shall not switch off the ignition or shut down the vehicle while the vehicle is
    in motion.</li>
    <li>The Customer shall not expose the vehicle or the High Voltage (HV) battery system to extreme
      environmental conditions beyond the limits prescribed by Tata Motors Commercial Vehicles and
      shall comply
      with all
    vehicle storage requirements specified by Tata Motors Commercial Vehicles.</li>
    <li>The Customer shall ensure that charging is carried out only through approved charging
      infrastructure, charging equipment and electrical installations recommended or approved by
    Tata Motors Commercial Vehicles.</li>
    <li>The Customer shall ensure that the State of Charge (SOC) of the HV battery is maintained
      within the limits prescribed by Tata Motors Commercial Vehicles and shall follow all charging
      practices
    recommended in the OSB.</li>
    <li>The Customer shall ensure that coolant levels in the Battery Cooling System (BCS), Traction
      Cooling System (TCS) and other applicable cooling systems are maintained at the prescribed
    levels.</li>
    <li>The Customer shall immediately report any battery warning, charging fault, thermal event,
      abnormal battery behaviour, HV battery alert or other critical warning indication to the
    Service Stations.</li>
    <li>The Customer shall not tamper with, modify, dismantle or permit any unauthorized repair of
      the HV battery, battery charging systems, power electronics, traction motor or other
    high-voltage components.</li>
    <li>The Customer shall maintain accurate operational records, including kilometres travelled and
      operating hours, as may be required under the applicable VAS and provide the same upon
    request.</li>
    <li>Failure to comply with the operating, charging, maintenance, storage or safety requirements
      prescribed by Tata Motors Commercial Vehicles may result in exclusion of the affected repair,
      replacement
      or claim
    from VAS coverage.</li>
  </ol>
</div>
<p><strong>4. CONFIDENTIALITY</strong></p>
<p><strong>4.1.</strong> For the purpose of this Agreement, <strong>"Confidential
Information"</strong> means any and all non-public information disclosed to or otherwise
received or acquired by the Customer from or on behalf of Tata Motors Commercial Vehicles
including proprietary
information, either directly or indirectly, in writing, orally, electronically, photographically,
or in any other form or by inspection of tangible objects that is treated by Tata Motors
Commercial Vehicles as
confidential, or any other information of such nature as may be reasonably construed to be
confidential.</p>
<p><strong>4.2.</strong> Customer shall keep all Confidential Information confidential and shall not
divulge any Confidential Information to any other person or use the Confidential Information other
than in accordance with this Agreement, except to the extent:</p>
<p><strong>4.2.1.</strong> such Confidential Information is in the public domain other than by
breach of this Agreement;</p>
<p><strong>4.2.2.</strong> such Confidential Information is required to be disclosed under the
applicable laws or pursuant to any applicable regulatory requirements or by any statutory
authority, provided that prior written notice is given to Tata Motors Commercial Vehicles within
reasonable time
period, so that a protective order or other relief, as appropriate, maybe sought by Tata Motors
Commercial Vehicles;
</p>
<p><strong>4.2.3.</strong> any of the Confidential Information is later legally acquired by the
Customer from a source not obligated to Tata Motors Commercial Vehicles, or its affiliates, to
maintain
confidentiality of such Confidential Information.</p>
<p><strong>4.3.</strong> Customer agrees that Confidential Information shall at all times remain the
property of Tata Motors Commercial Vehicles.</p>
<p><strong>4.4.</strong> Upon expiry or termination of the Agreement, Customer shall return the
Confidential Information to the other Party.</p>
<p><strong>4.5.</strong> The confidentiality obligations herein shall survive the termination of
this Agreement.</p>
<p><strong>5. INTELLECTUAL PROPERTY RIGHTS</strong></p>
<p><strong>5.1.</strong> Customer hereby agrees, confirms, and warrants that it shall have no right,
title, interest, or other claim whatsoever over the intellectual property of the Tata Motors
Commercial Vehicles or
its affiliates, and that all rights, title and interest in respect of the intellectual property
shall continue to vest solely with Tata Motors Commercial Vehicles or its affiliates.</p>
<p><strong>5.2.</strong> You grant to Tata Motors Commercial Vehicles a limited, royalty-free
license to use your
pre-existing intellectual property to the extent required for Tata Motors Commercial Vehicles to
perform the VAS and
to use for Tata Motors Commercial Vehicles marketing and other related purpose.</p>
<p><strong>5.3.</strong> Customer shall not, neither during nor at any time after the expiry or
termination of this Agreement in any way question or dispute Tata Motors Commercial Vehicles
ownership of the
intellectual property.</p>
<p><strong>5.4.</strong> Customer shall not, without obtaining the prior written consent of Tata
Motors, use, display, reproduce, duplicate, or publish any of the intellectual property of Tata
Motors.</p>
<p><strong>6. INDEMNITY</strong></p>
<p><strong>6.1.</strong> You agree to indemnify and hold Tata Motors Commercial Vehicles, its
directors, officers,
affiliates and employees, harmless from and against any and all losses, penalties, claims,
obligations, liabilities, damages, taxes, interests, fines, penalties, costs and expenses,
including legal fees, imposed on, sustained, incurred or suffered by Tata Motors Commercial
Vehicles as a result of,
relating to, or arising out of:</p>
<p><strong>6.1.1.</strong> your acts and omissions or of any third party including the driver of the
vehicle(s) pursuant to or in relation to the VAS provided by Tata Motors Commercial Vehicles;</p>
<p><strong>6.1.2.</strong> a breach or non-performance of your obligations under this Agreement; or
</p>
<p><strong>6.1.3.</strong> your failure to comply with or contravention of the provision of
applicable law.</p>
<p><strong>7. LIMITATION OF LIABILITY</strong></p>
<p><strong>7.1.</strong> The vehicle(s) shall be serviced, driven and parked in the Service Station
at your sole risk, and Tata Motors Commercial Vehicles shall not be responsible for any damage or
deterioration caused
to the vehicle(s) thereof.</p>
<p><strong>7.2.</strong> The Service Station shall not be responsible for any work undertaken by any
unauthorized person or garage on the vehicle(s). Upon detection, the Service Station shall inform
you about the same.</p>
<p><strong>7.3.</strong> Tata Motors Commercial Vehicles shall not be liable for any death, bodily
injury or any
consequential business losses, external damages and failures due to any modification / negligence
in operation / maintenance caused by your vehicle(s) during the provision of VAS.</p>
<p><strong>7.4.</strong> In addition, you specifically acknowledge and agree that no oral or written
information or advice provided by Tata Motors Commercial Vehicles, its affiliates, officers,
directors, employees, and
agent, will (a) constitute legal or financial advice; or (b) create a warranty of any kind with
respect to the VAS, and you should not rely on any such information or advice.</p>
<p><strong>7.5.</strong> In no event shall Tata Motors Commercial Vehicles be liable to you for any
indirect, special,
exemplary, punitive, consequential, or incidental damage or loss of revenue or business profits,
of any kind in connection with this Agreement, whether based on warranty, contract, tort, or any
other legal or equitable theory, and whether or not Tata Motors Commercial Vehicles is advised of
the possibility of
such damages.</p>
<p><strong>7.6.</strong> Tata Motors Commercial Vehicles shall not be liable for:</p>
<ol type="a">
  <li>Providing VAS for the breakdown of any part not covered under the list of parts for the
  particular VAS selected.</li>
  <li>Any loss or damage to the items which are not part of the standard/ original vehicle(s).</li>
  <li>Damage resulting out of owner/ driver not taking reasonable steps to safeguard the vehicle(s)
  from loss or damage and to maintain it in efficient condition.</li>
  <li>Any repairs/ replacement arising from collision damage, burglary, theft or any other external
    means, act of God, riots, terrorism, malicious damage or if the vehicle(s) is used for any sort
  of competition, racing, sport, rally or reliability trial.</li>
</ol>
<p><strong>7.7.</strong> Subject to the above and notwithstanding anything to the contrary contained
in this Agreement, the maximum aggregate liability (whether in contract, tort (including
negligence), or equity) of Tata Motors Commercial Vehicles in respect of this Agreement shall at
all times, regardless
of the form of claim, not exceed the Fees received from you towards the VAS, pro-rated for the
preceding 12 months prior to such claim having arisen. The foregoing limitations of liability will
apply notwithstanding the failure of the essential purpose of any limited remedy of the Agreement.
</p>
<p><strong>7.8.</strong> Except as expressly stated in this Agreement, Tata Motors Commercial
Vehicles disclaims all
warranties of any kind, implied, statutory, or in any communication between Tata Motors Commercial
Vehicles and you,
including without limitation, the implied warranties of merchantability, non-infringement, title,
and fitness for a particular purpose.</p>
<p><strong>8. TERM AND TERMINATION</strong></p>
<p>This Agreement shall come into effect on the start date specified in the
  CIF and remain valid till the end date specified therein <strong>("Term")</strong>, unless
  terminated (in the manner provided herein) or extended pursuant to mutual agreement. For the
  purpose of this Agreement, <strong>"Term"</strong> shall include any subsequent extension of the
Term for a further period pursuant to Clause 1.9.</p>
<p><strong>8.1.</strong> Tata Motors Commercial Vehicles shall have the right to terminate this
Agreement, without
assigning any reason, by giving you a prior written notice of 15 (fifteen) days. The advance Fees,
if any, shall be refunded to you on a pro-rata basis for the unexpired period of the Term.</p>
<p><strong>8.2.</strong> Tata Motors Commercial Vehicles may, at its absolute discretion, suspend or
terminate the VAS
for particular vehicle(s) or terminate the Agreement in entirety with immediate effect in the
event of the happening of any of the following events:</p>
<p><strong>8.2.1.</strong> if you are in breach of any of your obligations and duties under this
Agreement, and either the breach cannot be cured or, if the breach can be cured, it is not cured
by you within a period of 5 (five) days after receipt of Tata Motors Commercial Vehicles notice of
such breach;</p>
<p><strong>8.2.2.</strong> if you fail to make payment of the Fees within the applicable due date;
</p>
<p><strong>8.2.3.</strong> if the cheque provided by you towards Fee payment is dishonored for any
reason;</p>
<p><strong>8.2.4.</strong> if you become insolvent or are generally unable to pay, or fail to pay,
your debts as they become due;</p>
<p><strong>8.2.5.</strong> if the vehicle(s) is sold, disposed or otherwise transferred to a
third-party, subject to Clause 1.12;</p>
<p><strong>8.2.6.</strong> If any representation and warranties made by you are false or misleading;
</p>
<p><strong>8.2.7.</strong> if the vehicle(s) meets with an accident;</p>
<p><strong>8.2.8.</strong> if the vehicle(s) suffers any damages due to natural calamities or towing
or negligent driving;</p>
<p><strong>8.2.9.</strong> if the speedometer/ odometer/ hour meter is found to have been tampered
or malfunctioning;</p>
<p><strong>8.2.10.</strong> if the vehicle(s) is misused, including but not limited to overloading
beyond permissible/agreed limits, operating with adulterated fuels and/or prohibited/not
recommended lubricants, failing to adhere to scheduled maintenance services, operational faults
caused by drivers, or abuse due to operating conditions; or</p>
<p><strong>8.2.11.</strong> upon detection of any work undertaken by an unauthorized person or
garage in the vehicle(s) by the Service Station.</p>
<p><strong>8.3.</strong> Premature termination of this Agreement or withdrawal of VAS for any
specific vehicle(s) included in the Scheme by you for any reason whatsoever shall be preceded by
written notice of at least ninety (90) days and, in such event you agree that the Fees for the VAS
are not refundable under any circumstances.</p>
<p><strong>8.4.</strong> Upon termination of the Agreement pursuant to Clause 8.2, the Fees paid for
the VAS shall not be refunded to you (even on pro-rata basis). In this event, you will forthwith
pay all the expenses actually incurred by Tata Motors Commercial Vehicles as evidenced by written
records towards
rendering the VAS on the vehicle(s) up to the effective date of termination or the unpaid portion
of Fees up to the effective date of termination, whichever is higher. Additionally, depending upon
the facts on a case to case basis, Tata Motors Commercial Vehicles may impose a surcharge of 5%
(five percent) of the
amount so payable to Tata Motors Commercial Vehicles as stated hereinabove or INR 1000/- (Rupees
One Thousand only) per vehicle,
whichever is higher, towards the administrative expenses incurred by Tata Motors Commercial
Vehicles, involved in
respect of the unexpired period of the Term, to the extent permitted under applicable law. Any
applicable taxes shall be payable by the Customer over and above such surcharge.</p>
<p><strong>8.5.</strong> Upon the expiration or earlier termination of this Agreement, you shall:
</p>
<p><strong>8.5.1.</strong> return to Tata Motors Commercial Vehicles / destroy all documents and
tangible materials (and
any copies) containing, reflecting, incorporating or based on Tata Motors Commercial Vehicles
Confidential
Information;</p>
<p><strong>8.5.2.</strong> permanently erase all of Tata Motors Commercial Vehicles Confidential
Information from its
computer systems; and</p>
<p><strong>8.5.3.</strong> certify in writing to Tata Motors Commercial Vehicles that you have
complied with the
requirements of this clause.</p>
<p><strong>8.6.</strong> In the event of suspension or termination of the VAS by Tata Motors
for particular vehicle(s) pursuant to Clause 8.2.7 and 8.2.8, you may seek re-induction of such
vehicle(s) subject to the sole discretion of Tata Motors Commercial Vehicles and the fulfilment of
the following conditions:</p>
<p><strong>8.6.1.</strong> the vehicle(s) are repaired/rectified at Tata Motors Commercial Vehicles
designated Service
Stations at your own cost and to the complete satisfaction of Tata Motors Commercial Vehicles;</p>
<p><strong>8.6.2.</strong> insurance formalities, claims and accounts are settled by you fully with
the Service Station in respect of accident;</p>
<p><strong>8.6.3.</strong> on completion of work, the vehicle(s) are inspected by Tata Motors
Commercial Vehicles
service engineer and repaired and found to be up to his satisfaction. The decision of the service
engineer of Tata Motors Commercial Vehicles in this regard will be final;</p>
<p><strong>8.6.4.</strong> the expenses for any additional rectification work required to be carried
out as per the advice of service engineer are borne by you and paid to the Service Station
directly;</p>
<p><strong>8.6.5.</strong> payment of administrative charges of INR 1000/- (Rupees One Thousand
only) to Tata Motors Commercial Vehicles for each such re-inducted vehicle(s); and</p>
<p><strong>8.6.6.</strong> payment of additional amount for re-induction under VAS, if applicable,
due to change in the rate of Fees for the VAS established basis the inspection report.</p>
<p><strong>8.7.</strong> Upon termination of this Agreement for any reason whatsoever, the Customer
shall make payment of all undisputed sums under this Agreement due to Tata Motors Commercial
Vehicles
prior to or
after such termination, within 30 days of the receipt of the termination notice.</p>
<p><strong>8.8.</strong> Termination of a VAS or this Agreement, or loss of VAS benefits in respect
of a particular vehicle(s) shall result in the automatic cessation of any additional warranties
that may have been given by Tata Motors Commercial Vehicles under this Agreement or otherwise,
including but not
limited to vehicle(s) residual value guarantee and battery capacity warranty offered by Tata
Motors in relation to that vehicle(s).</p>
<p><strong>9. FORCE MAJEURE</strong></p>
<p><strong>9.1.</strong> If Tata Motors Commercial Vehicles and / or the Service Stations are
rendered wholly or
partially unable to perform any of their obligations under this Agreement because of a Force
Majeure Event, they shall be excused from performance of such obligations. The non-performance of
obligations shall not be regarded as the breach of this Agreement by Tata Motors Commercial
Vehicles and / or the
Service Stations. A <strong>"Force Majeure Event"</strong> shall be referred to as any event
beyond the reasonable control of Tata Motors Commercial Vehicles and / or the Service Stations
including but not
limited to act of God, fire, flood, earthquake, windstorm or other natural disasters, war,
invasion, act of foreign enemies, terrorism, hostilities whether war be declared or not, civil
war, rebellion, or insurrection, strike, lockout, labour dispute, orders or restrictions imposed
by Government or any other public authority including restrictions on export/import and other
licenses passed/imposed by the Government or any lockdown announced by the local Government making
it impossible for this Service Station to provide VAS under the Agreement.</p>
<p><strong>9.2.</strong> During the subsistence of a Force Majeure Event, the performance of Tata
Motors shall remain suspended and the time allowed to comply with any obligation shall be extended
for as long as the relevant Force Majeure Event causing such delay or suspension continues.</p>
<p><strong>9.3.</strong> Notwithstanding the foregoing, the occurrence of a Force Majeure Event
shall not operate to dilute or suspend your payment obligations under this Agreement.</p>
<p><strong>10. GOVERNING LAW AND DISPUTE RESOLUTION</strong></p>
<p><strong>10.1.</strong> This Agreement, including non-contractual rights and obligations arising
out of or in connection with this Agreement, shall be governed by the laws of India.</p>
<p><strong>10.2.</strong> All disputes and/or differences whatsoever arising between the Parties out
of or relating to the construction, meaning, validity, termination and operation or effect of this
Agreement or breach thereof shall be initially referred to the business heads of respective
parties for amicable resolution through discussions. In the event, the dispute or differences are
not settled amicably through discussions within 30 days of referring the dispute to the business
heads, the same shall be settled by arbitration in accordance with the rules of arbitration of the
Mumbai Centre For International Arbitration (<strong>"MCIA Rules"</strong> as amended from time to
time), which
rules are deemed to be incorporated by reference in this clause.</p>
<p><strong>10.3.</strong> The Award made in pursuance thereof shall be binding on the Parties.</p>
<p><strong>10.4.</strong> The venue and seat of the arbitration shall be Mumbai.</p>
<p><strong>10.5.</strong> The language of the arbitration shall be English.</p>
<p><strong>10.6.</strong> The law governing this arbitration agreement shall be Indian law.</p>
<p><strong>10.7.</strong> Save as aforesaid, the competent courts in Mumbai alone shall have
exclusive jurisdiction in the event of any legal/ judicial proceedings.</p>
<p><strong>11. Personal Data</strong></p>
<p><strong>11.1.</strong> The Customer agrees to share all his/her personal and sensitive personal
data <strong>("Personal Data")</strong> with Tata Motors Commercial Vehicles freely, specifically,
after being fully
informed,
unconditionally and unambiguously with a clear understanding that Tata Motors Commercial Vehicles
collects, stores,
processes, utilizes, transfers and uses Personal Data for promotional and marketing activities.
</p>
<p><strong>11.2.</strong> The Customer is also fully aware that Tata Motors Commercial Vehicles
shares the Personal Data
with its Service Stations, business partners, associates, third parties, etc.; and also uploads
the Personal Data and a copy of the Agreement on the CRM DMS system/portal of Tata Motors
Commercial Vehicles.</p>
<p><strong>11.3.</strong> The Customer hereby confirms that he/she has no objection nor shall raise
any in future as regards the Personal Data collection, storage, processing, utilization, transfer
and usage of Personal Data by Tata Motors Commercial Vehicles.</p>
<p><strong>11.4.</strong> The Customer hereby unconditionally grants his/her consent and authorize
Tata Motors Commercial Vehicles including its Service Stations, authorized service providers,
channel partners,
contractors, advertisers, suppliers and licensors to collect, store, process, utilize, transfer
and use Personal Data for promotional and marketing activities. They shall be fully authorized to
use all the Personal Data disclosed by the Customer, and to share the Personal Data for
promotional, marketing activities of Tata Motors Commercial Vehicles or any of its group
companies/ subsidiaries/
authorized dealers, in accordance with the privacy policy of Tata Motors Commercial Vehicles.</p>
<p><strong>11.5.</strong> Tata Motors Commercial Vehicles also reserves the right to access, store,
use, analyse,
monetise and transfer to third parties the data captured by Tata Fleetedge on your vehicle(s)
enrolled under the VAS in accordance with the privacy policy of Tata Fleetedge.</p>
<p><strong>12. REPRESENTATION &amp; WARRANTIES</strong></p>
<p>Each Party represents and warrants to the other Party that: (i) it has the power and authority to
  grant the rights and perform the obligations to which it commits herein; (ii) the execution of
  this Agreement by the person representing it, will be sufficient to render this Agreement binding
  upon it; (iii) neither its performance hereunder nor the exercise by any other Party of rights
  granted by the warranting Party hereunder, will violate any applicable laws or regulations, or the
  legal rights of any other Parties, or the terms of any other agreement, to which the warranting
  Party is or becomes a Party; and (iv) it will perform its obligations and fulfil its
  responsibilities under this Agreement, in a manner that complies with all the applicable laws, and
  it shall at all times comply, at its cost, with all the applicable laws (including identifying and
  procuring required permits, certificates, approvals, licenses and inspections), to perform its
obligations under this Agreement.</p>
<p><strong>13. MISCELLANEOUS</strong></p>
<p><strong>13.1.</strong> Clauses 4 (Confidentiality), 5 (Intellectual Property Rights), 6
(Indemnity), 7 (Limitation of Liability), 8 (Termination), 10 (Governing Law and Dispute
Resolution), 11 (Personal Data) and 12 (Miscellaneous), or any Clause which by its nature is
intended to survive the termination or expiry of this Agreement, shall survive the termination or
expiry of this Agreement.</p>
<p><strong>13.2.</strong> All notices, demands or other communications hereunder shall be given in
writing by, courier service, or email.</p>
<p><strong>13.3.</strong> This Agreement is entered into between the Parties on a
principal-to-principal basis and does not create any agency relationship between the Parties.
Hence, Tata Motors Commercial Vehicles shall not be held vicariously accountable for any
act/omission of the Customer.
Further, nothing in this Agreement shall create any relationship of any kind such as association,
partnership, franchise, joint venture or relationships of principal-agent or master and servant,
affiliate or subsidiary, or employer and employee or fiduciary relationship. Neither Party shall
enter into any commitments, undertakings or agreements purporting to obligate such other Party in
any way, or amend, modify or vary any existing agreements to which such other Party may be a
party.</p>
<p><strong>13.4.</strong> The Service Stations have agreements with Tata Motors Commercial Vehicles
on a
principal-to-principal basis meaning that Tata Motors Commercial Vehicles shall not be held
vicariously accountable
for any act/omission of the Service Stations or their Manpower or executives stationed at the Site
for discharging any of the services under this Agreement. Tata Motors Commercial Vehicles, though,
shall ensure
satisfactory discharge of the services under this Agreement for the Customer either directly or
through the Service Stations. Notwithstanding anything in this Agreement, Tata Motors Commercial
Vehicles shall not be
bound by any act/omission/commitment of the Service Stations or their Manpower/executives beyond
the discharge of service obligations under this Agreement. Tata Motors Commercial Vehicles shall
have the exclusive
right to change or replace the Service Station or their Manpower/executives deployed for the
Customer to discharge the services under this Agreement at any point of time without prior
intimation to either party. Merely for the reason that the Manpower/executives shall be deployed
by the Service Stations at your Site, there shall not be any employee-employer relationship
created between Tata Motors Commercial Vehicles and such Manpower/executives. The Service Stations
shall continue to
be the exclusive employers of their Manpower/executives at all times. The Manpower/executives
shall work/operate at your Site under the direct supervision and control of their
employers/Service Stations.</p>
<p><strong>13.5.</strong> In the event of any conflict or inconsistency between the provisions of
the Annexures and this Agreement, the provisions contained in this Agreement shall prevail to the
extent of such conflict or inconsistency.</p>
<p><strong>13.6.</strong> You shall not have the right, power, or authority to assign the Agreement
or any of its rights or obligations hereunder to any third party without the prior written consent
of Tata Motors Commercial Vehicles.</p>
<p><strong>13.7.</strong> No failure by Tata Motors Commercial Vehicles hereto to exercise and no
delay in exercising
any right hereunder shall operate as a waiver thereof by Tata Motors Commercial Vehicles.</p>
<p><strong>13.8.</strong> This Agreement including its Annexures attached hereto and any amendments
hereof, sets forth in the entire agreement and understanding between the Parties and supersede and
override all prior communications, discussions, understandings, negotiations, commitments, or any
prior or contemporaneous agreements, express or implied, written, or oral, between them with
respect to the subject matter hereof.</p>
<p><strong>13.9.</strong> If any part of this Agreement is deemed invalid, void, or for any reason
unenforceable, that part of the Agreement will be deemed severable and will not affect the
validity and enforceability of any remaining part of this Agreement.</p>
<p><strong>13.10.</strong> All rights and remedies of the Parties herein shall be in addition to all
other rights and remedies available under law or in equity, including, without limitation,
specific performance, and temporary and permanent injunctive relief.</p>
<p><strong>13.11.</strong> Tata Motors Commercial Vehicles reserves its right to amend the scope and
the terms of the
Agreement at any time.</p>
<p><strong>13.12.</strong> Nothing in this Agreement shall create any rights in any person other
than the Parties hereto.</p>
<p>By signing/executing the CIF you have agreed to these general terms and conditions and the
Agreement shall be binding on you.</p>
</div>
</div>
<div class="row">
  <div class="col-12 col-md-12">
    <h4 class="infotitle text-align-center" style="text-align: center;">Annexure 1 – List of Vehicles
    </h4>
    <h5 class="text-align-center" style="text-align: center;">Contract Summary - Vehicle Maintenance
      Services / Suraksha Scheme
    </h5>
  </div>
  <div class="row">
    <div class="table-responsive text-nowrap table-paymentcustm fixed-table">
      <table class="table table-bordered">
        <thead class="table-header">
          <tr class="table-primary">
            <th class="table-header">Sr.No</th>
            <th class="table-header">Chassis No.</th>
            <th class="table-header">Registration No.</th>
            <th class="table-header">Contract No.</th>
            <th class="table-header">Vehicle Sale Date</th>
            <th class="table-header">
              Start {{showFormattext}}
            </th>
            <th class="table-header">
              End {{showFormattext}}
            </th>
            <th class="table-header">Start Date</th>
            <th class="table-header">End Date</th>
          </tr>
        </thead>
        <tbody>
          @for (res of cifDetails?.all_chassis_contracts; track res; let i = $index) {
            <tr>
              <td class="table-data">{{ i + 1 }}</td> <!-- Dynamically add Sr. No -->
              <td class="table-data">{{ res.chassis_number }}</td>
              <td class="table-data">{{ res.registration_number }}</td>
              <td class="table-data">{{ res.contract_number }}</td>
              <td class="table-data">{{ res.sale_date | date:"dd-MMM-yy" }}</td>
              <td class="table-data">{{ res.start_kms_or_hrs | number : "1.0-0" }}</td>
              <td class="table-data">{{ res.end_kms_or_hrs | number : "1.0-0" }}</td>
              <td class="table-data">{{ res.start_date | date:"dd-MMM-yy" }}</td>
              <td class="table-data">{{ res.end_date | date:"dd-MMM-yy" }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
<br />
<div class="mt-4">
  <p><strong>Note:</strong></p>
  <ul>
    <li>
      <p>
        Usage Parameter may mean kilometers, engine hours, operating hours, battery operating hours or
        such other parameter specified by Tata Motors Commercial Vehicles for the relevant vehicle
        model.
      </p>
    </li>
    <li>
      <p>Kms shall be applicable only in case of the vehicle(s) having scheduled services defined in
        terms
      of kilometers. Please refer the owner's service book of your vehicle(s) for further details.</p>
    </li>
    <li>
      <p>Hrs shall be applicable only in case of the vehicle(s) having scheduled services defined in
        terms
        of hours of operation, eg. tippers. Please refer the owner's service book of your vehicle(s) for
      further details.</p>
    </li>
    <li>
      <p>Contract Value = The total cost of VAS after adjusting the applicable discounts which is
      finally paid by the Customer.</p>
    </li>
  </ul>
</div>
<div class="col-12 col-md-12">
  <hr />
</div>
@if (cifDetails?.payment_details?.payment_mode === 'EMI' && cifDetails?.emi_plan_details.length > 0) {
  <div class="row"
    >
    <div class="col-12 col-md-12">
      <h4 class="infotitle text-align-center" style="text-align: center;">Billing Plan
      </h4>
    </div>
    @if (cifDetails?.order_details?.is_group_order === false) {
      <div class="row">
        <div class="table-responsive text-nowrap table-paymentcustm fixed-table">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Sr.No</th>
                <th>From Period</th>
                <th>To Period</th>
                <th>Due Date</th>
                <th>Amt</th>
                @if (cifDetails?.emi_plan_details[0]?.igst_amount > 0) {
                  <th>IGST</th>
                }
                @if (cifDetails?.emi_plan_details[0]?.cgst_amount > 0) {
                  <th>CGST</th>
                }
                @if (cifDetails?.emi_plan_details[0]?.ugst_amount > 0) {
                  <th>UTGST</th>
                }
                @if (cifDetails?.emi_plan_details[0]?.sgst_amount > 0) {
                  <th>SGST</th>
                }
                <th>TDS</th>
                <th>Amt (Incl. Tax)</th>
              </tr>
            </thead>
            <tbody>
              @for (res of cifDetails?.emi_plan_details; track res; let i = $index) {
                <tr>
                  <td>{{ i + 1 }}</td>
                  <td>{{ res?.from_date | date : "dd-MMM-yy"}}</td>
                  <td>{{ res?.to_date | date : "dd-MMM-yy"}}</td>
                  <td>{{ res?.payment_due_date | date : "dd-MMM-yy"}}</td>
                  <td>₹{{ res.billing_value | number : "1.2-2" }}</td>
                  @if (res.igst_amount > 0) {
                    <td>₹{{ res.igst_amount | number : "1.2-2" }}</td>
                  }
                  @if (res.cgst_amount > 0) {
                    <td>₹{{ res.cgst_amount | number : "1.2-2" }}</td>
                  }
                  @if (res.ugst_amount > 0) {
                    <td>₹{{ res.ugst_amount | number : "1.2-2" }}</td>
                  }
                  @if (res.sgst_amount > 0) {
                    <td>₹{{ res.sgst_amount | number : "1.2-2" }}</td>
                  }
                  <td>
                    @if (cifDetails?.customer_details?.opted_for_tds==false) {
                      <span>
                        -
                      </span>
                    }
                    @if (cifDetails?.customer_details?.opted_for_tds) {
                      <span>
                        ₹ {{
                        res.tds_amount
                        | number : "1.2-2"
                        }}
                      </span>
                    }
                  </td>
                  <td>₹{{ res.payment_amount | number : "1.2-2" }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }
    @if (cifDetails?.order_details?.is_group_order) {
      <div class="row">
        @for (chassis of cifDetails?.chassis_wise_emi_plan_details; track chassis?.chassis_number) {
          <div class="mb-3">
            <h5 class="text-align-center">
              <strong>{{ chassis?.chassis_number }}</strong>
            </h5>
            <div class="table-responsive text-nowrap table-paymentcustm fixed-table">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Sr.No</th>
                    <th>From Period</th>
                    <th>To Period</th>
                    <th>Due Date</th>
                    <th>Amt</th>
                    @if (chassis?.emi_plan_details[0]?.igst_amount > 0) {
                      <th>IGST</th>
                    }
                    @if (chassis?.emi_plan_details[0]?.cgst_amount > 0) {
                      <th>CGST</th>
                    }
                    @if (chassis?.emi_plan_details[0]?.ugst_amount > 0) {
                      <th>UTGST</th>
                    }
                    @if (chassis?.emi_plan_details[0]?.sgst_amount > 0) {
                      <th>SGST</th>
                    }
                    <th>TDS</th>
                    <th>Amt (Incl. Tax)</th>
                  </tr>
                </thead>
                <tbody>
                  @for (res of chassis?.emi_plan_details; track res; let i = $index) {
                    <tr>
                      <td>{{ i + 1 }}</td>
                      <td>{{ res?.from_date | date : "dd-MMM-yy"}}</td>
                      <td>{{ res?.to_date | date : "dd-MMM-yy"}}</td>
                      <td>{{ res?.payment_due_date | date : "dd-MMM-yy"}}</td>
                      <td>₹{{ res.billing_value | number : "1.2-2" }}</td>
                      @if (res.igst_amount > 0) {
                        <td>₹{{ res.igst_amount | number : "1.2-2" }}</td>
                      }
                      @if (res.cgst_amount > 0) {
                        <td>₹{{ res.cgst_amount | number : "1.2-2" }}</td>
                      }
                      @if (res.ugst_amount > 0) {
                        <td>₹{{ res.ugst_amount | number : "1.2-2" }}</td>
                      }
                      @if (res.sgst_amount > 0) {
                        <td>₹{{ res.sgst_amount | number : "1.2-2" }}</td>
                      }
                      <td>
                        @if (!cifDetails?.customer_details?.opted_for_tds) {
                          <span>-</span>
                        }
                        @if (cifDetails?.customer_details?.opted_for_tds) {
                          <span>
                            ₹{{ res.tds_amount | number : "1.2-2" }}
                          </span>
                        }
                      </td>
                      <td>₹{{ res.payment_amount | number : "1.2-2" }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
      </div>
    }
  </div>
}
@if (cifDetails?.payment_details?.payment_mode === 'EMI' && cifDetails?.emi_plan_details.length > 0) {
  <div class="emt"
    >
  * Excl. Taxes</div>
}
<div>
  <div class="annexure-table" style="margin-top: 20px;">
    @if (cifDetails?.amc_details?.service_product_type === 'AMC') {
      <div>
        <div class="col-12 col-md-12">
          <h4 class="infotitle text-align-center" style="text-align: center;">Annexure 2 - Annual
            Maintenance Contract (AMC) Coverage
            <!-- <span *ngIf="cifDetails?.amc_details?.service_product_type === 'AMC'">A</span>
            <span *ngIf="cifDetails?.amc_details?.service_product_type === 'EW'">B</span>
            <span *ngIf="cifDetails?.amc_details?.service_product_type === 'FMS'">C</span> -->
          </h4>
        </div>
        <h5 class="text-align-center" style="text-align: center;">Annual Maintenance Contract (AMC)
          Coverage - HCV, ILMCV, CV Passenger, Vans & SCV C PU - BS6
        Phase II </h5>
        <!-- <div class="container my-2"> -->
        <div class="my-2">
          <div class="table-responsive">
            <table class="">
              <thead style="background: rgba(241, 241, 241, 1);">
                <tr>
                  <th style="background: rgba(241, 241, 241, 1);padding:15px 0px;color: black;">Part
                  Description</th>
                  <th
                    style="background: rgba(241, 241, 241, 1);padding:15px 0px;color: black;width: 10%;">
                  Silver</th>
                  <th
                    style="background: rgba(241, 241, 241, 1);padding:15px 0px;color: black;width: 10%;">
                  Silver Plus</th>
                  <th
                    style="background: rgba(241, 241, 241, 1);padding:15px 0px;color: black;width: 10%;">
                  Gold Plus</th>
                  <th
                    style="background: rgba(241, 241, 241, 1);padding:15px 0px;color: black;width: 10%;">
                  Platinum</th>
                  <th
                    style="background: rgba(241, 241, 241, 1);padding:15px 0px;color: black;width: 10%;">
                  Platinum Plus</th>
                  <th
                    style="background: rgba(241, 241, 241, 1);padding:15px 0px;color: black;width: 10%;">
                  Applicability</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                                <td colspan="7" style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;
                              color: black;">
                    Lubricants (Applicable as per recommended in OSB / Service circular)
                  </td>
                </tr>
                <!-- Lubricants -->
                <tr>
                  <td class="left-align">Engine Oil</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>All LOBs</td>
                </tr>
                <tr>
                  <td class="left-align">Gear Box Oil</td>
                  <td>Y</td>
                  <td>N</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>All LOBs</td>
                </tr>
                <tr>
                  <td class="left-align">Rear Axle Oil</td>
                  <td>Y</td>
                  <td>N</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>All LOBs</td>
                </tr>
                <tr>
                  <td class="left-align">Clutch & Brake Fluid</td>
                  <td>Y</td>
                  <td>N</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>All LOBs</td>
                </tr>
                <tr>
                  <td class="left-align">Hub Grease</td>
                  <td>Y</td>
                  <td>N</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>All LOBs</td>
                </tr>
                <tr>
                  <td class="left-align">Power Steering Oil </td>
                  <td>Y</td>
                  <td>N</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>All LOBs</td>
                </tr>
                <tr>
                  <td class="left-align">Coolant</td>
                  <td>Y</td>
                  <td>N</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>All LOBs</td>
                </tr>
                <tr>
                  <td class="left-align">Cab tilt oil (if applicable)</td>
                  <td>Y</td>
                  <td>N</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>All LOBs</td>
                </tr>
                <tr>
                  <td class="left-align">Retarder oil (if applicable)</td>
                  <td>Y</td>
                  <td>N</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>CV Passenger</td>
                </tr>
                <tr>
                  <td class="left-align">Tipping oil (if applicable)</td>
                  <td>Y</td>
                  <td>N</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>HCV & ILMCV</td>
                </tr>
                <tr>
                  <td class="left-align">Top ups - Engine Oil & Coolant</td>
                  <td>N</td>
                  <td>N</td>
                  <td>N</td>
                  <td>N</td>
                  <td>N</td>
                  <td>All LOBs</td>
                </tr>
                <tr>
                  <td colspan="7"
                    style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                    Consumables (Applicable as per recommended in OSB / Service circular)
                  </td>
                </tr>
                <!-- Lubricants -->
                <tr>
                  <td class="left-align">Fuel Water Separator (If Applicable)</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>All LOBs</td>
                </tr>
                <tr>
                  <td class="left-align">Fuel Filter (Primary & Main)</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>All LOBs</td>
                </tr>
                <tr>
                  <td class="left-align">Engine Oil Filter</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>All LOBs</td>
                </tr>
                <tr>
                  <td class="left-align">Oil Mist Separator Filter <strong><sub>1</sub></strong></td>
                  <td>Y</td>
                  <td>N</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>All LOBs</td>
                </tr>
                <tr>
                  <td class="left-align">Filter - Breather Crankcase <strong><sub>2</sub></strong></td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>Y</td>
                  <td>All LOBs</td>
                </tr>
                <tr>
                  <td class="left-align">Primary Air Filter <strong><sub>3</sub></strong> (Only on RED
                  band
                indication)</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Secondary Air Filter at every 3rd replacement of primary
                  filter<strong><sub>4</sub></strong>
                </td>
                <td>Y</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Hub Greasing & Kit <strong><sub>5</sub></strong></td>
                <td>Y</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Desiccant Cartridge</td>
                <td>Y</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Power Steering Oil Filter</td>
                <td>Y</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Clutch Master Cylinder Kit <strong><sub>6</sub></strong></td>
                <td>Y</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Clutch Booster Repair Kit <strong><sub>6</sub></strong></td>
                <td>Y</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Cleaning material (Cotton) <strong><sub>7</sub></strong></td>
                <td>Y</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Anabond for Rear axle</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td colspan="7"
                  style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                  SCR System (Applicable as per recommended in OSB / Service circular)
                </td>
              </tr>
              <!-- Lubricants -->
              <tr>
                <td class="left-align">Suction Side Screen Filter DEF Suction Port
                  <strong><sub>8</sub></strong>
                </td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">DEF Tank (UL 2.2) Filter</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Supply Unit (SU) DEF Filter kit</td>
                <td>Y</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">DPF Ash cleaning (Labor Only)</td>
                <td>Y</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>HCV,ILMCV & CVP</td>
              </tr>
              <tr>
                <td colspan="7"
                  style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                  Engine
                </td>
              </tr>
              <!-- Lubricants -->
              <tr>
                <td class="left-align">Engine Assembly (Long Block Prolife)</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Cylinder Head</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Cylinder Block</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Crank Shaft</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Cam Shaft</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Engine Head Gasket</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Water Pump</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Oil Pump</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Oil Cooler</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Flywheel Housing</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Turbocharger</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Oil Seal</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Viscous Fan</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Air Compressor</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Timing Belt & Tensioner</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>SCV C PU</td>
              </tr>
              <tr>
                <td class="left-align">Fan Belt</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Engine kit bearings</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Water Hoses</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Radiator & Mountings</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Engine mounting</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Module Electronic Control Unit (Engine ECU)</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Thermostat</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">EGR Valve <strong><sub>9</sub></strong></td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Exhaust Throttle Valve (ETV) <strong><sub>10</sub></strong></td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Air-Fuel Throttle Value (AFTV) / Intake Air Throttle Valve</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">EGR Cooler <strong><sub>9</sub></strong></td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Fan Shroud</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td colspan="7"
                  style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                  Fuel System
                </td>
              </tr>
              <!-- Lubricants -->
              <tr>
                <td class="left-align">Fuel Injection Pump (FIP)</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Common Rail Injectors</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Fuel Rail</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Fuel pipes Hoses</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td colspan="7"
                  style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                  Clutch System
                </td>
              </tr>
              <!-- Lubricants -->
              <tr>
                <td class="left-align">Flywheel</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Clutch Disc</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Pressure Plate</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Clutch Release Bearing</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Clutch Housing</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Clutch Fork</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Clutch Booster</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Clutch Master/Slave Cylinder</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td colspan="7"
                  style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                  Gear Box
                </td>
              </tr>
              <tr>
                <td class="left-align">Gear Housing</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Main / Counter Shaft</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Main / Counter Gear</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Synchro Ring Cone</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Shifter Shaft</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Thrust Bearing</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Gear Lever Bush</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">PTO (if applicable)</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Shifter Cable</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Drive Shaft</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td class="left-align">Bearings</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <!-- Lubricants -->
              <tr>
                <td colspan="7"
                  style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                  Propeller Shaft
                </td>
              </tr>
              <tr>
                <td style="text-align: left;">Propeller Shaft</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Yoke Teeth</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">CJ Bearing</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">UJ Cross</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">CB Rubber</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Joint Flange</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td colspan="7"
                  style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                  Steering System
                </td>
              </tr>
              <tr>
                <td style="text-align: left;">Steering Gear Box</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Steering Pump</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Steering Column</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Ball Joint (RH & LH)</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Drag Link & Pitman Arm</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Steering Column Support</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Steering Wheel</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Steering Oil Container</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td colspan="7"
                  style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                  Rear Axle
                </td>
              </tr>
              <tr>
                <td style="text-align: left;">Crown Wheel Pinion (CWP)</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Pinion Oil Seal</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Bevel Gear</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Oil Seals</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Brake Chamber</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Differential Side Gear/ Differential Pinion</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Wheel Bearing</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Inter Axle Shaft</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Rear Axle Beam</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Assembly Carrier Housing (In Banjo Type)</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Non-live Rear Axle/Dummy Axle</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Winger</td>
              </tr>
              <tr>
                <td style="text-align: left;">Hub Bolts</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td colspan="7"
                  style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                  Front Axle
                </td>
              </tr>
              <tr>
                <td style="text-align: left;">King Pin & King Pin Bush</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Oil Seals</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Stub Axle</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Shims</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Wheel Bearing</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Tie Rod</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Front Axle I-Beam</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Hub Bolts</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td colspan="7"
                  style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                  Lift Axle
                </td>
              </tr>
              <tr>
                <td style="text-align: left;">Lift Axle Control Valve</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Load Sensing Valve</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Air Bellow</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Lift Axle Beam/Hanger/Brackets & Arms</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Hub Bolts</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td colspan="7"
                  style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                  Brake System
                </td>
              </tr>
              <tr>
                <td style="text-align: left;">Front and Rear Wheel Cylinder Kit</td>
                <td>Y</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>SCV C PU</td>
              </tr>
              <tr>
                <td style="text-align: left;">Master & Slave Cylinders</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Brake Drum</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Brake Shoe & Lining</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Brake Valves</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Brake Actuators</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Slack Adjuster</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Brake Ducting & Pipes</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Vacuum Brakes</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">Engine Brakes</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">ABS Unit (ECU)</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td colspan="7"
                  style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                  ATS Systems
                </td>
              </tr>
              <tr>
                <td style="text-align: left;">DEF PUMP <strong><sub>11</sub></strong> </td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">DOSING UNIT INJECTOR <strong><sub>11</sub></strong> </td>
                <td>N</td>
                <td>N</td>
                <td>N</td>
                <td>Y</td>
                <td>Y</td>
                <td>All LOBs</td>
              </tr>
              <tr>
                <td style="text-align: left;">ATS Sensors <strong><sub>11</sub></strong> (NOx,
                Temperature, Urea Quality, Urea Level,
              PFM)</td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>Y</td>
              <td>Y</td>
              <td>All LOBs</td>
            </tr>
            <tr>
              <td style="text-align: left;">DP Sensor Pipe <strong><sub>11</sub></strong> </td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>Y</td>
              <td>Y</td>
              <td>All LOBs</td>
            </tr>
            <tr>
              <td style="text-align: left;">SCR MODULE</td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>Y</td>
              <td>All LOBs</td>
            </tr>
            <tr>
              <td style="text-align: left;">DOC MODULE</td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>Y</td>
              <td>All LOBs</td>
            </tr>
            <tr>
              <td style="text-align: left;">DPF MODULE</td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>Y</td>
              <td>All LOBs</td>
            </tr>
            <tr>
              <td style="text-align: left;">SCR Mixer</td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>Y</td>
              <td>All LOBs</td>
            </tr>
            <tr>
              <td style="text-align: left;">CLAMP ASSY V BAND</td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>All LOBs</td>
            </tr>
            <tr>
              <td style="text-align: left;">Exhaust pipe & Bellow, Muffler</td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>All LOBs</td>
            </tr>
            <tr>
              <td style="text-align: left;">DEF Tank float unit</td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>All LOBs</td>
            </tr>
            <tr>
              <td style="text-align: left;">LNT & CDPF</td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>Y</td>
              <td>SCV</td>
            </tr>
            <tr>
              <td colspan="7"
                style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                Electricals
              </td>
            </tr>
            <tr>
              <td style="text-align: left;">Alternator</td>
              <td>N</td>
              <td>N</td>
              <td>Y</td>
              <td>Y</td>
              <td>Y</td>
              <td>All LOBs</td>
            </tr>
            <tr>
              <td style="text-align: left;">Starter motor</td>
              <td>N</td>
              <td>N</td>
              <td>Y</td>
              <td>Y</td>
              <td>Y</td>
              <td>All LOBs</td>
            </tr>
            <tr>
              <td style="text-align: left;">Instrument cluster</td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>Y</td>
              <td>Y</td>
              <td>All LOBs</td>
            </tr>
            <tr>
              <td style="text-align: left;">Wiring Harness (Engine & Injector)</td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>Y</td>
              <td>Y</td>
              <td>All LOBs</td>
            </tr>
            <tr>
              <td style="text-align: left;">Wiper Motor</td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>Y</td>
              <td>Y</td>
              <td>All LOBs</td>
            </tr>
            <tr>
              <td style="text-align: left;">All Sensors</td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>Y</td>
              <td>Y</td>
              <td>All LOBs</td>
            </tr>
            <tr>
              <td style="text-align: left;">Combination Switch</td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>Y</td>
              <td>Y</td>
              <td>All LOBs</td>
            </tr>
            <tr>
              <td style="text-align: left;">Accelerator pedal</td>
              <td>N</td>
              <td>N</td>
              <td>N</td>
              <td>Y</td>
              <td>Y</td>
              <td>All LOBs</td>
            </tr>
            <tr>
              <td style="text-align: left;">Wiring Harness <strong><sub>12</sub></strong>
            (Chassis-Front/Rear/ABS/Tail)</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>Y</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">Wiring Harness (SCR)</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>Y</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">Wiring Harness (Dashboard)</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>Y</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">Vehicle ECU/ZDCU/GDCU</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">AC Compressor, Condenser & parts related to AC unit</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">Telematics Control Unit</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">Batteries, including battery cables, Wiring harness,
              cut-off
            switch</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">OE – Bulbs (Head & Tail lamp)/ Fuse & Relays</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td colspan="7"
              style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
              Aggregates Overhauling
            </td>
          </tr>
          <tr>
            <td style="text-align: left;">Engine</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">Gear Box</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">Differential</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td colspan="7"
              style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
              Suspension System
            </td>
          </tr>
          <tr>
            <td style="text-align: left;">Leaf Spring, Shackles, Hanger, Shock absorbers, bushes,
              Air
            spring/Air bellow, Anti Roll Bars, U Bolts etc.</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td colspan="7"
              style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
              Body items
            </td>
          </tr>
          <tr>
            <td style="text-align: left;">Cab/ Cowl (OE) - Body items such as door handles, steering
              wheel, wiper arm and blades, upholstery items (including driver's seat, door locks,
            winding mechanism, etc.)</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">Chassis Frame</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">Fifth wheel coupling</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">Load Body</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">Paints</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">Chassis/tipper Sub frame</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">Tipping Cylinder/ Tank</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td colspan="7"
              style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
              Glass
            </td>
          </tr>
          <tr>
            <td style="text-align: left;">All glass items including Windshield glass</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td colspan="7"
              style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
              Sheet Metal Items & Tanks
            </td>
          </tr>
          <tr>
            <td style="text-align: left;">Sheet Metal items (like fuel tank, air tank, hydraulic oil
              tank, si
              tank, silencer pipes, muffler, catalytic converter) & plastic coolant tank, DEF Tank
            </td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td colspan="7"
              style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
              Tires & Wheels
            </td>
          </tr>
          <tr>
            <td style="text-align: left;">Tires, Wheel rims, Wheel Bolts, Discs </td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td colspan="7"
              style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
              Wheel Alignment
            </td>
          </tr>
          <tr>
            <td style="text-align: left;">Wheel Alignment & Tyre Rotation</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td colspan="7"
              style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
              Hydraulics (OE fitment)- Only for Construck range of vehicles
              *Change of oil/filters as per schedule in OSB/Latest service circulars only
            </td>
          </tr>
          <tr>
            <td style="text-align: left;">Hydraulic Oil</td>
            <td>Y</td>
            <td>N</td>
            <td>Y</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">Breather Filter element</td>
            <td>Y</td>
            <td>Y</td>
            <td>Y</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">Return Line Filter element</td>
            <td>Y</td>
            <td>Y</td>
            <td>Y</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">Hydraulic oil Filter</td>
            <td>Y</td>
            <td>N</td>
            <td>Y</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">Axial Piston Pump / Gear Pump</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">Hydraulic Piping</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">Hydraulic Cylinder</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">Oil level Gauge</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">Metallic Strainer</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">Linear Spool Valve</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">Tipping Valve Assembly</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td colspan="7"
              style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
              Fasteners
            </td>
          </tr>
          <tr>
            <td style="text-align: left;">Bolt, Nut, Clamp, Screw, Washer, Plug etc. such items will
              be selectively covered based on component/assembly coverage and as defined in the
            coverage </td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td colspan="7"
              style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
              Predefined Preventive Maintenance
            </td>
          </tr>
          <tr>
            <td style="text-align: left;">Vehicle washing (&#64; Schedule Services only)</td>
            <td>Y</td>
            <td>Y</td>
            <td>Y</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">Inspection (Daily/Monthly/Weekly/Fortnightly/Yearly)</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">Greasing</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td style="text-align: left;">Torqueing</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td colspan="7"
              style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
              Towing Services
            </td>
          </tr>
          <tr>
            <td style="text-align: left;">Towing Services </td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td colspan="7"
              style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
              Breakdown assistance
            </td>
          </tr>
          <tr>
            <td style="text-align: left;">Complaint attended en-route in case of breakdown
              <strong><sup>13</sup></strong>
            </td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs</td>
          </tr>
          <tr>
            <td colspan="7"
              style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
              CNG & Bi-Fuel Components
            </td>
          </tr>
          <tr>
            <td style="text-align: left;">Low Pressure Hose</td>
            <td>Y</td>
            <td>N</td>
            <td>Y</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs CNG</td>
          </tr>
          <tr>
            <td style="text-align: left;">Spark plug</td>
            <td>Y</td>
            <td>N</td>
            <td>Y</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs CNG</td>
          </tr>
          <tr>
            <td style="text-align: left;">CYLINDER VALVE/ITVR</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs CNG</td>
          </tr>
          <tr>
            <td style="text-align: left;">High Pressure Regulator Valve</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs CNG</td>
          </tr>
          <tr>
            <td style="text-align: left;">Solenoid Valve</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs CNG</td>
          </tr>
          <tr>
            <td style="text-align: left;">Catalytic Converter and GPF</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>Y</td>
            <td>All LOBs CNG</td>
          </tr>
          <tr>
            <td style="text-align: left;">HP Tube/ HP Pipe</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs CNG</td>
          </tr>
          <tr>
            <td style="text-align: left;">Connector</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs CNG</td>
          </tr>
          <tr>
            <td style="text-align: left;">CIGAR Coil/Ignition Coil</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs CNG</td>
          </tr>
          <tr>
            <td style="text-align: left;">2-WAY ISOLATION VALVE</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs CNG</td>
          </tr>
          <tr>
            <td style="text-align: left;">Lambda Sensor <strong><sub>14</sub></strong> </td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>Y</td>
            <td>Y</td>
            <td>All LOBs CNG</td>
          </tr>
          <tr>
            <td style="text-align: left;">FILLING RECEPTACLE ASSY</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>All LOBs CNG</td>
          </tr>
          <tr>
            <td style="text-align: left;">PRESSURE GAUGE</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>All LOBs CNG</td>
          </tr>
          <tr>
            <td style="text-align: left;">CYLINDER</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>N</td>
            <td>All LOBs CNG</td>
          </tr>
          <tr>
            <td colspan="7" class="left-align">
              <strong>Legend = N : Not Covered, Y : Covered, <br /> LOBs : HCV,
                ILMCV, CV Passenger,
              Vans, SCV C PU (ICE Vehicles) </strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <!-- Additional Notes and Contact Details -->
  <div style="border: 1px solid black; padding: 10px; margin-top: 20px;">
    <p><strong>Applicability : </strong></p>
    <ol type="1">
      <li>Applicable for 5 Ltrs. Engine (Tata Turbotronn)</li>
      <li>Applicable for Cummins Engines</li>
      <li>
        Primary Air Filter -
        <ol type="a">
          <li>For SCV as per OSB</li>
          <li>For HCV &amp; ILMCV Truck, MCV Bus at every schedule service</li>
          <li>In-between Schedule Service, air filter replacement will require RED band
          indication/Cluster indicator (Applicable for Platinum &amp; Above packages)</li>
          <li>In-between Schedule Service, air filter replacement is not covered in Silver, Gold
          plus package</li>
        </ol>
      </li>
      <li>Secondary filter not applicable for SCV Passenger &amp; SCV C PU.</li>
      <li>Not Applicable for THU fitted axles.</li>
      <li>Applicable as per recommended in OSB / Service circular.</li>
      <li>AMC MISC Items - Cotton waste, diesel etc. Used during schedule service only</li>
      <li>As and when required.</li>
      <li>Applicable for 5 Ltrs. Engine (Tata Turbotron)</li>
      <li>Applicable for ILCV, CV Passenger for BS6 Phase 2 vehicles. Not covered under Platinum
      pack for ILCV, CV Passenger &amp; SCV C PU (BS6 Phase 1)</li>
      <li>Not covered for ILCV Truck, SCV Passenger, Vans SCV C PU in Platinum Pack</li>
      <li>Wiring not mentioned in coverage will not be covered</li>
      <li>Applicable only Breakdown due to component covered in contract only &amp; incase vehicle
      of vehicle immovable</li>
      <li>Not covered for ILCV Truck, SCV Passenger, SCV C PU</li>
      <li>Silver Plus Package is applicable for 5.6 &amp; 6.7 L HCV Cargo &amp; Construck vehicles
      only</li>
      <li>
        For HCV Cargo &amp; Construck vehicles with 5.6L &amp; 6.7L engine vehicle, the coverage for
        Silver Plus AMC is as below:
        <ol type="a">
          <li>Engine oil – Yes for 1st schedule service &#64; 1 yr/ 40k kms or 1yr/ 500 hours.</li>
          <li>Additional coverage for 1 yr/ 1 lac kms.</li>
        </ol>
      </li>
    </ol>
  </div>
  <table style="width:100%; margin-top:1px;">
    <tr>
      <td style="width:50%; text-align:left;">
        # This document is valid till further communication.
      </td>
      <td style="width:50%; text-align:left;">
        TML / CV / FleetCare / VAS / Rev. 02 / Date 01.09.2026
      </td>
    </tr>
  </table>
</div>
}
<!-- New code Start-->
<!-- Annexure 2 – Part B -->
@if (cifDetails?.amc_details?.service_product_type === 'FMS') {
  <div>
    @if (['1', '2', '3'].includes(cifDetails?.amc_details?.product_type_code)) {
      <div>
        <div class="annexure-table" style="margin-top: 20px;">
          <h4 class="infotitle text-align-center mb-4" style="text-align: center;">Annexure 2</h4>
          <h4>FLEET MANAGEMENT SOLUTIONS - HCV, ILMCV, CV Passenger, Vans & SCV C PU - BS6 Phase II
          </h4>
          <!-- <div class="container my-2"> -->
          <div class="my-2">
            <div class="table-responsive">
              <table class="">
                <thead style="background: rgba(241, 241, 241, 1);">
                  <tr>
                    <th style="background: rgba(241, 241, 241, 1);padding:15px 0px;color: black;">Part
                    Description</th>
                    <th
                      style="background: rgba(241, 241, 241, 1);padding:15px 0px;color: black;width: 10%;">
                    FMS- PACK 1</th>
                    <th
                      style="background: rgba(241, 241, 241, 1);padding:15px 0px;color: black;width: 10%;">
                    FMS- PACK 2</th>
                    <th
                      style="background: rgba(241, 241, 241, 1);padding:15px 0px;color: black;width: 10%;">
                    FMS- PACK 3</th>
                    <th
                      style="background: rgba(241, 241, 241, 1);padding:15px 0px;color: black;width: 10%;">
                    Applicability</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colspan="5"
                      style="background: rgba(48, 127, 226, 0.1); padding:10px 0px; color: black;">
                      Lubricants<br>(Applicable as per recommended in OSB / Service circular)
                    </td>
                  </tr>
                  <!-- Lubricants -->
                  <tr>
                    <td class="left-align">Engine Oil</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>All LOBs</td>
                  </tr>
                  <tr>
                    <td class="left-align">Gear Box Oil</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>All LOBs</td>
                  </tr>
                  <tr>
                    <td class="left-align">Rear Axle Oil</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>All LOBs</td>
                  </tr>
                  <tr>
                    <td class="left-align">Clutch &amp; Brake Fluid</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>All LOBs</td>
                  </tr>
                  <tr>
                    <td class="left-align">Hub Grease</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>All LOBs</td>
                  </tr>
                  <tr>
                    <td class="left-align">Power Steering Oil</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>All LOBs</td>
                  </tr>
                  <tr>
                    <td class="left-align">Coolant</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>All LOBs</td>
                  </tr>
                  <tr>
                    <td class="left-align">Top ups¹ - Engine Oil &amp; Coolant</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>All LOBs</td>
                  </tr>
                  <tr>
                    <td class="left-align">Cab tilt oil (if applicable)</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>All LOBs</td>
                  </tr>
                  <tr>
                    <td class="left-align">Retarder oil (if applicable)</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>CV Pass</td>
                  </tr>
                  <tr>
                    <td class="left-align">Tipping oil (if applicable)²</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>HCV &amp; ILMCV</td>
                  </tr>
                  <tr>
                    <td colspan="5"
                      style="background: rgba(48, 127, 226, 0.1); padding:10px 0px; color: black;">
                      Consumables (Applicable as per recommended in OSB / Service circular)
                    </td>
                  </tr>
                  <tr>
                    <td class="left-align">Fuel Water Separator</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>All LOBs</td>
                  </tr>
                  <tr>
                    <td class="left-align">Fuel Filter (Primary &amp; Main)</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>All LOBs</td>
                  </tr>
                  <tr>
                    <td class="left-align">Engine Oil Filter</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>All LOBs</td>
                  </tr>
                  <tr>
                    <td class="left-align">Oil Mist Separator Filter<sup>3</sup></td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>All LOBs</td>
                  </tr>
                  <tr>
                    <td class="left-align">Filter - Breather Crankcase <sup>4</sup></td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>All LOBs</td>
                  </tr>
                  <tr>
                    <td class="left-align">
                      <div>
                        Primary Air Filter <sup>5</sup>
                        <div style="font-size:11px;line-height:12px;">
                          (Only on RED band indication)
                        </div>
                      </div>
                    </td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>Y</td>
                    <td>All LOBs</td>
                  </tr>
                  <tr>
                    <td class="left-align">Secondary Air Filter at every 3rd replacement of primary
                      filter<sup>6</sup></td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Hub Greasing &amp; Kit<sup>7</sup></td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Clutch Master Cylinder Kit<sup>8</sup></td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Clutch Booster Repair Kit<sup>8</sup></td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Desiccant Cartridge</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Power Steering Oil Filter</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Anabond for Rear axle</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Cleaning material (Cotton)<sup>9</sup></td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td colspan="5"
                        style="background: rgba(48, 127, 226, 0.1); padding:10px 0px; color: black;">
                        SCR System<br>(Applicable as per recommended in OSB / Service circular)
                      </td>
                    </tr>
                    <tr>
                      <td class="left-align">Suction Side Screen Filter DEF Suction Port<sup>10</sup></td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">DEF Tank (UL 2.2) Filter</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Supply Unit (SU) DEF Filter kit</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">DPF Ash cleaning (Labor Only)</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>HCV,ILMCV &amp; CVP</td>
                    </tr>
                    <tr>
                      <td colspan="5"
                        style="background: rgba(48, 127, 226, 0.1); padding:10px 0px; color: black;">
                        Engine
                      </td>
                    </tr>
                    <tr>
                      <td class="left-align">Engine Assembly(Long Block Profile)</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Cylinder Head</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Cylinder Block</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Crank Shaft</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Cam Shaft</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Engine Head Gasket</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Water Pump</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Oil Pump</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Oil Cooler</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Flywheel Housing</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Turbocharger</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Oil Seal</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Viscous Fan</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Air Compressor</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Timing Belt &amp; Tensioner</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>SCVCPU</td>
                    </tr>
                    <tr>
                      <td class="left-align">Fan Belt</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Engine Kit Bearings</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Water Hoses</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Radiator &amp; Mountings</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Engine Mounting</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Module Electronic Control Unit(Engine ECU)</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Thermostat</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">EGR Cooler</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">EGR Valve</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Exhaust Throttle Valve(ETV)<sup>11</sup></td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Air-Fuel Throttle Valve(AFTV)/Intake Air Throttle Valve</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Fan Shroud</td>
                      <td>N</td>
                      <td>N</td>
                      <td>N</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td colspan="5"
                        style="background: rgba(48, 127, 226, 0.1); padding:10px 0px; color: black;">
                        Fuel System
                      </td>
                    </tr>
                    <tr>
                      <td class="left-align">Fuel Injection Pump(FIP)</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Common Rail Injectors</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Fuel Float Unit</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Fuel Rail</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Fuel Pipes Hoses</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td colspan="5"
                        style="background: rgba(48, 127, 226, 0.1); padding:10px 0px; color: black;">
                        Clutch System
                      </td>
                    </tr>
                    <tr>
                      <td class="left-align">Flywheel</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Clutch Disc</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Pressure Plate</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Clutch Release Bearing</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Clutch Housing</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Clutch Fork</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Clutch Booster</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Clutch Master/Slave Cylinder</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td colspan="5"
                        style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                        Gear Box
                      </td>
                    </tr>
                    <tr>
                      <td class="left-align">Gear Housing</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Main / Counter Shaft</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Main / Counter Gear</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Synchro Ring Cone</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Shifter Shaft</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Thrust Bearing</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Gear Lever Bush</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">PTO (if applicable)<sup>12</sup></td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Shifter Cable</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Drive Shaft</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td class="left-align">Bearings</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <!-- Lubricants -->
                    <tr>
                      <td colspan="5"
                        style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                        Propeller Shaft
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Propeller Shaft</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Yoke Teeth</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">CJ Bearing</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">UJ Cross</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">CB Rubber</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Joint Flange</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td colspan="5"
                        style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                        Steering System
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Steering Gear Box</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Steering Pump</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Steering Column</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Ball Joint (RH & LH)</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Drag Link & Pitman Arm</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Steering Column Support</td>
                      <td>N</td>
                      <td>N</td>
                      <td>N</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Steering Wheel</td>
                      <td>N</td>
                      <td>N</td>
                      <td>N</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Steering Oil Container</td>
                      <td>N</td>
                      <td>N</td>
                      <td>N</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td colspan="5"
                        style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                        Rear Axle
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Inter Axle Shaft</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Crown Wheel Pinion (CWP)</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Pinion Oil Seal</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Bevel Gear</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Oil Seals</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Assembly Carrier Housing (In Banjo Type)</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Differential Side Gear/ Differential Pinion</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Wheel Bearing</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Rear Axle Beam</td>
                      <td>N</td>
                      <td>N</td>
                      <td>N</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Non-live Rear Axle/Dummy Axle</td>
                      <td>N</td>
                      <td>N</td>
                      <td>N</td>
                      <td>Winger</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Hub Bolts</td>
                      <td>N</td>
                      <td>N</td>
                      <td>N</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td colspan="5"
                        style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                        Front Axle
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">King Pin & King Pin Bush</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Oil Seals</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Stub Axle</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Shims</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Wheel Bearing</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Tie Rod</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Front Axle I-Beam</td>
                      <td>N</td>
                      <td>N</td>
                      <td>N</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Hub Bolts</td>
                      <td>N</td>
                      <td>N</td>
                      <td>N</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td colspan="5"
                        style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                        Lift Axle
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Lift Axle Control Valve</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Load Sensing Valve</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Air Bellow</td>
                      <td>N</td>
                      <td>N</td>
                      <td>N</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Lift Axle Beam/Hanger/Bracket & Arms</td>
                      <td>N</td>
                      <td>N</td>
                      <td>N</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Hub Bolts</td>
                      <td>N</td>
                      <td>N</td>
                      <td>N</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td colspan="5"
                        style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                        Brake System
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Master & Slave Cylinders</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Brake Drum</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Slack Adjuster</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Brake Shoe & Lining</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Brake Ducting & Pipes</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Brake Valves</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Brake Actuators</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Vacuum Brakes</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Engine Brakes</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">Front and Rear Wheel Cylinder Kit</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>SCV C PU</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">DDU </td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">ABS Unit (ECU)</td>
                      <td>N</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td colspan="5"
                        style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                        ATS Systems
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">SCR MODULE</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">DOC MODULE</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">DPF MODULE</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">SCR Mixer</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>Y</td>
                      <td>All LOBs</td>
                    </tr>
                    <tr>
                      <tr>
                        <td style="text-align: left;">DEF PUMP</td>
                        <td>Y</td>
                        <td>Y</td>
                        <td>Y</td>
                        <td>All LOBs</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">DOSING UNIT INJECTOR </td>
                        <td>Y</td>
                        <td>Y</td>
                        <td>Y</td>
                        <td>All LOBs</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">ATS Sensors (NOx,
                          Temperature, Urea Quality, Urea Level,
                        PFM)</td>
                        <td>Y</td>
                        <td>Y</td>
                        <td>Y</td>
                        <td>All LOBs</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">DP Sensor Pipe </td>
                        <td>Y</td>
                        <td>Y</td>
                        <td>Y</td>
                        <td>All LOBs</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">DEF Tank float unit</td>
                        <td>Y</td>
                        <td>Y</td>
                        <td>Y</td>
                        <td>All LOBs</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">LNT & CDPF</td>
                        <td>Y</td>
                        <td>Y</td>
                        <td>Y</td>
                        <td>SCV</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">CLAMP ASSY V BAND</td>
                        <td>N</td>
                        <td>N</td>
                        <td>Y</td>
                        <td>All LOBs</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">Exhaust pipe & Bellow, Muffler</td>
                        <td>N</td>
                        <td>N</td>
                        <td>Y</td>
                        <td>All LOBs</td>
                      </tr>
                      <tr>
                        <td colspan="5"
                          style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                          Electricals
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">Alternator</td>
                        <td>Y</td>
                        <td>Y</td>
                        <td>Y</td>
                        <td>All LOBs</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">Starter motor</td>
                        <td>Y</td>
                        <td>Y</td>
                        <td>Y</td>
                        <td>All LOBs</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">Instrument cluster</td>
                        <td>Y</td>
                        <td>Y</td>
                        <td>Y</td>
                        <td>All LOBs</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">Wiring Harness (Engine &
                          Injector)<sup><small>(14)</small></sup></td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Wiring Harness (Chassis-Front/Rear/ABS/Tail)</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Wiring Harness (SCR)<sup>14</sup></td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Wiring Harness (Dashboard)<sup>14</sup></td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Wiper Motor</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">All Sensors</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Combination Switch</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Accelerator pedal</td>
                          <td>N</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Vehicle ECU/ZDCU/GDCU<sup>15</sup></td>
                          <td>N</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Batteries ,including battery cables, Wiring harness,
                          cut-off switch</td>
                          <td>N</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">OE - Bulbs (Head & Tail lamp)/ Fuse & Relays</td>
                          <td>N</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">CBCU(MULTIPLEX UNIT)<sub>16</sub></td>
                          <td>N</td>
                          <td>N</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">AC Compressor, Condenser & parts related to AC unit
                          </td>
                          <td>N</td>
                          <td>N</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Telematics Control Unit</td>
                          <td>N</td>
                          <td>N</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td colspan="5"
                            style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                            Aggregates Overhauling
                          </td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Engine</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Gear Box</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Differential</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td colspan="5"
                            style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                            Suspension System
                          </td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Leaf Spring, Shackles, Hanger, brackets, arms Shock
                          absorbers, bushes, Air spring/Air bellow, Anti Roll Bars, U Bolts etc</td>
                          <td>N</td>
                          <td>N</td>
                          <td>Y(Customized)</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td colspan="5"
                            style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                            Body items
                          </td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Cob/Cowl (OE) - Body items such as door
                            handles,<br>steering wheel,wiper arm and blades. upholstery items (including
                            driver's
                          seat, door locks, winding mechanism. etc.)</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Chassis Frame</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Pifth wheel coupling</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Lood Body</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Paints</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Cnassis/tipper Sub frame</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td colspan="5"
                            style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                            Glass
                          </td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">All glass items including Windshield glass</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td colspan="5"
                            style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                            Sheet Metal Items &amp; Tanks
                          </td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">
                            Sheet Metal items (like fuel tank, air tank, hydraulic oil tank,
                            silencer pipes, muffler, catalytic converter) & plastic coolant
                            tank, DEF Tank
                          </td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td colspan="5"
                            style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                            Tyres &amp; Wheels
                          </td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Tyres, Wheel rims, Wheel Bolts, Discs</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td colspan="5"
                            style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                            Wheel Alignment
                          </td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Wheel Alignment &amp; Tyre Rotation</td>
                          <td>N</td>
                          <td>N</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td colspan="5"
                            style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                            Hydraulics (OE fitment)- Only for Construck range of vehicles
                            *Change of oil/filters as per schedule in OSB/Latest service circulars only
                          </td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Hydraulic Oil</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Breather Filter element</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Return Line Filter element</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Hydraulic oil Filter</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Axial Piston Pump / Gear Pump</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Hydraulic Piping</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Hydraulic Cylinder</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Oil level Gauge</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Metallic Strainer</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Linear Spool Valve</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Tipping Valve Assembly</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td colspan="5"
                            style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                            Fasteners
                          </td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Bolt, Nut, Clamp, Screw, Washer, Plug etc. such items
                            will
                            be
                          selectively covered based on component/assembly coverage</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td colspan="5"
                            style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                            Predefined Preventive Maintenance
                          </td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">
                            1. Vehicle washing<br>
                            (<span style="font-size:12px;"> Schedule Services only</span>)
                          </td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">2. Greasing <span
                          style="font-size:12px;">(Quarterly)</span></td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">3. Torqueing<span
                          style="font-size:12px;">(Quarterly)</span></td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">
                            4. Inspection<br>
                            <span style="font-size:12px;">(Daily/Monthly/ Weekly/ Fortnightly/Yearly)</span>
                          </td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td colspan="5"
                            style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                            Towing Services
                          </td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Towing Services </td>
                          <td>N</td>
                          <td>N</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td colspan="5"
                            style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                            Breakdown assistance
                          </td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Complaint attended en-route in case of breakdown
                            <strong><sup>17</sup></strong>
                          </td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td colspan="5"
                            style="background: rgba(48, 127, 226, 0.1);padding:10px 0px;color: black;">
                            CNG & Bi-Fuel Components
                          </td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">CYLINDER VALVE/ITVR</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">High Pressure Regulator Valve</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Solenoid Valve</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Catalytic Converter and GPF</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">HP Tube/ HP Pipe</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Connector</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Low Pressure Hose</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">CIGAR Coil/Ignition Coil</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">2-WAY ISOLATION VALVE</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Spark plug</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">FILLING RECEPTACLE ASSY</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">PRESSURE GAUGE</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">CYLINDER</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td style="text-align: left;">Lambda Sensor <strong><sup>18</sup></strong> </td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>All LOBs</td>
                        </tr>
                        <tr>
                          <td colspan="5" class="left-align">
                            <strong>Legend = N : Not Covered, Y : Covered,<br />
                            LOBs : HCV, ILMCV, CV Passenger, SCV C PU </strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- Additional Notes and Contact Details -->
              <div>
                <div style="border: 1px solid black; padding: 10px; margin-top: 20px;">
                  <p><strong>Applicability :</strong></p>
                  <ol type="1">
                    <li>At Every 10000 KMs / 250 Engine Hrs.</li>
                    <li>Applicable for MHCV &amp; ILCV Construck Model.</li>
                    <li>Applicable for 5 Ltrs. Engine (Tata Turbotron).</li>
                    <li>Applicable for Cummins Engines.</li>
                    <li>
                      Primary Air Filter
                      <ol type="a">
                        <li>For SCV as per OSB.</li>
                        <li>For HCV &amp; ILMCV Truck, MCV Bus at every schedule service.</li>
                        <li>In-between Schedule Service, air filter replacement will require RED band
                        indication / Cluster indicator.</li>
                      </ol>
                    </li>
                    <li>Secondary filter not applicable for SCV C PU.</li>
                    <li>Not Applicable for THU fitted axles.</li>
                    <li>Applicable as per recommended in OSB / Service circular.</li>
                    <li>FMS MISC Items - Cotton waste, diesel etc. used during schedule service only.</li>
                    <li>As and when required.</li>
                    <li>Applicable for ILCV &amp; CV Passenger for BS6 Phase 2.</li>
                    <li>If Applicable, Tata Motors OE Fitted PTO.</li>
                    <li>Wiring not mentioned in coverage will not be covered.</li>
                    <li>GDCU part is applicable for SCV C PU and SCV Passenger.</li>
                    <li>Only Applicable for CV Passenger FBV.</li>
                    <li>
                      Breakdown due to component covered in contract only &amp; in case vehicle becomes
                      immovable.
                    </li>
                    <li>Not covered for ILCV Truck, SCV Passenger, SCV C PU.</li>
                  </ol>
                </div>
                <table style="width:100%; margin-top:1px;">
                  <tr>
                    <td style="width:50%; text-align:left;">
                      # This document is valid till further communication.
                    </td>
                    <td style="width:50%; text-align:left;">
                      TML / CV / FleetCare / VAS / Rev. 02 / Date 01.09.2026
                    </td>
                  </tr>
                </table>
              </div>
              <!-- <p><strong>Note:</strong> Replacement of filters (Air/ Fuel/ DEF etc.) will be done only as per
              scheduled interval or as recommended in OSB. No in between replacement will be
              done under all type of FMS.
            </p> -->
          </div>
        }
        @if (['4', '5'].includes(cifDetails?.amc_details?.product_type_code)) {
          <div>
            <h4 class="infotitle text-align-center mb-4" style="text-align: center;">Annexure 2</h4>
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th class="header-cell">S.N.</th>
                    <th class="header-cell">Description</th>
                    <th class="header-cell">FMS Pack-4<br>(Uptime Assurance)</th>
                    <th class="header-cell">FMS Pack-5<br>(Uptime Assurance + Mileage Assistance)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colspan="4" class="section-header">Scope of Services</td>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td class="left-align">Fuel Efficiency Management</td>
                    <td>N</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td class="left-align">Schedule service alerts & planning</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td class="left-align">Real time fault code monitoring</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td class="left-align">Breakdown management</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td class="left-align">Ticket management (Opening/ Monitoring/ Closing)</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td class="left-align">Prognostic diagnostics</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td class="left-align">Parts availability checking and guiding for vehicle reporting
                    </td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td class="left-align">Co-ordinatin with TMCVL authorized workshops</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td class="left-align">Monthly MIS report</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td class="left-align">Escalations to TMCVL personnel in case of any Technical
                    intervention required</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td colspan="4" class="section-header">Basic Aminities/ Infracture - Provided by
                      Customer
                    </td>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td class="left-align">Dedicated space with work table</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td class="left-align">Internet connection</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td class="left-align">Potable water & Electircity</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td class="left-align">Safety & First Aid arrangements</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td class="left-align">Big screen for ease of monitoring (Optional)</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td colspan="4" class="section-header">Work not in scope by Manpower deputed</td>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td colspan="3" class="left-align">Any other MIS apart from scope of Pack opted</td>
                    <!-- <td></td>
                    <td></td> -->
                  </tr>
                  <tr>
                    <td>2</td>
                    <td colspan="3" class="left-align">Additional vehicle monitoring other that signed
                    contract numbers</td>
                    <!-- <td></td>
                    <td></td> -->
                  </tr>
                  <tr>
                    <td>3</td>
                    <td colspan="3" class="left-align">Any addiontal day or work on National holidays.</td>
                    <!-- <td></td>
                    <td></td> -->
                  </tr>
                  <tr>
                    <td>4</td>
                    <td colspan="3" class="left-align"> Any technical support or advisory for repairs or
                      vehicle performance
                    </td>
                    <!-- <td></td>
                    <td></td> -->
                  </tr>
                  <tr>
                    <td>5</td>
                    <td colspan="3" class="left-align">Any other job which includes customer business
                    operaitons</td>
                    <!-- <td></td>
                    <td></td> -->
                  </tr>
                  <tr>
                    <td colspan="4" class="left-align">
                      <strong>Legend = N : Not Covered, Y : Covered</strong>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" style="width:50%; text-align:left;">
                      # This document is valid till further communication.
                    </td>
                    <td colspan="2" style="width:50%; text-align:left;">
                      TML / CV / FleetCare / VAS / Rev. 02 / Date 01.09.2026
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="mt-4 d-none">
              <h4>FMS Comfort</h4>
              <u><strong>Services Covered / Not Covered AND Responsibilities of Customer</strong></u><br>
              <p><strong>A. Under Fleet Management Solution (FMS), The Company shall provide the maintenance
                services and repairs to the Customer as per the service category FMS Comfort selected by
                the
              customer prior to commencement of FMS:</strong></p>
              <u><strong>FMS Comfort:</strong></u>
              <ol type="i">
                <li>Scheduled &amp; Preventive maintenance scheduled servicing as set-out in owner's Service
                Book (OSB);</li>
                <li>Maintenance, major or minor repairs, overhauling of aggregates e.g. Traction Motor,
                  Front
                &amp; Rear Axle Assy., Gear Box Assy., etc.</li>
                <li>Checking or replacement of transmission oil, rear axle oil, brake oil, wheel grease,
                compressor oil, steering oil, coolant, etc.</li>
                <li>Battery balancing as set-out in owner's Service Book (OSB);</li>
                <li>Servicing to the wear and tear of spare parts including brake lining, brake actuators,
                  brake
                  ducting and pipes, brake valves, master and slave cylinders, vacuum brakes, drying and
                  distribution unit, front and rear hubs and bearing, propeller shaft joints, central and
                intermediate bearings, taper roller and bearing;</li>
                <li>Servicing of the vehicle electrical fitments like Traction Motor, Wiper Motor, DC-DC
                Converter, EV Kit;</li>
                <li>Servicing of the Battery Cooling System (BCS);</li>
              </ol>
              <p><strong>B. Exclusion from the Services to be rendered by TMCVL</strong></p>
              <ol type="i">
                <li>Maintenance services and/or repairs and/or replacement of parts such as Cab, Upholstery,
                  Load Body, Tipping mechanism, Chassis frame &amp; cross members, Tires, Wheel Balancing,
                  Tyre
                  Rotation, Wheel Alignment, Paint Services, Mascots, Accessories, and Glasses including
                  Wind
                  Shield Glasses, ORVMs, Bulbs, Fuses &amp; Relays, Horn, Buzzers, Reverse Parking
                  assistance
                  Sensor, Telematics Device, LV Battery &amp; Battery cables &amp; switches, Wiring harness,
                  Wiper Arm &amp; blades, Oil &amp; Coolant top-ups, Suspension system, Sheet metal items,
                  Plastic tanks, Coolant tank, BCM housing assembly, E-Box housing assembly, Plates, Wheel
                Rims/Discs, Axle beams, Charging gun, Battery Box Mounting, E Box Mounting.</li>
                <li>Damages caused to the vehicle due to accident;</li>
                <li>Improper handling, operational misuse/lapse, unauthorized repairs/modifications;</li>
                <li>Defects due to usage for unintended applications;</li>
                <li>Washing (except basic Scheduled Service wash);</li>
                <li>Delivery and collection of the Vehicle;</li>
                <li>Supply of fuel or Charging between scheduled Services, oil/coolant top-up, rust
                  inhibiting
                agents;</li>
                <li>Towing from breakdown spot to service station;</li>
                <li>Weekly service/maintenance as per OSB;</li>
                <li>Services/repairs due to:
                  <ol type="a">
                    <li>Negligent act or omission by Customer or third party;</li>
                    <li>Faulty repairs by unauthorized service stations;</li>
                    <li>Non-compliance with OSB terms;</li>
                    <li>Unauthorized additions/modifications;</li>
                  </ol>
                </li>
                <li>Services covered under third-party or insurance;</li>
                <li>Services for legal compliance;</li>
                <li>Breakdown/damage due to accident, unlawful/negligent/fraudulent acts unless caused by
                  TMCVL
                Authorized Dealer;</li>
                <li>Repairs/replacement due to accident, collision, burglary, theft, force majeure, riots,
                terrorism, malicious damage, etc.</li>
                <li>If the Vehicle is rendered non-road worthy due to mishandling, tampering, accident,
                  negligence, fire or any other act of nature, the repairs shall not be covered under the
                  scope
                  of repair and the Dealer/TASS reserves the right to charge the Customer for repairs
                  thereof
                including its labour charge;</li>
                <li>Defect other than manufacturing defect which is likely to have existed prior to the
                  commencement of the Contract (which the Dealer/TASS will inform the Customer in writing
                  while
                  entering into this Contract. The Dealer/TASS will retain a copy of the same and also
                  forward a
                copy to TMCVL).</li>
                <li>Defects which arise from using the vehicle for application for which it is not intended
                  for,
                at the time of finalizing the FMS.</li>
              </ol>
              <p>TMCVL may, at its sole discretion, exclude such other Services which the Customer will be
              informed by TMCVL in writing.</p>
              <p><strong>C. Responsibilities of the Customer</strong></p>
              <p>The Customer shall be responsible for:- </p>
              <ol type="a">
                <li>Ensuring the daily checks and other maintenance as detailed in Operator's Service Book
                  (OSB)
                  which are required to be carried out by the Customer and will not be covered under the
                  FMS.
                </li>
                <li>Ensuring that whenever the oil level in aggregates falls below the required level, the
                  Customer shall ensure that requisite quantity of the oil is added to aggregates to bring
                  the
                oil to the requisite level at his cost.</li>
                <li>Ensuring that the vehicle is not put to use, and motor is switched off if the
                  temperature of
                the cooling system crosses the upper limit indicated on the temperature gauge.</li>
                <li>Ensuring that the vehicle is not put to use if the SOC level is &lt;=20%.</li>
                <li>Top up the coolant mix in the battery cooling system (BCS) whenever it falls below the
                required level by bringing the vehicle to nearest TMCVL authorized workshop.</li>
                <li>Do not drive the vehicle if the oil levels in aggregates and/or water and coolant
                  mixture
                level in BCS is not at requisite level.</li>
                <li>Keep the vehicle in a healthy running condition and ensure all requisites that the
                  Services
                in the vehicle are availed as per the OSB.</li>
                <li>Do not misuse the vehicle by overloading it beyond permissible/agreed limits.</li>
                <li>Pay directly to the service station for any service availed outside the scope of FMS
                contract.</li>
                <li>Inform TMCVL immediately on sale and/or transfer of ownership of the vehicle to someone
                  else
                  in any manner, whatsoever. In cases of re-possessed vehicles, it shall be the duty of the
                financier to keep TMCVL informed about the same.</li>
                <li>Not to allow any unauthorized workshop to carry out the service or repair activities in
                  your
                vehicle.</li>
                <li>Ensuring proper parking of the vehicle and suitable charging post day trip completion.
                </li>
                <li>The HV battery must never be allowed to discharge completely, as this situation causes a
                damage to the life of the battery and must be charged regularly.</li>
                <li>If warning related to battery appears, communicate to Tata Motors Commercial Vehicles
                  Authorized Service
                  Centre.
                </li>
                <li>Do not leave the vehicle for longer period when High voltage battery is near zero SoC.
                Follow the long duration storage guideline.</li>
                <li>Keeping the Telematics unit active and live, and ensuring that post completion of 1 year
                period of subscription, its renewal is done on chargeable basis for subsequent years.</li>
                <li>Ensuring Slow &amp; Fast charging schedule as recommended by TMCVL time to time.</li>
                <li>Ensuring that charging of HV battery is done through slow charging method and fast
                  charging
                  to be done if required by keeping Charging Cycle ratio of Slow Charging and Fast charging
                  as
                per the Operator Service Book (OSB).</li>
                <li>Ensuring that the Vehicle is brought for the Scheduled Services at authorized Dealer(s)/
                  TASS or at the site of the Customer (services provided through authorized Dealer / TASS)
                  as
                and when due as mentioned in OSB.</li>
                <li>Maintaining the Trip wise / Day wise Log Sheets of the actual Kilometers /Hours covered
                  by
                the Vehicle(s).</li>
                <li>Not to tamper with the speedometer / odometer / Hour meter of the vehicle.</li>
                <li>Ensuring that the Speedometer/ Odometer/ Hour meter is functioning all the time.
                  Whenever
                  the Speedometer/Odometer/Hour meter starts malfunctioning OR stops functioning, the
                  Customer
                  will ensure to take it immediately to the Nearest Dealer/TASS of TMCVL and get it
                  rectified/Replaced for proper functioning. Towing if necessary the charges for the same
                  would
                be borne by the customer.</li>
                <li>Registering a complaint with Customer Assistance Centre for any breakdown on road as
                available in the operator service booklet.</li>
                <li>When deal is closed &amp; payment is to be handed over to TMCVL representatives only
                  EMI's
                  to
                  be handed over through Demand Draft (DD)/RTGS + Post dated Cheque's (PDC's)/ECS duly
                  filled in
                all respects only. No cash transaction should take place.</li>
              </ol>
              <table>
                <thead>
                  <tr>
                    <th>Aggregate Type</th>
                    <th>Part Description</th>
                    <th>Parts</th>
                    <th>Labour</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td rowspan="4">Consumables *Applicable as per OSB recommendation</td>
                    <td>Gear box Oil, Rear Axle Oil, Steering Oil, Compressor Oil</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>Brake Fluid, Wheel Greasing</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>Refrigerant, Coolant</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>Battery Balancing</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td rowspan="12">EV Kit Component</td>
                    <td>TRACTION MOTOR ASSY, GEAR BOX ASSY</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>MOTOR CONTROL UNIT, BATTERY COOLING UNIT</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>BATTERY MANAGEMENT SYSTEM</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>BMS ASSY, BDU ASSY, COMPRESSOR ASSY</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>CONTROLLER, BATTERY COOLING SYSTEM</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>DC-DC CALBE ASSY</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>SENSOR, WIRING HARNESS</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>CONDENSER ASSY- Battery cooling, COOLANT PUMP ASSY</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>CHARGING GUN</td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>All Brackets & Mountings including E Box Mounting & Battery box mountings</td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>BCM & E Box Housing Assembly, Coolant Tank</td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>Top Plate, Front Plate, Rear plate, Bottom plate</td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td rowspan="4">Gear Box</td>
                    <td>GEAR BOX ASSY</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>YOKE</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>INPUT SHAFT, OUTPUT SHAFT</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>OIL SEAL & BEARING</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td rowspan="2">Propeller Shaft</td>
                    <td>PROPELLER SHAFT ASSY</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>KIT- U J, SLIP YOKE ASSY</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td rowspan="4">Steering</td>
                    <td>STEERING GEAR BOX ASSY, STEERING COLUMN ASSY</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>ASSY. DRAG LINK BS2/3/4/6</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>BALL JOINT ASSY, INTERMEDIATE SHAFT ASSY</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>BALL BEARING</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td rowspan="5">Rear Axle</td>
                    <td>CARRIER SUB ASSY, SHAFT ASSY, BRAKE DRUM</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>GEAR & PINION ASSY-HYPOID</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>KIT- CROWN WHEEL & PINION ASSY</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>OIL SEAL, BEARING</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>AXLE ASSY WITH BRAKE, AXEL BEAN ASSY</td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td rowspan="3">Front Axle</td>
                    <td>FRONT HUB ASSY, STUB AXLE ASSY, TIE ROD ASSY, BRAKE DRUM</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>THRUST BEARING, BALL JOINT ASSY;RH</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>FRONT AXLE TUBE ASSY</td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td rowspan="3">Brake</td>
                    <td>WHEEL CYLINDER ASSY, ADJUSTER ASSY, CALIPER ASSY</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>KIT-BRAKE SHOE, KIT-PAD ASSY</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td>VACUUM PUMP ASSY, VACUUM SENSOR, LOAD SENSING VALVE</td>
                    <td>Y</td>
                    <td>Y</td>
                  </tr>
                  <tr>
                    <td rowspan="5">Electricals</td>
                    <td>HORN, RELAYS, HEADLAMP ASSY, LAMP ASSY, USB CHARGER, LAMPS, GPS CONNECTOR, BUZZER,
                    SWITCHES etc.</td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>WIRING HARNESS MAIN, BATTERY & BATTERY CABLES</td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>SWITCH GEAR RANGE SELECTOR</td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>ECU VEHICLE TRACKING ASSY</td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>INSTRUMENT CLUSTER, REVERSE PARK ASSISTANCE SENSOR</td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td rowspan="">Suspension</td>
                    <td>Spring leaves, Shackles, Spring bush, Hanger, Shock absorbers, bushes etc.</td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td rowspan="2">Body items </td>
                    <td>Body items such as door handles , steering wheel, wiper arm and blades, upholstery
                      items
                    (including driver's seat, door locks, winding mechanism, etc.)mechanism, etc.)</td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>Chassis Frame, Paint Job</td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td rowspan="">Glass</td>
                    <td>All glass items including Windshield glass </td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td rowspan="">Sheet Metal Items & Tanks</td>
                    <td>Sheet Metal items (like fuel tank, air tank, silencer pipes, muffler, catalytic
                    converter) & plastic coolant tank, DEF Tank. </td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td rowspan="2">Tires & Wheels </td>
                    <td>Tires, Tube </td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>Wheel rims, Discs, wheel nut & bolts</td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>Wheel Alignment</td>
                    <td>Wheel Alignment & Tyre Rotation</td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>Fasteners</td>
                    <td>* Bolt, Nut, Clamp, Screw, Washer, Plug etc. such items will be selectively covered
                      based on
                    component/assembly coverage.</td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td rowspan="7">Other Services</td>
                    <td>Top-ups (Oil & Coolants)</td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>Daily Washing & Cleaning and Daily & monthly checks & inspection</td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>Tyre Management (Tyre Rotation, Wheel Alignment, Wheel Rims & Discs) </td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>Tyre Replacement</td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>Telematics Control Unit (TCU) Subscription</td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>Backup Vehicle Support , Towing Charges</td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>Towing</td>
                    <td>N</td>
                    <td>N</td>
                  </tr>
                </tbody>
              </table>
              <br />
              <h3><strong>General Terms</strong></h3>
              <ol>
                <li>Lubricants and consumables will be changed at scheduled service intervals as specified
                  in
                OSB.</li>
                <li>Breakdown assistance coverage applies only to parts covered under the relevant pack.
                </li>
                <li>Any item not explicitly listed or not part of any mentioned assembly/sub-assembly is
                excluded from coverage.</li>
                <li>Terms & Conditions of the FMS package are applicable as per the agreement. Refer to the
                  same
                for full inclusions and exclusions.</li>
                <li>Customised offers are required for any additional coverage.</li>
                <li>Contact a TMCVL representative for further package details.</li>
              </ol>
            </div>
          </div>
        }
        @if (['8'].includes(cifDetails?.amc_details?.product_type_code)) {
          <div>
            <div class="annexure-table" style="margin-top: 20px;">
              <h4 class="infotitle text-align-center mb-4" style="text-align: center;">Annexure 2</h4>
              <h4>Coverage of FMS-Comfort Package for SCV EV Models
              </h4>
              <!-- <div class="container my-2"> -->
              <div class="my-2">
                <div class="table-responsive">
                  <table cellpadding="5" cellspacing="0">
                    <thead>
                      <tr
                        style="background-color: rgba(241, 241, 241, 1);; color: black; text-align: center;">
                        <th rowspan="2" style="border: 1px solid #a37a58; padding: 8px;">Aggregate Type</th>
                        <th rowspan="2" style="border: 1px solid #a37a58; padding: 8px;">Part Description
                        </th>
                        <th colspan="2"
                          style="border: 1px solid #a37a58; padding: 8px; background-color: rgba(241, 241, 241, 1);">
                          Ace EV
                        </th>
                        <th colspan="2"
                          style="border: 1px solid #a37a58; padding: 8px; background-color: rgba(241, 241, 241, 1);">
                          Ace
                        Pro EV</th>
                        <th colspan="2"
                          style="border: 1px solid #a37a58; padding: 8px; background-color: rgba(241, 241, 241, 1);">
                          Intra
                        EV</th>
                      </tr>
                      <tr
                        style="background-color: rgba(241, 241, 241, 1); color: black; text-align: center;">
                        <th class="left-align">Parts</th>
                        <th class="left-align">Labour</th>
                        <th class="left-align">Parts</th>
                        <th class="left-align">Labour</th>
                        <th class="left-align">Parts</th>
                        <th class="left-align">Labour</th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- Consumables -->
                      <tr>
                        <td rowspan="4" class="left-align">
                          Consumables<br>*Applicable as per OSB recommendation</td>
                          <td class="left-align">Gear box Oil, Rear Axle Oil,
                          Steering Oil, Compressor Oil</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <tr>
                          <td class="left-align">Brake Fluid</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <tr>
                          <td class="left-align">Refrigerant, Coolant</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <tr>
                          <td class="left-align">Battery Balancing (By Supplier)
                          </td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <!-- EV Kit Component -->
                        <tr>
                          <td rowspan="14" class="left-align">EV
                          Kit Component</td>
                          <td class="left-align">Traction motor assembly</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <tr>
                          <td class="left-align">Motor control unit</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <tr>
                          <td class="left-align">Battery management system</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <tr>
                          <td class="left-align">Power Distribution Unit (PDU)
                            assembly/ On Borad Charger (OBC)/ DC-DC converter<br>Ace - E-Box/ Ace Pro -
                          Separate/ Intra - Integrated with 3 in 1</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <tr>
                          <td class="left-align">Controller (Battery Cooling
                          system)</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>NA
                          </td>
                          <td>NA
                          </td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <tr>
                          <td class="left-align">Battery cooling management
                            (BCM) & E-Box Housing assembly, Coolant Tank<br><strong>Serviceability:</strong>
                          Ace - Supplier/ Ace Pro - TMCVL/ Intra - TMCVL</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <tr>
                          <td class="left-align">DC-DC cable assembly</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <tr>
                          <td class="left-align">Sensor, Wiring harness</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <tr>
                          <td class="left-align">Condenser assembly- Battery
                          cooling, Coolant pump assembly</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <tr>
                          <td class="left-align">Charging gun</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                        </tr>
                        <tr>
                          <td class="left-align">All brackets & mountings
                          including E-Box mounting & Battery box mountings</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                        </tr>
                        <tr>
                          <td class="left-align">HV Battery</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                        </tr>
                        <tr>
                          <td class="left-align">LV Battery</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <tr>
                          <td class="left-align">Top Plate, Front Plate, Rear
                          plate, Bottom plate (Battery)</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                        </tr>
                        <!-- Electricals -->
                        <tr>
                          <td rowspan="11" class="left-align">
                          Electricals</td>
                          <td class="left-align">Vacuum pump assembly, Vacuum
                          sensor</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <tr>
                          <td class="left-align">Horn, Relays, Headlamp
                            assembly, USB charger, Lamps, GPS connector, Buzzer, Switches, Combi switch, Fuses
                          etc.</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                        </tr>
                        <tr>
                          <td class="left-align">Wiring harness of EV system
                          (Except body i.e. Head/ tail lamp etc.)</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <tr>
                          <td class="left-align">HV cables</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <tr>
                          <td class="left-align">LV Battery & cables</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <tr>
                          <td class="left-align">Switch gear range selector/
                          Drive-Neutral-Reverse (DNR)</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <tr>
                          <td class="left-align">ECU (VECU)</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <tr>
                          <td class="left-align">Vehicle tracking/ Gateway
                          Domain Control Unit (GDCU)</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                          <td>N</td>
                        </tr>
                        <tr>
                          <td class="left-align">Wiper motor</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <tr>
                          <td class="left-align">Crash sensor</td>
                          <td>NA
                          </td>
                          <td>NA
                          </td>
                          <td>NA
                          </td>
                          <td>NA
                          </td>
                          <td>N</td>
                          <td>N</td>
                        </tr>
                        <tr>
                          <td class="left-align">Instrument cluster</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <!-- Gear Box -->
                        <tr>
                          <td rowspan="6" class="left-align">Gear
                          Box</td>
                          <td class="left-align">Gear box assembly</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>NA
                          </td>
                          <td>NA
                          </td>
                          <td>NA
                          </td>
                          <td>NA
                          </td>
                        </tr>
                        <tr>
                          <td class="left-align">Transaxle assembly</td>
                          <td>NA
                          </td>
                          <td>NA
                          </td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <tr>
                          <td class="left-align">Yoke</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>NA
                          </td>
                          <td>NA
                          </td>
                          <td>NA
                          </td>
                          <td>NA
                          </td>
                        </tr>
                        <tr>
                          <td class="left-align">Input/ Output shaft gearbox
                          </td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>NA
                          </td>
                          <td>NA
                          </td>
                          <td>NA
                          </td>
                          <td>NA
                          </td>
                        </tr>
                        <tr>
                          <td class="left-align">Drive shaft</td>
                          <td>NA
                          </td>
                          <td>NA
                          </td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>NA
                          </td>
                          <td>NA
                          </td>
                        </tr>
                        <tr>
                          <td class="left-align">Oil seal & bearing</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <!-- Propeller Shaft -->
                        <tr>
                          <td rowspan="2" class="left-align">
                          Propeller Shaft</td>
                          <td class="left-align">Propeller shaft assembly</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>NA
                          </td>
                          <td>NA
                          </td>
                          <td>NA
                          </td>
                          <td>NA
                          </td>
                        </tr>
                        <tr>
                          <td class="left-align">Kit- UJ, Slip yoke assembly
                          </td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>NA
                          </td>
                          <td>NA
                          </td>
                          <td>NA
                          </td>
                          <td>NA
                          </td>
                        </tr>
                        <!-- Steering -->
                        <tr>
                          <td rowspan="4" class="left-align">
                          Steering</td>
                          <td class="left-align">Steering gear box assembly,
                          Steering column assembly</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <tr>
                          <td class="left-align">Assembly drag link</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <tr>
                          <td class="left-align">Ball joint assembly,
                          Intermediate shaft assembly</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <tr>
                          <td class="left-align">Ball bearing</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                          <td>Y</td>
                        </tr>
                        <!-- Rear Axle/ Transaxle -->
                        <tr>
                          <td rowspan="6" class="left-align">Rear
                            Axle/<br>Transaxle</td>
                            <td class="left-align">Carrier sub assembly, Shaft
                            assembly, Brake drum</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                          </tr>
                          <tr>
                            <td class="left-align">Gear & pinion assembly-hypoid
                            </td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                          </tr>
                          <tr>
                            <td class="left-align">Kit- crown wheel & pinion
                            assembly</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                          </tr>
                          <tr>
                            <td class="left-align">Oil seal, Bearing</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                          </tr>
                          <tr>
                            <td class="left-align">Axle assembly with brake, gear
                            parts, axle shaft</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>NA
                            </td>
                            <td>NA
                            </td>
                            <td>Y</td>
                            <td>Y</td>
                          </tr>
                          <tr>
                            <td class="left-align">Axle beam/ tube assembly</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                          </tr>
                          <!-- Front Axle -->
                          <tr>
                            <td rowspan="3" class="left-align">Front
                            Axle</td>
                            <td class="left-align">Front hub assembly, stub axle
                            assembly, tie rod assembly, brake drum</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                          </tr>
                          <tr>
                            <td class="left-align">Thrust bearing, ball join
                            assembly</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>NA
                            </td>
                            <td>NA
                            </td>
                            <td>Y</td>
                            <td>Y</td>
                          </tr>
                          <tr>
                            <td class="left-align">Front axle beam assembly</td>
                            <td>N</td>
                            <td>N</td>
                            <td>NA
                            </td>
                            <td>NA
                            </td>
                            <td>N</td>
                            <td>N</td>
                          </tr>
                          <!-- Brake -->
                          <tr>
                            <td rowspan="2" class="left-align">Brake
                            </td>
                            <td class="left-align">Wheel cylinder assembly,
                            Adjuster assembly, Calliper assembly</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                          </tr>
                          <tr>
                            <td class="left-align">Kit-brake shoe, Kit-pad
                            assembly</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                          </tr>
                          <!-- Suspension -->
                          <tr>
                            <td class="left-align">Suspension</td>
                            <td class="left-align">Spring leaves, Shackles, Spring
                            bush, Hanger, Shock absorbers, bushes etc.</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                          </tr>
                          <!-- Body items -->
                          <tr>
                            <td rowspan="3" class="left-align">Body
                            items</td>
                            <td class="left-align">Body items such as door handles
                              , steering wheel, wiper arm and blades, upholstery items (including driver's seat,
                            door locks, winding mechanism, etc.)mechanism, etc.)</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                          </tr>
                          <tr>
                            <td class="left-align">Chassis Frame, Paint Jobs</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                          </tr>
                          <tr>
                            <td class="left-align">All glass items including
                            Windshield glass</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                          </tr>
                          <!-- Tyres & Wheels -->
                          <tr>
                            <td rowspan="3" class="left-align">Tyres
                            & Wheels</td>
                            <td class="left-align">Tyre/ Tube (Repairs/
                            Replacement)</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                          </tr>
                          <tr>
                            <td class="left-align">Wheel rims, Discs, wheel nut &
                            bolts</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                          </tr>
                          <tr>
                            <td class="left-align">Wheel Alignment & Tyre Rotation
                            </td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                          </tr>
                          <!-- Fasteners -->
                          <tr>
                            <td class="left-align">Fasteners</td>
                            <td class="left-align">* Bolt, Nut, Clamp, Screw,
                              Washer, Plug etc. such items will be selectively covered based on
                            component/assembly coverage.</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                          </tr>
                          <!-- Other services -->
                          <tr>
                            <td rowspan="4" class="left-align">Other
                            services</td>
                            <td class="left-align">Top ups - Oil & Coolants
                            (Excluded if damage or accidental case)</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                            <td>Y</td>
                          </tr>
                          <tr>
                            <td class="left-align">Daily Washing & Cleaning and
                            Daily & monthly checks & inspection</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                          </tr>
                          <tr>
                            <td class="left-align">Telematics Control Unit (TCU)
                            Subscription</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                          </tr>
                          <tr>
                            <td class="left-align">Backup Vehicle Support, Towing
                            Charges</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                            <td>N</td>
                          </tr>
                        </tbody>
                      </table>
                      <br />
                      <table class="ew-table">
                        <tbody>
                          <!-- General Terms Header Section -->
                          <tr style="background-color: #fbe5d6; font-weight: bold;">
                            <td colspan="8" class="left-align"
                              style="border: 1px solid #a37a58; padding: 6px; color: black;">
                            General Terms</td>
                          </tr>
                          <!-- General Terms Content Rows -->
                          <tr>
                            <td colspan="8" class="left-align">
                              <strong>N - Not covered/ NA - Not applicable </strong></td>
                            </tr>
                            <tr>
                              <td colspan="8" class="left-align">1. Change of
                                lubricants and Consumables will be at schedule service interval as specified in
                              OSB.</td>
                            </tr>
                            <tr>
                              <td colspan="8" class="left-align">2. Breakdown
                              assistance coverage is on parts covered under relevant pack.</td>
                            </tr>
                            <tr>
                              <td colspan="8" class="left-align">3. Any
                                part/component/item which is not explicitly mentioned above and is not part of any
                                assembly/sub-assembly mentioned above will not be part of relevant FMS Comfort
                              pack coverage</td>
                            </tr>
                            <tr>
                              <td colspan="8" class="left-align">4. Terms &
                                Conditions of FMS package will be applicable as per the agreement. Kindly refer to
                              the same for detailed coverage on inclusions and exclusions</td>
                            </tr>
                            <tr>
                              <td colspan="8" class="left-align">5. For any
                              additional coverage, customised offer need to be taken</td>
                            </tr>
                            <tr>
                              <td colspan="8" class="left-align">
                                6. For any further information on the package, TMCVL representative can be
                                contacted
                              </td>
                            </tr>
                            <tr>
                              <td colspan="4" style="width:50%; text-align:left;">
                                # This document is valid till further communication.
                              </td>
                              <td colspan="4" style="width:50%; text-align:left;">
                                TML / CV / FleetCare / VAS / Rev. 02 / Date 01.09.2026
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
          @if (cifDetails?.amc_details?.service_product_type === 'EW') {
            <div>
              <div>
                <h4 class="infotitle text-align-center mb-4" style="text-align: center;">Annexure 2</h4>
                <h4 class="section-title">Extended Warranty - Coverage details - HCV Truck, ILMCV Trucks, CV P &
                SCV C PU</h4>
                <table class="ew-table">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th>Aggregates / Parts</th>
                      <th>Extended warranty (Driveline)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">
                        <strong>Engine</strong>
                      </td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>Engine Assembly</td>
                      <td>Y</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Cylinder Head</td>
                      <td>Y</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>Cylinder Block</td>
                      <td>Y</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>Crankshaft</td>
                      <td>Y</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>Camshaft</td>
                      <td>Y</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>Head Gasket</td>
                      <td>Y</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>Water pump</td>
                      <td>Y</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>Oil Pump</td>
                      <td>Y</td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>Oil Cooler</td>
                      <td>Y</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>OIL MIST SEPARATOR ASSY (M/S M&H)</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>11</td>
                      <td>Flywheel Housing</td>
                      <td>Y</td>
                    </tr>
                    <tr>
                      <td>12</td>
                      <td>Air Compressor</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>13</td>
                      <td>Radiator</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>14</td>
                      <td>Turbocharger</td>
                      <td>Y (Applicable for SCV C PU)</td>
                    </tr>
                    <tr>
                      <td>15</td>
                      <td>Starter Motor</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>16</td>
                      <td>Alternator</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>17</td>
                      <td>AC Compressor</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>18</td>
                      <td>AC Condenser</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>19</td>
                      <td>EGR Cooler</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>20</td>
                      <td>EGR Valve</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>21</td>
                      <td>CR Pump (FIP)</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>22</td>
                      <td>Common Rail, Injectors ( SL Engine & Cummins)</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>23</td>
                      <td>HP Lines</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>24</td>
                      <td>Front / Rear oil Seal</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>25</td>
                      <td>Fan Belt</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>26</td>
                      <td>Viscous Fan</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>27</td>
                      <td>Engine Mounting</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>28</td>
                      <td>Intake air throttle valve (IATV)</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>29</td>
                      <td>Exhaust throttle valve (ETV)</td>
                      <td>N</td>
                    </tr>
                    <!-- Clutch Section -->
                    <tr>
                      <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">
                        <strong>Clutch</strong>
                      </td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>Flywheel</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Clutch Disk Structure (No warranty on burn cases)</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>Pressure Plate</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>Clutch Master Cylinder</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>Clutch Release Bearing</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>Clutch Booster</td>
                      <td>N</td>
                    </tr>
                    <!-- Gear Box Section -->
                    <tr>
                      <td colspan="3" style="background-color: #e9ecef; font-weight: bold;"><strong>Gear
                      Box</strong></td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>Gear Housing</td>
                      <td>Y</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Main/Counter Shaft /Gear</td>
                      <td>Y</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>Synchro Ring/cone</td>
                      <td>Y</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>Shifter Shaft</td>
                      <td>Y</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>Shifter/Selector cable</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>PTO</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>Gear Box All Parts</td>
                      <td>Y</td>
                    </tr>
                    <tr>
                      <td colspan="3" style="background-color: #e9ecef; font-weight: bold;"><strong>Propeller
                      Shaft</strong></td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>Propeller Shaft / Inter Axle Shaft</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>UJ Cross</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>Yoke/teeth</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>CJ Rubber/Bearing</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td colspan="3" style="background-color: #e9ecef; font-weight: bold;"><strong>Rear
                      Axle</strong></td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>Rear Axle Housing</td>
                      <td>Y</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Hub</td>
                      <td>Y</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>Axle Shaft</td>
                      <td>Y</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>CWP</td>
                      <td>Y</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>Pinion oil Seal </td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td colspan="3" style="background-color: #e9ecef; font-weight: bold;"><strong>Front
                      Axle</strong></td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>Axle Beam</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>King Pin</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>Tie Rod</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>Drag Link / Ball Joint</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>Thrust Bearing </td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td colspan="3" style="background-color: #e9ecef; font-weight: bold;"><strong>Truck Hub
                      Unit (THU)</strong></td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>THU Bearing</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td colspan="3" style="background-color: #e9ecef; font-weight: bold;"><strong>Lift Axle
                      12.5T</strong></td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>Hanger</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Trailing Arm</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>Axle</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>Air Bellow</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>Rebound Chain </td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td colspan="3" style="background-color: #e9ecef; font-weight: bold;"><strong>Lift Axle
                      7T</strong></td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>Structural Parts</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Air Bellow</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>Stabilizer</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>Rebound strap</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <th colspan="3" style="background-color: #e9ecef; font-weight: bold;">BRAKE PARTS</th>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>ABS unit</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Brake Drum</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>Air Processing Unit</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>Pneumatic valve</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>S Camshaft</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>Brake Shoe</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>Torque Plate</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>Slack Adjuster</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>Brake actuator / chamber</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>Hand Brake Valve</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>11</td>
                      <td>Anti Roll Back Assy (HAS)</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>12</td>
                      <td>EMR Retarder</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <th colspan="3" style="background-color: #e9ecef; font-weight: bold;">FRAME</th>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>Chassis Frame</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <th colspan="3" style="background-color: #e9ecef; font-weight: bold;">SUSPENSION</th>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>Leaf Spring / Bogie Spring</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Shock Absorber</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>Bogie Bracket</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>Bogie Trunnion</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>V Rod</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>Torque Rod</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>Anti Roll Bar</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>Suspension Bolster</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>Steering Damper</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>Lift Axle Control valve</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>11</td>
                      <td>Levelling valve</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>12</td>
                      <td>Air Suspension Assembly</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>13</td>
                      <td>Ultimax Suspension (Tippers) </td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <th colspan="3" style="background-color: #e9ecef; font-weight: bold;">CABIN</th>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>Cabin</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Music System</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>Cabin Suspension</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>Instrument Cluster</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>Wiper Motor</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>Windshield glass (Mfg. defect)</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>USB CHARGER 24V 2-PORT</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>Window regulator</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>Door latch</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>Washer Kit</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>11</td>
                      <td>Telematics Unit</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <th colspan="3" style="background-color: #e9ecef; font-weight: bold;">STEERING</th>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>Steering GB</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Steering Column</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>Steering Pump</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>Steering Power Cylinder</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <th colspan="3" style="background-color: #e9ecef; font-weight: bold;">ELECTRICALS &
                      ELECTRONICS</th>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>Engine ECU</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>ECU ABS</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>All Sensors / Relays</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>Battery</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>Battery Cut off Switch</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>Wiring Harness / Battery Cable (For Mfg. Defect.)</td>
                      <td>N</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>Lamp (Head /Tail/Roof /Fog)<br><i>For Mfg. Defect. Bulb not covered Under warranty</i>
                    </td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>E-Horn (Minda)</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td>Switches<br>(Regeneration & Other Dashboard switches)</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td>RPAS (Rear Park Assistance Sensor)</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>11</td>
                    <td>DCU (L)</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>12</td>
                    <td>VECU</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>13</td>
                    <td>GDCU</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <th colspan="3" style="background-color: #e9ecef; font-weight: bold;">EXHAUST SYSTEM</th>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>After Treatment System assy. (Cummins & 5L)</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Exhaust Flex Pipe</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <th colspan="3" style="background-color: #e9ecef; font-weight: bold;">LOAD BODY</th>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>Tipping cylinder/tipping tank</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Load Body (Except abused & Overload)</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Tipper Sub frame </td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Paints</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">
                      <strong>OTHERS</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>Plastic Fuel Tank With AFT (Anti Fuel Theft Unitt / Fuel Tank (Metallic))</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Fuel Tank (Metallic)</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Oil Seals</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Fifth Wheel Coupling</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>Wheel Rim (Except overload)</td>
                    <td>N</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>Wheel Hub Bearing (Non-THU)</td>
                    <td>N</td>
                  </tr>
                  <!-- <tr>
                  <td colspan="3" class="left-align">Validity: Till 30th Sept'25 unless notified separately
                  </td>
                </tr> -->
                <tr>
                  <td colspan="4" class="left-align">
                    <strong>Legend = N : Not Covered, Y : Covered</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" style="width:50%; text-align:left;">
                    <strong># This document is valid till further communication.</strong>
                  </td>
                  <td colspan="2" style="width:50%; text-align:left;">
                    TML / CV / FleetCare / VAS / Rev. 02 / Date 01.09.2026
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- <div class="page-footer">
            <p>Note: This table represents a selection of coverage details. Refer to the original
            document for complete coverage information.</p>
          </div> -->
        </div>
        <div class="mt-5 d-none">
          <h4 class="annexure-title">Extended Warranty Coverage</h4>
          <table>
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Aggregates / Parts</th>
                <th>Extended Warranty (Driveline)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">
                  <strong>Engine</strong>
                </td>
              </tr>
              <tr>
                <td>1</td>
                <td>Engine Assembly</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Cylinder Head</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Cylinder Block</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Crankshaft</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Camshaft</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Head Gasket</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Water pump</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>8</td>
                <td>Oil Pump</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>9</td>
                <td>Oil Cooler</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>10</td>
                <td>OIL MIST SEPARATOR ASSY (M/S M&H)</td>
                <td>N</td>
              </tr>
              <tr>
                <td>11</td>
                <td>Flywheel Housing</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>12</td>
                <td>Air Compressor</td>
                <td>N</td>
              </tr>
              <tr>
                <td>13</td>
                <td>Radiator</td>
                <td>N</td>
              </tr>
              <tr>
                <td>14</td>
                <td>Turbocharger</td>
                <td>N</td>
              </tr>
              <tr>
                <td>15</td>
                <td>Starter Motor</td>
                <td>N</td>
              </tr>
              <tr>
                <td>16</td>
                <td>Alternator</td>
                <td>N</td>
              </tr>
              <tr>
                <td>17</td>
                <td>AC Compressor</td>
                <td>N</td>
              </tr>
              <tr>
                <td>18</td>
                <td>AC Condenser</td>
                <td>N</td>
              </tr>
              <tr>
                <td>19</td>
                <td>EGR Cooler</td>
                <td>N</td>
              </tr>
              <tr>
                <td>20</td>
                <td>EGR Valve</td>
                <td>N</td>
              </tr>
              <tr>
                <td>21</td>
                <td>CR Pump (FIP)</td>
                <td>N</td>
              </tr>
              <tr>
                <td>22</td>
                <td>Common Rail, Injectors ( 5L Engine & Cummins) </td>
                <td>N</td>
              </tr>
              <tr>
                <td>23</td>
                <td>HP Lines</td>
                <td>N</td>
              </tr>
              <tr>
                <td>24</td>
                <td>Front / Rear oil Seal</td>
                <td>N</td>
              </tr>
              <tr>
                <td>25</td>
                <td>Fan Belt</td>
                <td>N</td>
              </tr>
              <tr>
                <td>26</td>
                <td>Viscous Fan</td>
                <td>N</td>
              </tr>
              <tr>
                <td>27</td>
                <td>Engine Mounting</td>
                <td>N</td>
              </tr>
              <tr>
                <td>28</td>
                <td>Intake air throttle valve (IATV)</td>
                <td>N</td>
              </tr>
              <tr>
                <td>29</td>
                <td>Exhaust throttle valve (ETV) </td>
                <td>N</td>
              </tr>
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">
                  <strong>Clutch</strong>
                </td>
              </tr>
              <tr>
                <td>1</td>
                <td>Flywheel</td>
                <td>N</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Clutch Disk Structure (No warranty on burn cases)</td>
                <td>N</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Pressure Plate</td>
                <td>N</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Clutch Master Cylinder</td>
                <td>N</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Clutch Release Bearing</td>
                <td>N</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Clutch Booster</td>
                <td>N</td>
              </tr>
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;"><strong>Gear
                Box</strong></td>
              </tr>
              <tr>
                <td>1</td>
                <td>Gear Housing</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Main/Counter Shaft /Gear</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Synchro Ring/cone</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Shifter Shaft</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Shifter/Selector cable</td>
                <td>N</td>
              </tr>
              <tr>
                <td>5</td>
                <td>PTO</td>
                <td>N</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Gear Box All Parts</td>
                <td>Y</td>
              </tr>
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;"><strong>Propeller
                Shaft</strong></td>
              </tr>
              <tr>
                <td>1</td>
                <td>Propeller Shaft / Inter Axle Shaft</td>
                <td>N</td>
              </tr>
              <tr>
                <td>2</td>
                <td>UJ Cross</td>
                <td>N</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Yoke/teeth</td>
                <td>N</td>
              </tr>
              <tr>
                <td>4</td>
                <td>CJ Rubber/Bearing</td>
                <td>N</td>
              </tr>
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;"><strong>Rear
                Axle</strong></td>
              </tr>
              <tr>
                <td>1</td>
                <td>Rear Axle Housing</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Hub</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Axle Shaft</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>4</td>
                <td>CWP</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Pinion oil Seal</td>
                <td>N</td>
              </tr>
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;"><strong>Front
                Axle</strong></td>
              </tr>
              <tr>
                <td>1</td>
                <td>Axle Beam</td>
                <td>N</td>
              </tr>
              <tr>
                <td>2</td>
                <td>King Pin</td>
                <td>N</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Tie Rod</td>
                <td>N</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Drag Link / Ball Joint</td>
                <td>N</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Thrust Bearing</td>
                <td>N</td>
              </tr>
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;"><strong>Truck Hub
                Unit (THU)</strong></td>
              </tr>
              <tr>
                <td>1</td>
                <td>THU Bearing </td>
                <td>N</td>
              </tr>
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;"><strong>Lift Axle
                12.5T</strong></td>
              </tr>
              <tr>
                <td>1</td>
                <td>Hanger</td>
                <td>N</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Trailing Arm</td>
                <td>N</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Axle</td>
                <td>N</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Air Bellow</td>
                <td>N</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Rebound Chain </td>
                <td>N</td>
              </tr>
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;"><strong>Lift Axle
                7T</strong></td>
              </tr>
              <tr>
                <td>1</td>
                <td>Structural Parts</td>
                <td>N</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Air Bellow</td>
                <td>N</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Stabilizer</td>
                <td>N</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Rebound strap</td>
                <td>N</td>
              </tr>
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;"><strong>Brake
                Parts</strong></td>
              </tr>
              <tr>
                <td>1</td>
                <td>ABS unit</td>
                <td>N</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Brake Drum</td>
                <td>N</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Air Processing Unit</td>
                <td>N</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Pneumatic valve</td>
                <td>N</td>
              </tr>
              <tr>
                <td>5</td>
                <td>S Camshaft</td>
                <td>N</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Brake Shoe</td>
                <td>N</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Torque Plate</td>
                <td>N</td>
              </tr>
              <tr>
                <td>8</td>
                <td>Slack Adjuster</td>
                <td>N</td>
              </tr>
              <tr>
                <td>9</td>
                <td>Brake actuator / chamber</td>
                <td>N</td>
              </tr>
              <tr>
                <td>10</td>
                <td>Hand Brake Valve</td>
                <td>N</td>
              </tr>
              <tr>
                <td>11</td>
                <td>Anti Roll Back Assy (HAS) </td>
                <td>N</td>
              </tr>
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">
                  <strong>Frame</strong>
                </td>
              </tr>
              <tr>
                <td>1</td>
                <td>Chassis Frame</td>
                <td>N</td>
              </tr>
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">
                  <strong>Suspension</strong>
                </td>
              </tr>
              <tr>
                <td>1</td>
                <td>Leaf Spring / Bogie Spring</td>
                <td>N</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Shock Absorber</td>
                <td>N</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Bogie Bracket</td>
                <td>N</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Bogie Trunnion</td>
                <td>N</td>
              </tr>
              <tr>
                <td>5</td>
                <td>V Rod</td>
                <td>N</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Torque Rod</td>
                <td>N</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Anti Roll Bar</td>
                <td>N</td>
              </tr>
              <tr>
                <td>8</td>
                <td>Suspension Bolster</td>
                <td>N</td>
              </tr>
              <tr>
                <td>9</td>
                <td>Steering Damper</td>
                <td>N</td>
              </tr>
              <tr>
                <td>10</td>
                <td>Lift Axle Control valve</td>
                <td>N</td>
              </tr>
              <tr>
                <td>11</td>
                <td>Levelling valve</td>
                <td>N</td>
              </tr>
              <tr>
                <td>12</td>
                <td>Air Suspension Assembly</td>
                <td>N</td>
              </tr>
              <tr>
                <td>13</td>
                <td>Ultimax Suspension (Tippers) </td>
                <td>N</td>
              </tr>
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">
                  <strong>Cabin</strong>
                </td>
              </tr>
              <tr>
                <td>1</td>
                <td>Cabin</td>
                <td>N</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Music System</td>
                <td>N</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Cabin Suspension</td>
                <td>N</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Instrument Cluster</td>
                <td>N</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Wiper Motor</td>
                <td>N</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Windshield glass (Mfg. defect)</td>
                <td>N</td>
              </tr>
              <tr>
                <td>7</td>
                <td>USB CHARGER 24V 2-PORT</td>
                <td>N</td>
              </tr>
              <tr>
                <td>8</td>
                <td>Window regulator</td>
                <td>N</td>
              </tr>
              <tr>
                <td>9</td>
                <td>Door latch</td>
                <td>N</td>
              </tr>
              <tr>
                <td>10</td>
                <td>Washer Kit</td>
                <td>N</td>
              </tr>
              <tr>
                <td>11</td>
                <td>Telematics Unit</td>
                <td>N</td>
              </tr>
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">
                  <strong>Steering</strong>
                </td>
              </tr>
              <tr>
                <td>1</td>
                <td>Steering GB</td>
                <td>N</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Steering Column</td>
                <td>N</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Steering pump</td>
                <td>N</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Steering Power Cylinder</td>
                <td>N</td>
              </tr>
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;"><strong>Electricals
                  and
                Electronics</strong></td>
              </tr>
              <tr>
                <td>1</td>
                <td>Engine ECU</td>
                <td>N</td>
              </tr>
              <tr>
                <td>2</td>
                <td>ECU ABS</td>
                <td>N</td>
              </tr>
              <tr>
                <td>3</td>
                <td>All Sensors / Relays</td>
                <td>N</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Battery</td>
                <td>N</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Battery Cut off Switch</td>
                <td>N</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Wiring Harness / Battery Cable (For Mfg. Defect.) </td>
                <td>N</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Lamp (Head /Tail/Roof /Fog) For Mfg. Defect. Bulb not covered Under warranty</td>
                <td>N</td>
              </tr>
              <tr>
                <td>8</td>
                <td>E-Horn (Minda) </td>
                <td>N</td>
              </tr>
              <tr>
                <td>9</td>
                <td>Switches(Regeneration & Other Dash board switches)</td>
                <td>N</td>
              </tr>
              <tr>
                <td>10</td>
                <td>RPAS ( Rear Park Assistance Sensor)</td>
                <td>N</td>
              </tr>
              <tr>
                <td>11</td>
                <td>DCU (5 L)</td>
                <td>N</td>
              </tr>
              <tr>
                <td>12</td>
                <td>VECU</td>
                <td>N</td>
              </tr>
              <tr>
                <td>13</td>
                <td>GDCU</td>
                <td>N</td>
              </tr>
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;"><strong>Exhaust
                System</strong></td>
              </tr>
              <tr>
                <td>1</td>
                <td>After Treatment System assy. (Cummins & 5L) </td>
                <td>N</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Exhaust Flex Pipe </td>
                <td>N</td>
              </tr>
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">
                  <strong>OTHERS</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">Fuel Tank</td>
                <td></td>
              </tr>
              <tr>
                <td>1</td>
                <td>(With AFT ( Anti Fuel Theft Unit / Sensor ) / Fuel Level Sensor )</td>
                <td>N</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Fuel Tank (Metallic)</td>
                <td>N</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Oil Seals</td>
                <td>N</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Wheel Rim (Except overload)</td>
                <td>N</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="mt-4 d-none">
          <h4 class="section-title">Extended Warranty Coverage MCV – TRUCKS</h4>
          <table>
            <thead>
              <tr>
                <th>Sr No.</th>
                <th>Aggregates / Parts</th>
                <th>Coverage</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">ENGINE</td>
              </tr>
              <tr>
                <td>1</td>
                <td>Engine Assembly</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Cylinder Head</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Cylinder Block</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Crankshaft</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Camshaft</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Head Gasket</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Water pump</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>8</td>
                <td>Oil Pump</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>9</td>
                <td>Oil Cooler</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>10</td>
                <td>OIL MIST SEPARATOR ASSY (M/S M&H)</td>
                <td>N</td>
              </tr>
              <tr>
                <td>11</td>
                <td>Flywheel Housing</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>12</td>
                <td>Air Compressor</td>
                <td>N</td>
              </tr>
              <tr>
                <td>13</td>
                <td>Radiator</td>
                <td>N</td>
              </tr>
              <tr>
                <td>14</td>
                <td>Turbocharger</td>
                <td>N</td>
              </tr>
              <tr>
                <td>15</td>
                <td>Starter Motor</td>
                <td>N</td>
              </tr>
              <tr>
                <td>16</td>
                <td>Alternator</td>
                <td>N</td>
              </tr>
              <tr>
                <td>17</td>
                <td>AC Compressor</td>
                <td>N</td>
              </tr>
              <tr>
                <td>18</td>
                <td>AC Condenser</td>
                <td>N</td>
              </tr>
              <tr>
                <td>19</td>
                <td>EGR Cooler</td>
                <td>N</td>
              </tr>
              <tr>
                <td>20</td>
                <td>EGR Valve</td>
                <td>N</td>
              </tr>
              <tr>
                <td>21</td>
                <td>CR Pump (FIP)</td>
                <td>N</td>
              </tr>
              <tr>
                <td>22</td>
                <td>Common Rail, Injectors (SL Engine & Cummins)</td>
                <td>N</td>
              </tr>
              <tr>
                <td>23</td>
                <td>HP Lines</td>
                <td>N</td>
              </tr>
              <tr>
                <td>24</td>
                <td>Front / Rear oil Seal</td>
                <td>N</td>
              </tr>
              <tr>
                <td>25</td>
                <td>Fan Belt</td>
                <td>N</td>
              </tr>
              <tr>
                <td>26</td>
                <td>Viscous Fan</td>
                <td>N</td>
              </tr>
              <tr>
                <td>27</td>
                <td>Engine Mounting</td>
                <td>N</td>
              </tr>
              <tr>
                <td>28</td>
                <td>Intake air throttle valve (IATV)</td>
                <td>N</td>
              </tr>
              <tr>
                <td>29</td>
                <td>Exhaust throttle valve (ETV)</td>
                <td>N</td>
              </tr>
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">CLUTCH</td>
              </tr>
              <tr>
                <td>1</td>
                <td>Flywheel</td>
                <td>N</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Clutch Disk Structure (No warranty on burn cases)</td>
                <td>N</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Pressure Plate</td>
                <td>N</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Clutch Master Cylinder</td>
                <td>N</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Clutch Release Bearing</td>
                <td>N</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Clutch Booster</td>
                <td>N</td>
              </tr>
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">GEAR BOX</td>
              </tr>
              <tr>
                <td>1</td>
                <td>Gear Housing</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Main/Counter Shaft /Gear</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Synchro Ring/cone</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Shifter Shaft</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Shifter/Selector cable</td>
                <td>N</td>
              </tr>
              <tr>
                <td>6</td>
                <td>PTO</td>
                <td>N</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Gear Box All Parts</td>
                <td>Y</td>
              </tr>
              <!-- Propeller Shaft Coverage -->
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">Propeller Shaft</td>
              </tr>
              <tr>
                <td>1</td>
                <td>Propeller Shaft / Inter Axle Shaft</td>
                <td>N</td>
              </tr>
              <tr>
                <td>2</td>
                <td>UI Cross</td>
                <td>N</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Yoke/teeth</td>
                <td>N</td>
              </tr>
              <tr>
                <td>4</td>
                <td>CJ Rubber/Bearing</td>
                <td>N</td>
              </tr>
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">REAR AXLE</td>
              </tr>
              <tr>
                <td>1</td>
                <td>Rear Axle Housing</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Hub</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Axle Shaft</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>4</td>
                <td>CWP</td>
                <td>Y</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Pinion oil Seal</td>
                <td>N</td>
              </tr>
              <!-- Front Axle Coverage -->
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">Front Axle</td>
              </tr>
              <tr>
                <td>1</td>
                <td>Axle Beam</td>
                <td>N</td>
              </tr>
              <tr>
                <td>2</td>
                <td>King Pin</td>
                <td>N</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Tie Rod</td>
                <td>N</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Drag Link / Ball Joint</td>
                <td>N</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Thrust Bearing</td>
                <td>N</td>
              </tr>
              <!-- Truck Hub Unit Coverage -->
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">Truck Hub Unit (THU)
                </td>
              </tr>
              <tr>
                <td>1</td>
                <td>THU Bearing</td>
                <td>N</td>
              </tr>
              <!-- Lift Axle 12.5T Coverage -->
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">Lift Axle 12.5T</td>
              </tr>
              <tr>
                <td>1</td>
                <td>Hanger</td>
                <td>N</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Trailing Arm</td>
                <td>N</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Axle</td>
                <td>N</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Air Bellow</td>
                <td>N</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Rebound Chain</td>
                <td>N</td>
              </tr>
              <!-- Lift Axle 7T Coverage -->
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">Lift Axle 7T</td>
              </tr>
              <tr>
                <td>1</td>
                <td>Structural Parts</td>
                <td>N</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Air Bellow</td>
                <td>N</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Stabilizer</td>
                <td>N</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Rebound strap</td>
                <td>N</td>
              </tr>
              <!-- BRAKE PARTS Coverage -->
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">BRAKE PARTS</td>
              </tr>
              <tr>
                <td>1</td>
                <td>ABS unit</td>
                <td>N</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Brake Drum</td>
                <td>N</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Air Processing Unit</td>
                <td>N</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Pneumatic valve</td>
                <td>N</td>
              </tr>
              <tr>
                <td>5</td>
                <td>S Camshaft</td>
                <td>N</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Brake Shoe</td>
                <td>N</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Torque Plate</td>
                <td>N</td>
              </tr>
              <tr>
                <td>8</td>
                <td>Slack Adjuster</td>
                <td>N</td>
              </tr>
              <tr>
                <td>9</td>
                <td>Brake actuator / chamber</td>
                <td>N</td>
              </tr>
              <tr>
                <td>10</td>
                <td>Hand Brake Valve</td>
                <td>N</td>
              </tr>
              <tr>
                <td>11</td>
                <td>Anti Roll Back Assy (HAS)</td>
                <td>N</td>
              </tr>
              <!-- FRAME Coverage -->
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">FRAME</td>
              </tr>
              <tr>
                <td>1</td>
                <td>Chassis Frame</td>
                <td>N</td>
              </tr>
              <!-- SUSPENSION Coverage -->
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">SUSPENSION</td>
              </tr>
              <tr>
                <td>1</td>
                <td>Leaf Spring / Bogie Spring</td>
                <td>N</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Shock Absorber</td>
                <td>N</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Bogie Bracket</td>
                <td>N</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Bogie Trunnion</td>
                <td>N</td>
              </tr>
              <tr>
                <td>5</td>
                <td>V Rod</td>
                <td>N</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Torque Rod</td>
                <td>N</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Anti Roll Bar</td>
                <td>N</td>
              </tr>
              <tr>
                <td>8</td>
                <td>Suspension Bolster</td>
                <td>N</td>
              </tr>
              <tr>
                <td>9</td>
                <td>Steering Damper</td>
                <td>N</td>
              </tr>
              <tr>
                <td>10</td>
                <td>Lift Axle Control valve</td>
                <td>N</td>
              </tr>
              <tr>
                <td>11</td>
                <td>Levelling valve</td>
                <td>N</td>
              </tr>
              <tr>
                <td>12</td>
                <td>Air Suspension Assembly</td>
                <td>N</td>
              </tr>
              <tr>
                <td>13</td>
                <td>Ultimax Suspension (Tippers)</td>
                <td>N</td>
              </tr>
              <!-- CABIN Coverage -->
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">CABIN</td>
              </tr>
              <tr>
                <td>1</td>
                <td>Cabin</td>
                <td>N</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Music System</td>
                <td>N</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Cabin Suspension</td>
                <td>N</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Instrument Cluster</td>
                <td>N</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Wiper Motor</td>
                <td>N</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Windshield glass (Mfg. defect)</td>
                <td>N</td>
              </tr>
              <tr>
                <td>7</td>
                <td>USB CHARGER 24V 2-PORT</td>
                <td>N</td>
              </tr>
              <tr>
                <td>8</td>
                <td>Window regulator</td>
                <td>N</td>
              </tr>
              <tr>
                <td>9</td>
                <td>Door latch</td>
                <td>N</td>
              </tr>
              <tr>
                <td>10</td>
                <td>Washer Kit</td>
                <td>N</td>
              </tr>
              <tr>
                <td>11</td>
                <td>Telematics Unit</td>
                <td>N</td>
              </tr>
              <!-- STEERING Coverage -->
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">STEERING</td>
              </tr>
              <tr>
                <td>1</td>
                <td>Steering GB</td>
                <td>N</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Steering Column</td>
                <td>N</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Steering pump</td>
                <td>N</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Steering Power Cylinder</td>
                <td>N</td>
              </tr>
              <!-- ELECTRICALS & ELECTRONICS Coverage -->
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">ELECTRICALS &
                ELECTRONICS</td>
              </tr>
              <tr>
                <td>1</td>
                <td>Engine ECU</td>
                <td>N</td>
              </tr>
              <tr>
                <td>2</td>
                <td>ECU ABS</td>
                <td>N</td>
              </tr>
              <tr>
                <td>3</td>
                <td>All Sensors / Relays</td>
                <td>N</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Battery</td>
                <td>N</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Battery Cut off Switch</td>
                <td>N</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Wiring Harness / Battery Cable (For Mfg. Defect.)</td>
                <td>N</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Lamp (Head / Tail/Roof /Fog) For Mfg. Defect. Bulb not covered Under warranty</td>
                <td>N</td>
              </tr>
              <tr>
                <td>8</td>
                <td>E-Horn (Minda)</td>
                <td>N</td>
              </tr>
              <tr>
                <td>9</td>
                <td>Switches (Regeneration & Other Dash board switches)</td>
                <td>N</td>
              </tr>
              <tr>
                <td>10</td>
                <td>RPAS (Rear Park Assistance Sensor)</td>
                <td>N</td>
              </tr>
              <tr>
                <td>11</td>
                <td>DCU (5 L)</td>
                <td>N</td>
              </tr>
              <tr>
                <td>12</td>
                <td>VECU</td>
                <td>N</td>
              </tr>
              <tr>
                <td>13</td>
                <td>GDCU</td>
                <td>N</td>
              </tr>
              <!-- EXHAUST SYSTEM Coverage -->
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">EXHAUST SYSTEM</td>
              </tr>
              <tr>
                <td>1</td>
                <td>After Treatment System assay. (Cummins & 5L)</td>
                <td>N</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Exhaust Flex Pipe</td>
                <td>N</td>
              </tr>
              <!-- LOAD BODY Coverage -->
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">LOAD BODY</td>
              </tr>
              <tr>
                <td>1</td>
                <td>Tipping cylinder/tipping tank</td>
                <td>N</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Load Body (Except abused & Overload)</td>
                <td>N</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Tipper Sub frame</td>
                <td>N</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Paints</td>
                <td>N</td>
              </tr>
              <!-- OTHERS Coverage -->
              <tr>
                <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">OTHERS</td>
              </tr>
              <tr>
                <td>1</td>
                <td>Plastic Fuel Tank With AFT (Anti Fuel Theft Unit) / Fuel Tank (Metallic)</td>
                <td>N</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Fuel Tank (Metallic)</td>
                <td>N</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Oil Seals</td>
                <td>N</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Fifth Wheel Coupling</td>
                <td>N</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Wheel Rim (Except overload)</td>
                <td>N</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Wheel Hub Bearing (Non-THU)</td>
                <td>N</td>
              </tr>
            </tbody>
          </table>
          <!-- <p>This table shows a subset of coverage details.
        The complete list is available in the original document.</p> -->
      </div>
      <div class="mt-4 d-none">
        <h4 class="section-title">Extended Warranty Coverage ILCV – TRUCKS</h4>
        <table>
          <!-- <caption>Extended Warranty - Coverage details</caption> -->
          <thead>
            <tr>
              <th>Sr No.</th>
              <th>Aggregates / Parts</th>
              <th>Extended warranty (Driveline)</th>
            </tr>
          </thead>
          <tbody>
            <!-- Engine Coverage -->
            <tr>
              <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">Engine</td>
            </tr>
            <tr>
              <td>1</td>
              <td>Engine Assembly</td>
              <td>Y</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Cylinder Head</td>
              <td>Y</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Cylinder Block</td>
              <td>Y</td>
            </tr>
            <tr>
              <td>4</td>
              <td>Crankshaft</td>
              <td>Y</td>
            </tr>
            <tr>
              <td>5</td>
              <td>Camshaft</td>
              <td>Y</td>
            </tr>
            <tr>
              <td>6</td>
              <td>Head Gasket</td>
              <td>Y</td>
            </tr>
            <tr>
              <td>7</td>
              <td>Water pump</td>
              <td>Y</td>
            </tr>
            <tr>
              <td>8</td>
              <td>Oil Pump</td>
              <td>Y</td>
            </tr>
            <tr>
              <td>9</td>
              <td>Oil Cooler</td>
              <td>Y</td>
            </tr>
            <tr>
              <td>10</td>
              <td>OIL MIST SEPARATOR ASSY (M/S M&H)</td>
              <td>N</td>
            </tr>
            <tr>
              <td>11</td>
              <td>Flywheel Housing</td>
              <td>Y</td>
            </tr>
            <tr>
              <td>12</td>
              <td>Air Compressor</td>
              <td>N</td>
            </tr>
            <tr>
              <td>13</td>
              <td>Radiator</td>
              <td>N</td>
            </tr>
            <tr>
              <td>14</td>
              <td>Turbocharger</td>
              <td>N</td>
            </tr>
            <tr>
              <td>15</td>
              <td>Starter Motor</td>
              <td>N</td>
            </tr>
            <tr>
              <td>16</td>
              <td>Alternator</td>
              <td>N</td>
            </tr>
            <tr>
              <td>17</td>
              <td>AC Compressor</td>
              <td>N</td>
            </tr>
            <tr>
              <td>18</td>
              <td>AC Condenser</td>
              <td>N</td>
            </tr>
            <tr>
              <td>19</td>
              <td>EGR Cooler</td>
              <td>N</td>
            </tr>
            <tr>
              <td>20</td>
              <td>EGR Valve</td>
              <td>N</td>
            </tr>
            <tr>
              <td>21</td>
              <td>CR Pump (FIP)</td>
              <td>N</td>
            </tr>
            <tr>
              <td>22</td>
              <td>Common Rail, Injectors (SL Engine & Cummins)</td>
              <td>N</td>
            </tr>
            <tr>
              <td>23</td>
              <td>HP Lines</td>
              <td>N</td>
            </tr>
            <tr>
              <td>24</td>
              <td>Front / Rear oil Seal</td>
              <td>N</td>
            </tr>
            <tr>
              <td>25</td>
              <td>Fan Belt</td>
              <td>N</td>
            </tr>
            <tr>
              <td>26</td>
              <td>Viscous Fan</td>
              <td>N</td>
            </tr>
            <tr>
              <td>27</td>
              <td>Engine Mounting</td>
              <td>N</td>
            </tr>
            <tr>
              <td>28</td>
              <td>Intake air throttle valve (IATV)</td>
              <td>N</td>
            </tr>
            <tr>
              <td>29</td>
              <td>Exhaust throttle valve (ETV)</td>
              <td>N</td>
            </tr>
            <!-- Clutch Coverage -->
            <tr>
              <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">Clutch</td>
            </tr>
            <tr>
              <td>1</td>
              <td>Flywheel</td>
              <td>N</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Clutch Disk Structure (No warranty on burn cases)</td>
              <td>N</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Pressure Plate</td>
              <td>N</td>
            </tr>
            <tr>
              <td>4</td>
              <td>Clutch Master Cylinder</td>
              <td>N</td>
            </tr>
            <tr>
              <td>5</td>
              <td>Clutch Release Bearing</td>
              <td>N</td>
            </tr>
            <tr>
              <td>6</td>
              <td>Clutch Booster</td>
              <td>N</td>
            </tr>
            <!-- Gear Box Coverage -->
            <tr>
              <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">Gear Box</td>
            </tr>
            <tr>
              <td>1</td>
              <td>Gear Housing</td>
              <td>Y</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Main/Counter Shaft /Gear</td>
              <td>Y</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Synchro Ring/cone</td>
              <td>Y</td>
            </tr>
            <tr>
              <td>4</td>
              <td>Shifter Shaft</td>
              <td>Y</td>
            </tr>
            <tr>
              <td>5</td>
              <td>Shifter/Selector cable</td>
              <td>N</td>
            </tr>
            <tr>
              <td>6</td>
              <td>PTO</td>
              <td>N</td>
            </tr>
            <tr>
              <td>7</td>
              <td>Gear Box All Parts</td>
              <td>Y</td>
            </tr>
            <!-- Propeller Shaft Coverage -->
            <tr>
              <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">Propeller Shaft</td>
            </tr>
            <tr>
              <td>1</td>
              <td>Propeller Shaft / Inter Axle Shaft</td>
              <td>N</td>
            </tr>
            <tr>
              <td>2</td>
              <td>UI Cross</td>
              <td>N</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Yoke/teeth</td>
              <td>N</td>
            </tr>
            <tr>
              <td>4</td>
              <td>CJ Rubber/Bearing</td>
              <td>N</td>
            </tr>
            <!-- Rear Axle Coverage -->
            <tr>
              <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">Rear Axle</td>
            </tr>
            <tr>
              <td>1</td>
              <td>Rear Axle Housing</td>
              <td>Y</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Hub</td>
              <td>Y</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Axle Shaft</td>
              <td>Y</td>
            </tr>
            <tr>
              <td>4</td>
              <td>CWP</td>
              <td>Y</td>
            </tr>
            <tr>
              <td>5</td>
              <td>Pinion oil Seal</td>
              <td>N</td>
            </tr>
            <!-- Front Axle Coverage -->
            <tr>
              <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">Front Axle</td>
            </tr>
            <tr>
              <td>1</td>
              <td>Axle Beam</td>
              <td>N</td>
            </tr>
            <tr>
              <td>2</td>
              <td>King Pin</td>
              <td>N</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Tie Rod</td>
              <td>N</td>
            </tr>
            <tr>
              <td>4</td>
              <td>Drag Link / Ball Joint</td>
              <td>N</td>
            </tr>
            <tr>
              <td>5</td>
              <td>Thrust Bearing</td>
              <td>N</td>
            </tr>
            <!-- Truck Hub Unit Coverage -->
            <tr>
              <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">Truck Hub Unit (THU)
              </td>
            </tr>
            <tr>
              <td>1</td>
              <td>THU Bearing</td>
              <td>N</td>
            </tr>
            <!-- Lift Axle 12.5T Coverage -->
            <tr>
              <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">Lift Axle 12.5T</td>
            </tr>
            <tr>
              <td>1</td>
              <td>Hanger</td>
              <td>N</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Trailing Arm</td>
              <td>N</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Axle</td>
              <td>N</td>
            </tr>
            <tr>
              <td>4</td>
              <td>Air Bellow</td>
              <td>N</td>
            </tr>
            <tr>
              <td>5</td>
              <td>Rebound Chain</td>
              <td>N</td>
            </tr>
            <!-- Lift Axle 7T Coverage -->
            <tr>
              <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">Lift Axle 7T</td>
            </tr>
            <tr>
              <td>1</td>
              <td>Structural Parts</td>
              <td>N</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Air Bellow</td>
              <td>N</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Stabilizer</td>
              <td>N</td>
            </tr>
            <tr>
              <td>4</td>
              <td>Rebound strap</td>
              <td>N</td>
            </tr>
            <!-- BRAKE PARTS Coverage -->
            <tr>
              <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">BRAKE PARTS</td>
            </tr>
            <tr>
              <td>1</td>
              <td>ABS unit</td>
              <td>N</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Brake Drum</td>
              <td>N</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Air Processing Unit</td>
              <td>N</td>
            </tr>
            <tr>
              <td>4</td>
              <td>Pneumatic valve</td>
              <td>N</td>
            </tr>
            <tr>
              <td>5</td>
              <td>S Camshaft</td>
              <td>N</td>
            </tr>
            <tr>
              <td>6</td>
              <td>Brake Shoe</td>
              <td>N</td>
            </tr>
            <tr>
              <td>7</td>
              <td>Torque Plate</td>
              <td>N</td>
            </tr>
            <tr>
              <td>8</td>
              <td>Slack Adjuster</td>
              <td>N</td>
            </tr>
            <tr>
              <td>9</td>
              <td>Brake actuator / chamber</td>
              <td>N</td>
            </tr>
            <tr>
              <td>10</td>
              <td>Hand Brake Valve</td>
              <td>N</td>
            </tr>
            <tr>
              <td>11</td>
              <td>Anti Roll Back Assy (HAS)</td>
              <td>N</td>
            </tr>
            <!-- FRAME Coverage -->
            <tr>
              <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">FRAME</td>
            </tr>
            <tr>
              <td>1</td>
              <td>Chassis Frame</td>
              <td>N</td>
            </tr>
            <!-- SUSPENSION Coverage -->
            <tr>
              <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">SUSPENSION</td>
            </tr>
            <tr>
              <td>1</td>
              <td>Leaf Spring / Bogie Spring</td>
              <td>N</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Shock Absorber</td>
              <td>N</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Bogie Bracket</td>
              <td>N</td>
            </tr>
            <tr>
              <td>4</td>
              <td>Bogie Trunnion</td>
              <td>N</td>
            </tr>
            <tr>
              <td>5</td>
              <td>V Rod</td>
              <td>N</td>
            </tr>
            <tr>
              <td>6</td>
              <td>Torque Rod</td>
              <td>N</td>
            </tr>
            <tr>
              <td>7</td>
              <td>Anti Roll Bar</td>
              <td>N</td>
            </tr>
            <tr>
              <td>8</td>
              <td>Suspension Bolster</td>
              <td>N</td>
            </tr>
            <tr>
              <td>9</td>
              <td>Steering Damper</td>
              <td>N</td>
            </tr>
            <tr>
              <td>10</td>
              <td>Lift Axle Control valve</td>
              <td>N</td>
            </tr>
            <tr>
              <td>11</td>
              <td>Levelling valve</td>
              <td>N</td>
            </tr>
            <tr>
              <td>12</td>
              <td>Air Suspension Assembly</td>
              <td>N</td>
            </tr>
            <tr>
              <td>13</td>
              <td>Ultimax Suspension (Tippers)</td>
              <td>N</td>
            </tr>
            <!-- CABIN Coverage -->
            <tr>
              <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">CABIN</td>
            </tr>
            <tr>
              <td>1</td>
              <td>Cabin</td>
              <td>N</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Music System</td>
              <td>N</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Cabin Suspension</td>
              <td>N</td>
            </tr>
            <tr>
              <td>4</td>
              <td>Instrument Cluster</td>
              <td>N</td>
            </tr>
            <tr>
              <td>5</td>
              <td>Wiper Motor</td>
              <td>N</td>
            </tr>
            <tr>
              <td>6</td>
              <td>Windshield glass (Mfg. defect)</td>
              <td>N</td>
            </tr>
            <tr>
              <td>7</td>
              <td>USB CHARGER 24V 2-PORT</td>
              <td>N</td>
            </tr>
            <tr>
              <td>8</td>
              <td>Window regulator</td>
              <td>N</td>
            </tr>
            <tr>
              <td>9</td>
              <td>Door latch</td>
              <td>N</td>
            </tr>
            <tr>
              <td>10</td>
              <td>Washer Kit</td>
              <td>N</td>
            </tr>
            <tr>
              <td>11</td>
              <td>Telematics Unit</td>
              <td>N</td>
            </tr>
            <!-- STEERING Coverage -->
            <tr>
              <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">STEERING</td>
            </tr>
            <tr>
              <td>1</td>
              <td>Steering GB</td>
              <td>N</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Steering Column</td>
              <td>N</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Steering pump</td>
              <td>N</td>
            </tr>
            <tr>
              <td>4</td>
              <td>Steering Power Cylinder</td>
              <td>N</td>
            </tr>
            <!-- ELECTRICALS & ELECTRONICS Coverage -->
            <tr>
              <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">ELECTRICALS &
              ELECTRONICS</td>
            </tr>
            <tr>
              <td>1</td>
              <td>Engine ECU</td>
              <td>N</td>
            </tr>
            <tr>
              <td>2</td>
              <td>ECU ABS</td>
              <td>N</td>
            </tr>
            <tr>
              <td>3</td>
              <td>All Sensors / Relays</td>
              <td>N</td>
            </tr>
            <tr>
              <td>4</td>
              <td>Battery</td>
              <td>N</td>
            </tr>
            <tr>
              <td>5</td>
              <td>Battery Cut off Switch</td>
              <td>N</td>
            </tr>
            <tr>
              <td>6</td>
              <td>Wiring Harness / Battery Cable (For Mfg. Defect.)</td>
              <td>N</td>
            </tr>
            <tr>
              <td>7</td>
              <td>Lamp (Head / Tail/Roof /Fog) For Mfg. Defect. Bulb not covered Under warranty</td>
              <td>N</td>
            </tr>
            <tr>
              <td>8</td>
              <td>E-Horn (Minda)</td>
              <td>N</td>
            </tr>
            <tr>
              <td>9</td>
              <td>Switches (Regeneration & Other Dash board switches)</td>
              <td>N</td>
            </tr>
            <tr>
              <td>10</td>
              <td>RPAS (Rear Park Assistance Sensor)</td>
              <td>N</td>
            </tr>
            <tr>
              <td>11</td>
              <td>DCU (5 L)</td>
              <td>N</td>
            </tr>
            <tr>
              <td>12</td>
              <td>VECU</td>
              <td>N</td>
            </tr>
            <tr>
              <td>13</td>
              <td>GDCU</td>
              <td>N</td>
            </tr>
            <!-- EXHAUST SYSTEM Coverage -->
            <tr>
              <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">EXHAUST SYSTEM</td>
            </tr>
            <tr>
              <td>1</td>
              <td>After Treatment System assay. (Cummins & 5L)</td>
              <td>N</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Exhaust Flex Pipe</td>
              <td>N</td>
            </tr>
            <!-- LOAD BODY Coverage -->
            <tr>
              <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">LOAD BODY</td>
            </tr>
            <tr>
              <td>1</td>
              <td>Tipping cylinder/tipping tank</td>
              <td>N</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Load Body (Except abused & Overload)</td>
              <td>N</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Tipper Sub frame</td>
              <td>N</td>
            </tr>
            <tr>
              <td>4</td>
              <td>Paints</td>
              <td>N</td>
            </tr>
            <!-- OTHERS Coverage -->
            <tr>
              <td colspan="3" style="background-color: #e9ecef; font-weight: bold;">OTHERS</td>
            </tr>
            <tr>
              <td>1</td>
              <td>Plastic Fuel Tank With AFT (Anti Fuel Theft Unit) / Fuel Tank (Metallic)</td>
              <td>N</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Fuel Tank (Metallic)</td>
              <td>N</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Oil Seals</td>
              <td>N</td>
            </tr>
            <tr>
              <td>4</td>
              <td>Fifth Wheel Coupling</td>
              <td>N</td>
            </tr>
            <tr>
              <td>5</td>
              <td>Wheel Rim (Except overload)</td>
              <td>N</td>
            </tr>
            <tr>
              <td>6</td>
              <td>Wheel Hub Bearing (Non-THU)</td>
              <td>N</td>
            </tr>
            <tr>
              <td colspan="3" class="left-align">
                <strong>Legend = N : Not Covered, Y : Covered</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2" style="width:50%; text-align:left;">
                # This document is valid till further communication.
              </td>
              <td colspan="2" style="width:50%; text-align:left;">
                TML / CV / FleetCare / VAS / Rev. 02 / Date 01.09.2026
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  }
  @if (cifDetails?.amc_details?.service_product_type === 'OSS') {
    <div class="mt-4">
      <h4 class="infotitle text-align-center mb-4" style="text-align: center;">Annexure 2 </h4>
      <h4>Services to be provided to the Customer/You basis the type of OSS
      opted</h4>
      <div class="row mb-4">
        <div class="col-md-12">
          <p><strong>Y:</strong> Signifies inclusions/available services in the OSS type
        opted by the Customer</p>
        <p><strong>N:</strong> Signifies exclusions/services not available in the OSS
      type opted by the Customer</p>
    </div>
  </div>
  <div class="mb-5">
    <table>
      <thead>
        <tr>
          <th>S.N</th>
          <th>Description</th>
          <th>Condition applicable</th>
          <th>Scope</th>
          <th>OSS Standard</th>
          <th>OSS Suraksha Pack-1 (Supervisory)</th>
          <th>OSS Suraksha Pack-2 (Supervisor + Technician)</th>
          <th>OSS Suraksha pack-3 (Supervisor + Technician + tools)</th>
          <th>OSS Suraksha Pack-4 (Supervisor + Technician + tools+parts)</th>
          <th>OSS Suraksha Pack-5 (Supervisor + Technician + tools+parts+container)</th>
        </tr>
      </thead>
      <tbody>
        <tr class="section-title">
          <td colspan="10">Scope of Service/ Infrastructure deployed</td>
        </tr>
        <tr>
          <td>1</td>
          <td>Container</td>
          <td>Available only if opted by the Customer upon payment of applicable usage charges.</td>
          <td>TMCVL/ WS</td>
          <td>Y</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>Y</td>
        </tr>
        <tr>
          <td>2</td>
          <td>Required Tools & Equipments</td>
          <td>Standard Tool List shall be made available. Cost towards additional tools shall be
          charged extra.</td>
          <td>TMCVL/ WS</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
        </tr>
        <tr>
          <td>3</td>
          <td>Laptop & Diagnostics</td>
          <td>As per the applicable policy</td>
          <td>TMCVL/ WS</td>
          <td>Y</td>
          <td>N</td>
          <td>N</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
        </tr>
        <tr>
          <td>4</td>
          <td>Parts stocking</td>
          <td>Inventory worth Rs.15 Lacs shall be available, unless agreed otherwise.</td>
          <td>Yes</td>
          <td>Y</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>Y</td>
          <td>Y</td>
        </tr>
        <tr class="section-title">
          <td colspan="10">Manpower deployed</td>
        </tr>
        <tr>
          <td>1</td>
          <td>Supervisor</td>
          <td>As per the applicable policy</td>
          <td>TMCVL/ WS</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
        </tr>
        <tr>
          <td>2</td>
          <td>Sr. Mechanic</td>
          <td>As per the applicable policy</td>
          <td>TMCVL/ WS</td>
          <td>N</td>
          <td>N</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
        </tr>
        <tr>
          <td>3</td>
          <td>Electrician</td>
          <td>As per the applicable policy</td>
          <td>TMCVL/ WS</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>Y</td>
          <td>Y</td>
        </tr>
        <tr>
          <td>4</td>
          <td>Helper</td>
          <td>As per the applicable policy</td>
          <td>TMCVL/ WS</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>Y</td>
          <td>Y</td>
        </tr>
        <tr class="section-title">
          <td colspan="10">Work scope by Manpower deputed</td>
        </tr>
        <tr>
          <td>1</td>
          <td>Shift wise availability of the manpower at Customer's Site</td>
          <td>As per the details in table (Manpower) attached</td>
          <td>TMCVL/ WS</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
        </tr>
        <tr>
          <td>2</td>
          <td>Scheduled & Preventive maintenance Planning</td>
          <td>As per the policy applicable on vehicle model</td>
          <td>TMCVL/ WS</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
        </tr>
        <tr>
          <td>3</td>
          <td>Major/ Minor repairs of aggregate</td>
          <td>As per the applicable policy</td>
          <td>TMCVL/ WS</td>
          <td>N</td>
          <td>N</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
        </tr>
        <tr>
          <td>4</td>
          <td>Monthly once inspection, Greasing & Torqueing</td>
          <td>As per the applicable policy</td>
          <td>TMCVL/ WS</td>
          <td>Y</td>
          <td>N</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
        </tr>
        <tr>
          <td>5</td>
          <td>Spare parts Planning</td>
          <td>As per the applicable policy</td>
          <td>TMCVL/ WS</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
        </tr>
        <tr class="section-title">
          <td colspan="10">Work not in scope by Manpower deputed</td>
        </tr>
        <tr>
          <td>1</td>
          <td>Accident repair (Major/Minor)</td>
          <td>As per the applicable policy</td>
          <td>Customer</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
        </tr>
        <tr>
          <td>2</td>
          <td>Painting jobs</td>
          <td>As per the applicable policy</td>
          <td>Customer</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
        </tr>
        <tr>
          <td>3</td>
          <td>Body & Cabin Repair jobs</td>
          <td>As per the applicable policy</td>
          <td>Customer</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
        </tr>
        <tr>
          <td>4</td>
          <td>Suspension related jobs</td>
          <td>As per the applicable policy</td>
          <td>Customer</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
        </tr>
        <tr>
          <td>5</td>
          <td>Wheel Alignment, Tyre Repairs & Replacement jobs</td>
          <td>As per the applicable policy</td>
          <td>Customer</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
        </tr>
        <tr>
          <td>6</td>
          <td>Washing & Greasing of vehicles</td>
          <td>As per the applicable policy</td>
          <td>Customer</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
        </tr>
        <tr>
          <td>7</td>
          <td>Any welding jobs</td>
          <td>As per the applicable policy</td>
          <td>Customer</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
        </tr>
        <tr>
          <td>8</td>
          <td>Any such jobs that cannot be executed at site-workshop due to inadequate
          infrastructure, manpower etc</td>
          <td>As per the applicable policy</td>
          <td>Customer</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
        </tr>
      </tbody>
    </table>
  </div>
  <h3><strong>Facilities to be provided by Customer/You at the Site</strong></h3>
  <div>
    <table>
      <thead>
        <tr>
          <th>S.N</th>
          <th>Description</th>
          <th>Requirement criteria</th>
          <th>Scope</th>
          <th>OSS Standard</th>
          <th>OSS Suraksha Pack-1 (Supervisory)</th>
          <th>OSS Suraksha Pack-2 (Supervisor + Technician)</th>
          <th>OSS Suraksha pack-3 (Supervisor + Technician + tools)</th>
          <th>OSS Suraksha Pack-4 (Supervisor + Technician + tools+parts)</th>
          <th>OSS Suraksha Pack-5 (Supervisor + Technician + tools+parts+container)</th>
        </tr>
      </thead>
      <tbody>
        <tr class="section-title">
          <td colspan="10">Customer Scope :-Basic amenities and other infrastructural/safety
          facilities</td>
        </tr>
        <tr>
          <td>1</td>
          <td>Working bays with concrete flooring & shed</td>
          <td>Min. 2 bays</td>
          <td>Customer</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
        </tr>
        <tr>
          <td>2</td>
          <td>Place to establish container</td>
          <td>Compulsory (If opted by Customer)</td>
          <td>Customer</td>
          <td>Y</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>N</td>
          <td>Y</td>
        </tr>
        <tr>
          <td>3</td>
          <td>Washing bay with ramp</td>
          <td>Compulsory</td>
          <td>Customer</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
        </tr>
        <tr>
          <td>4</td>
          <td>Compressor with pneumatic connections</td>
          <td>Min.1 compressor</td>
          <td>Customer</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
        </tr>
        <tr>
          <td>5</td>
          <td>Electricity (24 x 7)</td>
          <td>Compulsory</td>
          <td>Customer</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
        </tr>
        <tr>
          <td>6</td>
          <td>Water supply (24 x 7)</td>
          <td>Compulsory</td>
          <td>Customer</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
        </tr>
        <tr>
          <td>7</td>
          <td>Spares room with racks</td>
          <td>Min. 1 room</td>
          <td>Customer</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
        </tr>
        <tr>
          <td>8</td>
          <td>ATM Van/ Bike for attending breakdown</td>
          <td>Complusory</td>
          <td>Customer</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
        </tr>
        <tr>
          <td>9</td>
          <td>Lodging & Boarding</td>
          <td>Complusory</td>
          <td>Customer</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
        </tr>
        <tr>
          <td>10</td>
          <td>Wheel alignment machine with tyre changer</td>
          <td>Complusory</td>
          <td>Customer</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
        </tr>
        <tr>
          <td>11</td>
          <td>Vehicle to be in washed condition for monthly activity and as per requirement of
          repair work</td>
          <td>Complusory</td>
          <td>Customer</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
        </tr>
        <tr>
          <td>12</td>
          <td>Additional helpers required if repair works involves heavy jobs</td>
          <td>Complusory</td>
          <td>Customer</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
        </tr>
        <tr>
          <td>13</td>
          <td>Ensuring safety arrangement at the workspace (e.g. Boundary, First aid kit,
          availability or arrangement of mobility in case of any casualty)</td>
          <td>Complusory</td>
          <td>Customer</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
        </tr>
        <tr>
          <td>14</td>
          <td>All required statutory/ government permissions</td>
          <td>Complusory</td>
          <td>Customer</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
          <td>Y</td>
        </tr>
      </tbody>
    </table>
  </div>
  <br />
  <table>
    <thead>
      <tr>
        <th colspan="7"
          style="text-align: center; font-weight: bold; font-size: 16px; padding: 10px;">Manpower
        </th>
      </tr>
      <tr>
        <td class="left-align" colspan="7"
          style="padding: 10px; line-height: 1.5; background-color: white;">
          *The labor shall be provided on shift basis as per the details agreed below.<br>
          *Each shift shall be for a maximum period of 8 hours<br>
          *The start of the shift may be decided by the Customer in mutual discussion with Tata
          Motors<br>
          * Weekly offs/holidays shall be provided by the Customer to the manpower as per the
          applicable laws
        </td>
      </tr>
      <tr style="text-align: center; font-weight: bold; background-color: #f2f2f2;">
        <th>Sr. No</th>
        <th style="width: 35%;">DESCRIPTION</th>
        <th style="width: 12%;">A' Shift</th>
        <th style="width: 12%;">B' Shift</th>
        <th style="width: 12%;">C' Shift</th>
        <th style="width: 12%;">General Shift</th>
        <th style="width: 12%;">TOTAL MANPOWER</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style="text-align: center;">1</td>
        <td>Supervisor</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td style="text-align: center;">2</td>
        <td>Sr . Mechanic</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td style="text-align: center;">3</td>
        <td>Asst. Mechanic</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td style="text-align: center;">4</td>
        <td>Helper</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td style="text-align: center;">5</td>
        <td>Electrician</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
    </tbody>
  </table>
</div>
}
<!-- New code End-->
<h4 class="mt-4">CONTACT DETAILS:</h4>
<p>
  If you have queries, concerns, comments or feedback
  regarding the any of these Suraksha schemes or the
  Services, then you may contact TMCVL at:
</p>
<address>
  <h5><strong>Tata Motors Commercial Vehicles Limited</strong></h5>
  <p>4th Floor, CVBU,<br>
    Ahura Centre 82, Mahakali Caves Road,<br>
    Shanti Nagar, MIDC, Andheri (East), Mumbai,<br>
  Maharashtra, India - 400093</p>
  <p><strong>Telephone:</strong> +91 (22) 67927272</p>
  <p><strong>Toll-free No.:</strong> 1800 258 2589</p>
  <p><strong>Email id:</strong><a
href="mailto:FleetCaresupport@tatamotors.com">FleetCaresupport&#64;tatamotors.com</a></p>
</address>
<!-- Declaration Section -->
<p>
  <input type="checkbox" id="termsAgree" name="termsAgree" [(ngModel)]="termsAgree" />
  <label for="termsAgree">
    I/We have been explained the terms and conditions of
    the <span
  style="font-weight:bold;color: #000;">{{cifDetails?.amc_details?.service_product_type}}</span>
  by the dealer's representative and I/we agree
  to abide by the same.
</label>
</p>
<p>
  <input type="checkbox" id="authorize" name="authorize" [(ngModel)]="authorize" />
  <label for="authorize">
    I/We hereby confirm and authorize Tata Motors Commercial Vehicles Limited
    to collect and use the data/information provided by
    me/ or collected as part of / ancillary to providing
    the <span
  style="font-weight:bold;color: #000;">{{cifDetails?.amc_details?.service_product_type}}</span>
  services in accordance with the terms and
  conditions hereof. I/We hereby authorize Tata Motors Commercial Vehicles
  Limited to use the information for any purpose
  including for sharing the information with its
  dealer/affiliates or third parties as maybe necessary.
  In the event I wish to withdraw my consent I shall
  inform Tata Motors Commercial Vehicles Limited in accordance with the
  notification process specified in the terms and
  conditions.
</label>
</p>
</div>
<!-- Button will be disabled initially    class="btn btn-disable btn-t01 p-2 me-n1"-->
<div class="row d-flex justify-content-center mt-4" style="margin-left: 1rem">
  <button class="btn-t01 btn-navy mt-0 col-md-2" type="button" id="sourceVisits"
    [disabled]="!termsAgree || !authorize" (click)="onSubmitCIF(rejectPopup)">
    I Agree
  </button>
</div>
<!-- Display the timer countdown only when the button is disabled -->
@if (isDisabled) {
  <span>Retry in {{ timeLeft }} seconds</span>
}
</div>
</div>
</div>
}
@if (showTokenExpiryDiv) {
  <div class="row mb-5">
    <div class="col-12 col-md-12">
      <h4 class="infotitles error-message" style="padding-left: 50px;">Token Expired</h4>
    </div>
  </div>
}
</div>
}

</div>

</div>
</div>
</div>
</div>
<ng-template #rejectPopup let-modal>
  <div class="upload_container popup_width">
    <div class="confirm-popup modal-body">
      <div class="confirm-text delete-title"> Are you sure you want to submit?</div>
      <div class="confirm-box">
        <button (click)="modal.dismiss('Cross click')" class="btn btn-t01 create-btn p-2 me-n1 w-100">
          Cancel
        </button>
        <button (click)="confirmAction()" class="btn btn-t01 btn-navy p-2 w-100 ml-3">
          Okay
        </button>
      </div>
    </div>
  </div>
</ng-template>